(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.aV.ap === region.a1.ap)
	{
		return 'on line ' + region.aV.ap;
	}
	return 'on lines ' + region.aV.ap + ' through ' + region.a1.ap;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList === 'function' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.bQ,
		impl.ch,
		impl.cd,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		aq: func(record.aq),
		aW: record.aW,
		aT: record.aT
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.aq;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.aW;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.aT) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.bQ,
		impl.ch,
		impl.cd,
		function(sendToApp, initialModel) {
			var view = impl.ci;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.bQ,
		impl.ch,
		impl.cd,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.aU && impl.aU(sendToApp)
			var view = impl.ci;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.ay);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.cf) && (_VirtualDom_doc.title = title = doc.cf);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.b_;
	var onUrlRequest = impl.b$;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		aU: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.bh === next.bh
							&& curr.a7 === next.a7
							&& curr.bd.a === next.bd.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		bQ: function(flags)
		{
			return A3(impl.bQ, flags, _Browser_getUrl(), key);
		},
		ci: impl.ci,
		ch: impl.ch,
		cd: impl.cd
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { bN: 'hidden', bD: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { bN: 'mozHidden', bD: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { bN: 'msHidden', bD: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { bN: 'webkitHidden', bD: 'webkitvisibilitychange' }
		: { bN: 'hidden', bD: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		bn: _Browser_getScene(),
		bt: {
			bv: _Browser_window.pageXOffset,
			bw: _Browser_window.pageYOffset,
			bu: _Browser_doc.documentElement.clientWidth,
			a6: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		bu: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		a6: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			bn: {
				bu: node.scrollWidth,
				a6: node.scrollHeight
			},
			bt: {
				bv: node.scrollLeft,
				bw: node.scrollTop,
				bu: node.clientWidth,
				a6: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			bn: _Browser_getScene(),
			bt: {
				bv: x,
				bw: y,
				bu: _Browser_doc.documentElement.clientWidth,
				a6: _Browser_doc.documentElement.clientHeight
			},
			bJ: {
				bv: x + rect.left,
				bw: y + rect.top,
				bu: rect.width,
				a6: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.bW) { flags += 'm'; }
	if (options.bC) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.a3.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.a3.b, xhr)); });
		$elm$core$Maybe$isJust(request.cg) && _Http_track(router, xhr, request.cg.a);

		try {
			xhr.open(request.bU, request.bs, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.bs));
		}

		_Http_configureRequest(xhr, request);

		request.ay.a && xhr.setRequestHeader('Content-Type', request.ay.a);
		xhr.send(request.ay.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.bM; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.ce.a || 0;
	xhr.responseType = request.a3.d;
	xhr.withCredentials = request.by;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		bs: xhr.responseURL,
		ca: xhr.status,
		cb: xhr.statusText,
		bM: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			b6: event.loaded,
			bo: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			b3: event.loaded,
			bo: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $author$project$Model$UrlChange = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$UrlRequest = function (a) {
	return {$: 0, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.b) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.d),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.d);
		} else {
			var treeLen = builder.b * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.e) : builder.e;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.b);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.d) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.d);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{e: nodeList, b: (len / $elm$core$Array$branchFactor) | 0, d: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {a4: fragment, a7: host, bb: path, bd: port_, bh: protocol, bi: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Model$FromInitialize = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$FromUnlock = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Initialize = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Unlock = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Session$Storage = F2(
	function (accounts, selectedAccount) {
		return {i: accounts, t: selectedAccount};
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $author$project$Session$Account = F3(
	function (name, address, keystore) {
		return {aF: address, W: keystore, p: name};
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$EthereumAddress$EthereumAddress = $elm$core$Basics$identity;
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $elm_community$result_extra$Result$Extra$combine = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $prozacchiwawa$elm_keccak$Keccak$KC = $elm$core$Basics$identity;
var $prozacchiwawa$elm_keccak$Keccak$ethereum_keccak_256 = {H: 512, C: 1, E: 32, x: 1088};
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$bytes$Bytes$Encode$Bytes = function (a) {
	return {$: 10, a: a};
};
var $elm$bytes$Bytes$Encode$bytes = $elm$bytes$Bytes$Encode$Bytes;
var $elm$bytes$Bytes$Encode$Seq = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$getWidths = F2(
	function (width, builders) {
		getWidths:
		while (true) {
			if (!builders.b) {
				return width;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
					$temp$builders = bs;
				width = $temp$width;
				builders = $temp$builders;
				continue getWidths;
			}
		}
	});
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return A2(
		$elm$bytes$Bytes$Encode$Seq,
		A2($elm$bytes$Bytes$Encode$getWidths, 0, builders),
		builders);
};
var $prozacchiwawa$elm_keccak$Keccak$concatBytesList = function (newPartial) {
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			A2(
				$elm$core$List$map,
				$elm$bytes$Bytes$Encode$bytes,
				$elm$core$List$reverse(newPartial))));
};
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Decode$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$Decode$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$map = F2(
	function (func, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var aOffset = _v1.a;
				var a = _v1.b;
				return _Utils_Tuple2(
					aOffset,
					func(a));
			});
	});
var $elm$bytes$Bytes$Decode$succeed = function (a) {
	return F2(
		function (_v0, offset) {
			return _Utils_Tuple2(offset, a);
		});
};
var $prozacchiwawa$elm_keccak$Keccak$listStep = F2(
	function (decoder, _v0) {
		var n = _v0.a;
		var xs = _v0.b;
		return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(
				$elm$core$List$reverse(xs))) : A2(
			$elm$bytes$Bytes$Decode$map,
			function (x) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(
						n - 1,
						A2($elm$core$List$cons, x, xs)));
			},
			decoder);
	});
var $elm$bytes$Bytes$Decode$loopHelp = F4(
	function (state, callback, bites, offset) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var decoder = _v0;
			var _v1 = A2(decoder, bites, offset);
			var newOffset = _v1.a;
			var step = _v1.b;
			if (!step.$) {
				var newState = step.a;
				var $temp$state = newState,
					$temp$callback = callback,
					$temp$bites = bites,
					$temp$offset = newOffset;
				state = $temp$state;
				callback = $temp$callback;
				bites = $temp$bites;
				offset = $temp$offset;
				continue loopHelp;
			} else {
				var result = step.a;
				return _Utils_Tuple2(newOffset, result);
			}
		}
	});
var $elm$bytes$Bytes$Decode$loop = F2(
	function (state, callback) {
		return A2($elm$bytes$Bytes$Decode$loopHelp, state, callback);
	});
var $elm$bytes$Bytes$Decode$unsignedInt8 = _Bytes_read_u8;
var $elm$bytes$Bytes$width = _Bytes_width;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $prozacchiwawa$elm_keccak$Keccak$intListOfBytes = function (b) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$bytes$Bytes$Decode$decode,
			A2(
				$elm$bytes$Bytes$Decode$loop,
				_Utils_Tuple2(
					$elm$bytes$Bytes$width(b),
					_List_Nil),
				$prozacchiwawa$elm_keccak$Keccak$listStep($elm$bytes$Bytes$Decode$unsignedInt8)),
			b));
};
var $prozacchiwawa$elm_keccak$Keccak$tupleMap2 = F3(
	function (f, _v0, _v1) {
		var a1 = _v0.a;
		var b1 = _v0.b;
		var a2 = _v1.a;
		var b2 = _v1.b;
		return _Utils_Tuple2(
			A2(f, a1, a2),
			A2(f, b1, b2));
	});
var $prozacchiwawa$elm_keccak$Keccak$and64 = F2(
	function (a, b) {
		return A3($prozacchiwawa$elm_keccak$Keccak$tupleMap2, $elm$core$Bitwise$and, a, b);
	});
var $prozacchiwawa$elm_keccak$Keccak$five = A2($elm$core$List$range, 0, 4);
var $prozacchiwawa$elm_keccak$Keccak$gd = F2(
	function (n, _v0) {
		var d0 = _v0.aJ;
		var d1 = _v0.aK;
		var d2 = _v0.aL;
		var d3 = _v0.aM;
		var d4 = _v0.aN;
		switch (n) {
			case 0:
				return d0;
			case 1:
				return d1;
			case 2:
				return d2;
			case 3:
				return d3;
			default:
				return d4;
		}
	});
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $prozacchiwawa$elm_keccak$Keccak$elementMask = 4294967295;
var $prozacchiwawa$elm_keccak$Keccak$tupleMap = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return _Utils_Tuple2(
			f(a),
			f(b));
	});
var $prozacchiwawa$elm_keccak$Keccak$inv64 = function (a) {
	return A2(
		$prozacchiwawa$elm_keccak$Keccak$tupleMap,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Bitwise$complement,
			$elm$core$Bitwise$and($prozacchiwawa$elm_keccak$Keccak$elementMask)),
		a);
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $prozacchiwawa$elm_keccak$Keccak$iPerm = F2(
	function (x, y) {
		return (5 * y) + x;
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $prozacchiwawa$elm_keccak$Keccak$load64 = F2(
	function (off, arr) {
		var _v0 = A2($elm$core$Array$get, off, arr);
		if (!_v0.$) {
			var a = _v0.a;
			return a;
		} else {
			return _Utils_Tuple2(0, 0);
		}
	});
var $prozacchiwawa$elm_keccak$Keccak$readLane = F3(
	function (x, y, state) {
		var off = A2($prozacchiwawa$elm_keccak$Keccak$iPerm, x, y);
		return A2($prozacchiwawa$elm_keccak$Keccak$load64, off, state);
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $prozacchiwawa$elm_keccak$Keccak$store64 = F3(
	function (off, v, arr) {
		return A3($elm$core$Array$set, off, v, arr);
	});
var $prozacchiwawa$elm_keccak$Keccak$writeLane = F4(
	function (x, y, lane, state) {
		var off = A2($prozacchiwawa$elm_keccak$Keccak$iPerm, x, y);
		return A3($prozacchiwawa$elm_keccak$Keccak$store64, off, lane, state);
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $prozacchiwawa$elm_keccak$Keccak$xor64 = F2(
	function (v, arr) {
		return A3($prozacchiwawa$elm_keccak$Keccak$tupleMap2, $elm$core$Bitwise$xor, v, arr);
	});
var $prozacchiwawa$elm_keccak$Keccak$chi = function (ss) {
	var newState = A3(
		$elm$core$List$foldr,
		F2(
			function (y, state) {
				var temp = {
					aJ: A3($prozacchiwawa$elm_keccak$Keccak$readLane, 0, y, ss.c),
					aK: A3($prozacchiwawa$elm_keccak$Keccak$readLane, 1, y, ss.c),
					aL: A3($prozacchiwawa$elm_keccak$Keccak$readLane, 2, y, ss.c),
					aM: A3($prozacchiwawa$elm_keccak$Keccak$readLane, 3, y, ss.c),
					aN: A3($prozacchiwawa$elm_keccak$Keccak$readLane, 4, y, ss.c)
				};
				var yupdate = F2(
					function (x, state_) {
						return A4(
							$prozacchiwawa$elm_keccak$Keccak$writeLane,
							x,
							y,
							A2(
								$prozacchiwawa$elm_keccak$Keccak$xor64,
								A2($prozacchiwawa$elm_keccak$Keccak$gd, x, temp),
								A2(
									$prozacchiwawa$elm_keccak$Keccak$and64,
									$prozacchiwawa$elm_keccak$Keccak$inv64(
										A2(
											$prozacchiwawa$elm_keccak$Keccak$gd,
											A2($elm$core$Basics$modBy, 5, x + 1),
											temp)),
									A2(
										$prozacchiwawa$elm_keccak$Keccak$gd,
										A2($elm$core$Basics$modBy, 5, x + 2),
										temp))),
							state_);
					});
				return A2(
					yupdate,
					4,
					A2(
						yupdate,
						3,
						A2(
							yupdate,
							2,
							A2(
								yupdate,
								1,
								A2(yupdate, 0, state)))));
			}),
		ss.c,
		$prozacchiwawa$elm_keccak$Keccak$five);
	return _Utils_update(
		ss,
		{c: newState});
};
var $prozacchiwawa$elm_keccak$Keccak$zero = _Utils_Tuple2(0, 0);
var $prozacchiwawa$elm_keccak$Keccak$initRound = function (state) {
	return {al: $prozacchiwawa$elm_keccak$Keccak$zero, ao: 1, c: state, bv: 1, bw: 0};
};
var $elm$core$Basics$neq = _Utils_notEqual;
var $prozacchiwawa$elm_keccak$Keccak$lfsr86540 = function (lfsr) {
	var result = !(!(lfsr & 1));
	return (!(!(lfsr & 128))) ? _Utils_Tuple2(result, (lfsr << 1) ^ 113) : _Utils_Tuple2(result, lfsr << 1);
};
var $prozacchiwawa$elm_keccak$Keccak$one = _Utils_Tuple2(1, 0);
var $prozacchiwawa$elm_keccak$Keccak$bitsPerElement = 32;
var $elm$core$Bitwise$or = _Bitwise_or;
var $prozacchiwawa$elm_keccak$Keccak$rolbytes = F2(
	function (n, _v0) {
		var va = _v0.a;
		var vb = _v0.b;
		return (!n) ? _Utils_Tuple2(va, vb) : _Utils_Tuple2(vb, va);
	});
var $prozacchiwawa$elm_keccak$Keccak$rolbits = F2(
	function (n, v) {
		if (!n) {
			return v;
		} else {
			var oneRotated = A2($prozacchiwawa$elm_keccak$Keccak$rolbytes, 1, v);
			return A3(
				$prozacchiwawa$elm_keccak$Keccak$tupleMap2,
				F2(
					function (a, b) {
						return $prozacchiwawa$elm_keccak$Keccak$elementMask & ((a << n) | (b >>> ($prozacchiwawa$elm_keccak$Keccak$bitsPerElement - n)));
					}),
				v,
				oneRotated);
		}
	});
var $prozacchiwawa$elm_keccak$Keccak$rol64 = F2(
	function (n, v) {
		var rby = A2($elm$core$Basics$modBy, $prozacchiwawa$elm_keccak$Keccak$bitsPerElement, (n / $prozacchiwawa$elm_keccak$Keccak$bitsPerElement) | 0);
		var rotated = A2($prozacchiwawa$elm_keccak$Keccak$rolbytes, rby, v);
		var rbi = A2($elm$core$Basics$modBy, $prozacchiwawa$elm_keccak$Keccak$bitsPerElement, n);
		return A2($prozacchiwawa$elm_keccak$Keccak$rolbits, rbi, rotated);
	});
var $prozacchiwawa$elm_keccak$Keccak$updateArray = F3(
	function (n, f, a) {
		var element = A2($elm$core$Array$get, n, a);
		if (element.$ === 1) {
			return a;
		} else {
			var element_ = element.a;
			return A3(
				$elm$core$Array$set,
				n,
				f(element_),
				a);
		}
	});
var $prozacchiwawa$elm_keccak$Keccak$storexor64 = F3(
	function (off, v, arr) {
		return A3(
			$prozacchiwawa$elm_keccak$Keccak$updateArray,
			off,
			$prozacchiwawa$elm_keccak$Keccak$xor64(v),
			arr);
	});
var $prozacchiwawa$elm_keccak$Keccak$xorLane = F4(
	function (x, y, lane, state) {
		var off = A2($prozacchiwawa$elm_keccak$Keccak$iPerm, x, y);
		return A3($prozacchiwawa$elm_keccak$Keccak$storexor64, off, lane, state);
	});
var $prozacchiwawa$elm_keccak$Keccak$iota = function (ss) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (j, ss_) {
				var bitPosition = (1 << j) - 1;
				var _v0 = $prozacchiwawa$elm_keccak$Keccak$lfsr86540(ss_.ao);
				var o = _v0.a;
				var lfsr = _v0.b;
				return o ? _Utils_update(
					ss_,
					{
						ao: lfsr,
						c: A4(
							$prozacchiwawa$elm_keccak$Keccak$xorLane,
							0,
							0,
							A2($prozacchiwawa$elm_keccak$Keccak$rol64, bitPosition, $prozacchiwawa$elm_keccak$Keccak$one),
							ss_.c)
					}) : _Utils_update(
					ss_,
					{ao: lfsr});
			}),
		ss,
		A2($elm$core$List$range, 0, 6));
};
var $prozacchiwawa$elm_keccak$Keccak$twentyThree = A2($elm$core$List$range, 0, 23);
var $prozacchiwawa$elm_keccak$Keccak$rhoPi = function (ss) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (t, ss_) {
				var yy = A2($elm$core$Basics$modBy, 5, (2 * ss_.bv) + (3 * ss_.bw));
				var r = A2($elm$core$Basics$modBy, 64, (((t + 1) * (t + 2)) / 2) | 0);
				return _Utils_update(
					ss_,
					{
						al: A3($prozacchiwawa$elm_keccak$Keccak$readLane, ss_.bw, yy, ss_.c),
						c: A4(
							$prozacchiwawa$elm_keccak$Keccak$writeLane,
							ss_.bw,
							yy,
							A2($prozacchiwawa$elm_keccak$Keccak$rol64, r, ss_.al),
							ss_.c),
						bv: ss_.bw,
						bw: yy
					});
			}),
		_Utils_update(
			ss,
			{
				al: A3($prozacchiwawa$elm_keccak$Keccak$readLane, 1, 0, ss.c),
				bv: 1,
				bw: 0
			}),
		$prozacchiwawa$elm_keccak$Keccak$twentyThree);
};
var $prozacchiwawa$elm_keccak$Keccak$cInitX = F2(
	function (x, state) {
		return A2(
			$prozacchiwawa$elm_keccak$Keccak$xor64,
			A3($prozacchiwawa$elm_keccak$Keccak$readLane, x, 0, state),
			A2(
				$prozacchiwawa$elm_keccak$Keccak$xor64,
				A3($prozacchiwawa$elm_keccak$Keccak$readLane, x, 1, state),
				A2(
					$prozacchiwawa$elm_keccak$Keccak$xor64,
					A3($prozacchiwawa$elm_keccak$Keccak$readLane, x, 2, state),
					A2(
						$prozacchiwawa$elm_keccak$Keccak$xor64,
						A3($prozacchiwawa$elm_keccak$Keccak$readLane, x, 3, state),
						A3($prozacchiwawa$elm_keccak$Keccak$readLane, x, 4, state)))));
	});
var $prozacchiwawa$elm_keccak$Keccak$twentyFive = A2($elm$core$List$range, 0, 25);
var $prozacchiwawa$elm_keccak$Keccak$theta = function (ss) {
	var d = function (x) {
		var c4 = A2(
			$prozacchiwawa$elm_keccak$Keccak$cInitX,
			A2($elm$core$Basics$modBy, 5, x + 4),
			ss.c);
		var c1 = A2(
			$prozacchiwawa$elm_keccak$Keccak$cInitX,
			A2($elm$core$Basics$modBy, 5, x + 1),
			ss.c);
		return A2(
			$prozacchiwawa$elm_keccak$Keccak$xor64,
			c4,
			A2($prozacchiwawa$elm_keccak$Keccak$rol64, 1, c1));
	};
	var dx = {
		aJ: d(0),
		aK: d(1),
		aL: d(2),
		aM: d(3),
		aN: d(4)
	};
	var sd = A3(
		$elm$core$List$foldl,
		F2(
			function (n, state) {
				var x = A2($elm$core$Basics$modBy, 5, n);
				var y = (n / 5) | 0;
				return A4(
					$prozacchiwawa$elm_keccak$Keccak$xorLane,
					x,
					y,
					A2($prozacchiwawa$elm_keccak$Keccak$gd, x, dx),
					state);
			}),
		ss.c,
		$prozacchiwawa$elm_keccak$Keccak$twentyFive);
	return _Utils_update(
		ss,
		{c: sd});
};
var $prozacchiwawa$elm_keccak$Keccak$keccakF1600_StatePermute = function (state) {
	var res = A3(
		$elm$core$List$foldr,
		function (_v0) {
			return A2(
				$elm$core$Basics$composeR,
				$prozacchiwawa$elm_keccak$Keccak$theta,
				A2(
					$elm$core$Basics$composeR,
					$prozacchiwawa$elm_keccak$Keccak$rhoPi,
					A2($elm$core$Basics$composeR, $prozacchiwawa$elm_keccak$Keccak$chi, $prozacchiwawa$elm_keccak$Keccak$iota)));
		},
		$prozacchiwawa$elm_keccak$Keccak$initRound(state),
		$prozacchiwawa$elm_keccak$Keccak$twentyThree);
	return res.c;
};
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $prozacchiwawa$elm_keccak$Keccak$bytesPerElement = ($prozacchiwawa$elm_keccak$Keccak$bitsPerElement / 8) | 0;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $prozacchiwawa$elm_keccak$Keccak$retrieveOutputByte = F2(
	function (i, arr) {
		var shift = 8 * A2($elm$core$Basics$modBy, $prozacchiwawa$elm_keccak$Keccak$bytesPerElement, i);
		var e = A2($elm$core$Basics$modBy, 2, (i / $prozacchiwawa$elm_keccak$Keccak$bytesPerElement) | 0);
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			A2($elm$core$Array$get, (i / 8) | 0, arr));
		var ea = _v0.a;
		var eb = _v0.b;
		var byi = (!e) ? ea : eb;
		return 255 & (byi >> shift);
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $prozacchiwawa$elm_keccak$Keccak$xorFromByte = F3(
	function (shift, sel, by) {
		return (!sel) ? _Utils_Tuple2(by << shift, 0) : _Utils_Tuple2(0, by << shift);
	});
var $prozacchiwawa$elm_keccak$Keccak$xorByteIntoState = F3(
	function (i, v, state) {
		var shift = 8 * A2($elm$core$Basics$modBy, $prozacchiwawa$elm_keccak$Keccak$bytesPerElement, i);
		var e = A2($elm$core$Basics$modBy, 2, (i / $prozacchiwawa$elm_keccak$Keccak$bytesPerElement) | 0);
		var newElt = A3($prozacchiwawa$elm_keccak$Keccak$xorFromByte, shift, e, v);
		return A3($prozacchiwawa$elm_keccak$Keccak$storexor64, (i / 8) | 0, newElt, state);
	});
var $prozacchiwawa$elm_keccak$Keccak$xorIntoState = F2(
	function (block, state) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, s) {
					var i = _v0.a;
					var e = _v0.b;
					return A3($prozacchiwawa$elm_keccak$Keccak$xorByteIntoState, i, e, s);
				}),
			state,
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, e) {
						return _Utils_Tuple2(i, e);
					}),
				block));
	});
var $prozacchiwawa$elm_keccak$Keccak$finish = function (_v0) {
	var state = _v0;
	var rateInBytes = (state.aA.x / 8) | 0;
	var inputLength = state.V;
	var config = state.aA;
	var concat = $prozacchiwawa$elm_keccak$Keccak$concatBytesList(state._);
	var inb = $prozacchiwawa$elm_keccak$Keccak$intListOfBytes(concat);
	var s1 = A2($prozacchiwawa$elm_keccak$Keccak$xorIntoState, inb, state.c);
	var blockSize = (!inputLength) ? 0 : ((!A2($elm$core$Basics$modBy, rateInBytes, inputLength)) ? rateInBytes : A2($elm$core$Basics$modBy, rateInBytes, inputLength));
	if (((config.x + config.H) !== 1600) || (!(!A2($elm$core$Basics$modBy, 8, config.x)))) {
		return _List_Nil;
	} else {
		var state1 = A3($prozacchiwawa$elm_keccak$Keccak$xorByteIntoState, blockSize, config.C, s1);
		var state2 = ((!(!(config.C & 128))) && _Utils_eq(blockSize, rateInBytes - 1)) ? $prozacchiwawa$elm_keccak$Keccak$keccakF1600_StatePermute(state1) : state1;
		var state3 = A3($prozacchiwawa$elm_keccak$Keccak$xorByteIntoState, rateInBytes - 1, 128, state2);
		var state4 = $prozacchiwawa$elm_keccak$Keccak$keccakF1600_StatePermute(state3);
		var processRemainingOutput = F3(
			function (state_, output_, outputByteLen) {
				processRemainingOutput:
				while (true) {
					if (outputByteLen > 0) {
						var blockSize_ = A2($elm$core$Basics$min, outputByteLen, rateInBytes);
						var outputBytes = A2(
							$elm$core$List$map,
							function (i) {
								return A2($prozacchiwawa$elm_keccak$Keccak$retrieveOutputByte, i, state4);
							},
							A2($elm$core$List$range, 0, blockSize_));
						var $temp$state_ = $prozacchiwawa$elm_keccak$Keccak$keccakF1600_StatePermute(state_),
							$temp$output_ = _Utils_ap(output_, outputBytes),
							$temp$outputByteLen = outputByteLen - blockSize_;
						state_ = $temp$state_;
						output_ = $temp$output_;
						outputByteLen = $temp$outputByteLen;
						continue processRemainingOutput;
					} else {
						return output_;
					}
				}
			});
		return A2(
			$elm$core$List$take,
			config.E,
			A3(processRemainingOutput, state4, _List_Nil, config.E));
	}
};
var $prozacchiwawa$elm_keccak$Keccak$KS = $elm$core$Basics$identity;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $prozacchiwawa$elm_keccak$Keccak$init = function (_v0) {
	var config = _v0;
	return {
		aA: config,
		V: 0,
		_: _List_Nil,
		c: A2(
			$elm$core$Array$initialize,
			25,
			$elm$core$Basics$always($prozacchiwawa$elm_keccak$Keccak$zero))
	};
};
var $elm$bytes$Bytes$Encode$U8 = function (a) {
	return {$: 3, a: a};
};
var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
var $elm$bytes$Bytes$Decode$bytes = function (n) {
	return _Bytes_read_bytes(n);
};
var $prozacchiwawa$elm_keccak$Keccak$emptyBytes = $elm$bytes$Bytes$Encode$encode(
	$elm$bytes$Bytes$Encode$sequence(_List_Nil));
var $elm$bytes$Bytes$Decode$andThen = F2(
	function (callback, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var newOffset = _v1.a;
				var a = _v1.b;
				var _v2 = callback(a);
				var decodeB = _v2;
				return A2(decodeB, bites, newOffset);
			});
	});
var $prozacchiwawa$elm_keccak$Keccak$restOfBytesDecoder = F2(
	function (n, m) {
		return A2(
			$elm$bytes$Bytes$Decode$andThen,
			function (x) {
				return $elm$bytes$Bytes$Decode$bytes(m);
			},
			$elm$bytes$Bytes$Decode$bytes(n));
	});
var $prozacchiwawa$elm_keccak$Keccak$restOfBytes = F2(
	function (n, b) {
		return A2(
			$elm$core$Maybe$withDefault,
			$prozacchiwawa$elm_keccak$Keccak$emptyBytes,
			A2(
				$elm$bytes$Bytes$Decode$decode,
				A2(
					$prozacchiwawa$elm_keccak$Keccak$restOfBytesDecoder,
					n,
					$elm$bytes$Bytes$width(b) - n),
				b));
	});
var $prozacchiwawa$elm_keccak$Keccak$update = F2(
	function (b, _v0) {
		update:
		while (true) {
			var state = _v0;
			var rateInBytes = (state.aA.x / 8) | 0;
			var newPartial = (!$elm$bytes$Bytes$width(b)) ? state._ : A2($elm$core$List$cons, b, state._);
			var storedBytes = A3(
				$elm$core$List$foldl,
				F2(
					function (bs, s) {
						return s + $elm$bytes$Bytes$width(bs);
					}),
				0,
				newPartial);
			if (_Utils_cmp(storedBytes, rateInBytes) > -1) {
				var concat = $prozacchiwawa$elm_keccak$Keccak$concatBytesList(newPartial);
				var first = A2(
					$elm$core$Maybe$withDefault,
					$prozacchiwawa$elm_keccak$Keccak$emptyBytes,
					A2(
						$elm$bytes$Bytes$Decode$decode,
						$elm$bytes$Bytes$Decode$bytes(rateInBytes),
						concat));
				var inb = $prozacchiwawa$elm_keccak$Keccak$intListOfBytes(first);
				var s1 = A2($prozacchiwawa$elm_keccak$Keccak$xorIntoState, inb, state.c);
				var s2 = $prozacchiwawa$elm_keccak$Keccak$keccakF1600_StatePermute(s1);
				var rest = A2($prozacchiwawa$elm_keccak$Keccak$restOfBytes, rateInBytes, concat);
				var $temp$b = $prozacchiwawa$elm_keccak$Keccak$emptyBytes,
					$temp$_v0 = _Utils_update(
					state,
					{
						V: $elm$bytes$Bytes$width(b) + state.V,
						_: _List_fromArray(
							[rest]),
						c: s2
					});
				b = $temp$b;
				_v0 = $temp$_v0;
				continue update;
			} else {
				return _Utils_update(
					state,
					{
						V: $elm$bytes$Bytes$width(b) + state.V,
						_: newPartial
					});
			}
		}
	});
var $prozacchiwawa$elm_keccak$Keccak$Int$keccak = F2(
	function (config, ints) {
		return $prozacchiwawa$elm_keccak$Keccak$finish(
			A2(
				$prozacchiwawa$elm_keccak$Keccak$update,
				$elm$bytes$Bytes$Encode$encode(
					$elm$bytes$Bytes$Encode$sequence(
						A2($elm$core$List$map, $elm$bytes$Bytes$Encode$unsignedInt8, ints))),
				$prozacchiwawa$elm_keccak$Keccak$init(config)));
	});
var $prozacchiwawa$elm_keccak$Keccak$Int$ethereum_keccak_256 = $prozacchiwawa$elm_keccak$Keccak$Int$keccak($prozacchiwawa$elm_keccak$Keccak$ethereum_keccak_256);
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$String$append = _String_append;
var $author$project$EthereumAddress$toByteLength = function (str) {
	return ($elm$core$String$length(str) === 1) ? A2($elm$core$String$append, '0', str) : str;
};
var $elm$core$Char$toLower = _Char_toLower;
var $elm$core$String$fromList = _String_fromList;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$EthereumAddress$checksumHelper = function (zeroLessAddress) {
	var addressChars = $elm$core$String$toList(zeroLessAddress);
	return function (b) {
		return _Utils_Tuple2(addressChars, b);
	}(
		A2(
			$elm$core$Result$withDefault,
			_List_Nil,
			$elm_community$result_extra$Result$Extra$combine(
				A2(
					$elm$core$List$map,
					$rtfeldman$elm_hex$Hex$fromString,
					A2(
						$elm$core$String$split,
						'',
						A2(
							$elm$core$String$join,
							'',
							A2(
								$elm$core$List$map,
								A2($elm$core$Basics$composeR, $rtfeldman$elm_hex$Hex$toString, $author$project$EthereumAddress$toByteLength),
								A2(
									$elm$core$List$take,
									20,
									$prozacchiwawa$elm_keccak$Keccak$Int$ethereum_keccak_256(
										A2(
											$elm$core$List$map,
											A2($elm$core$Basics$composeR, $elm$core$Char$toLower, $elm$core$Char$toCode),
											addressChars))))))))));
};
var $elm$core$Char$toUpper = _Char_toUpper;
var $author$project$EthereumAddress$compareCharToHash = F2(
	function (addrChar, hashInt) {
		return (hashInt >= 8) ? $elm$core$Char$toUpper(addrChar) : addrChar;
	});
var $author$project$EthereumAddress$remove0x = function (str) {
	return (A2($elm$core$String$startsWith, '0x', str) || A2($elm$core$String$startsWith, '0X', str)) ? A2($elm$core$String$dropLeft, 2, str) : str;
};
var $elm$core$String$toLower = _String_toLower;
var $author$project$EthereumAddress$checksumIt = function (str) {
	var _v0 = $author$project$EthereumAddress$checksumHelper(
		$author$project$EthereumAddress$remove0x(
			$elm$core$String$toLower(str)));
	var addrChars = _v0.a;
	var hashInts = _v0.b;
	return $elm$core$String$fromList(
		A3($elm$core$List$map2, $author$project$EthereumAddress$compareCharToHash, addrChars, hashInts));
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {bP: index, bT: match, bX: number, cc: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{bC: false, bW: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $author$project$EthereumAddress$isAddress = $elm$regex$Regex$contains(
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^((0[Xx]){1})?[0-9A-Fa-f]{40}$')));
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Basics$not = _Basics_not;
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$EthereumAddress$isChecksumAddress = function (str) {
	var checksumTestChar = F2(
		function (addrChar, hashInt) {
			return (((hashInt >= 8) && $elm$core$Char$isLower(addrChar)) || ((hashInt < 8) && $elm$core$Char$isUpper(addrChar))) ? false : true;
		});
	var _v0 = $author$project$EthereumAddress$checksumHelper(
		$author$project$EthereumAddress$remove0x(str));
	var addrChars = _v0.a;
	var hashInts = _v0.b;
	var checksumCorrect = A3($elm$core$List$map2, checksumTestChar, addrChars, hashInts);
	return $author$project$EthereumAddress$isAddress(str) ? A2($elm$core$List$all, $elm$core$Basics$identity, checksumCorrect) : false;
};
var $author$project$EthereumAddress$isLowerCaseAddress = $elm$regex$Regex$contains(
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^((0[Xx]){1})?[0-9a-f]{40}$')));
var $author$project$EthereumAddress$isUpperCaseAddress = $elm$regex$Regex$contains(
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^((0[Xx]){1})?[0-9A-F]{40}$')));
var $author$project$EthereumAddress$quote = function (str) {
	return '\"' + (str + '\"');
};
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $author$project$EthereumAddress$fromString = function (addressStr) {
	var noZeroX = $author$project$EthereumAddress$remove0x(addressStr);
	var emptyZerosInBytes32 = A2($elm$core$String$left, 24, noZeroX);
	var bytes32Address = A2($elm$core$String$right, 40, addressStr);
	return (($elm$core$String$length(noZeroX) === 64) && A2(
		$elm$core$String$all,
		$elm$core$Basics$eq('0'),
		emptyZerosInBytes32)) ? (($author$project$EthereumAddress$isUpperCaseAddress(bytes32Address) || $author$project$EthereumAddress$isLowerCaseAddress(bytes32Address)) ? $elm$core$Result$Ok(
		$author$project$EthereumAddress$checksumIt(bytes32Address)) : ($author$project$EthereumAddress$isChecksumAddress(bytes32Address) ? $elm$core$Result$Ok(
		$author$project$EthereumAddress$checksumIt(bytes32Address)) : $elm$core$Result$Err(
		'Given address ' + ($author$project$EthereumAddress$quote(addressStr) + ' failed the EIP-55 checksum test.')))) : (($elm$core$String$length(noZeroX) !== 40) ? $elm$core$Result$Err(
		'Given address ' + ($author$project$EthereumAddress$quote(addressStr) + ' is not the correct length.')) : ((!$author$project$EthereumAddress$isAddress(noZeroX)) ? $elm$core$Result$Err(
		'Given address ' + ($author$project$EthereumAddress$quote(addressStr) + ' contains invalid hex characters.')) : (($author$project$EthereumAddress$isUpperCaseAddress(noZeroX) || $author$project$EthereumAddress$isLowerCaseAddress(noZeroX)) ? $elm$core$Result$Ok(
		$author$project$EthereumAddress$checksumIt(noZeroX)) : ($author$project$EthereumAddress$isChecksumAddress(noZeroX) ? $elm$core$Result$Ok(noZeroX) : $elm$core$Result$Err(
		'Given address ' + ($author$project$EthereumAddress$quote(addressStr) + ' failed the EIP-55 checksum test.'))))));
};
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$EthereumAddress$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (addressStr) {
		var _v0 = $author$project$EthereumAddress$fromString(addressStr);
		if (!_v0.$) {
			var address = _v0.a;
			return $elm$json$Json$Decode$succeed(address);
		} else {
			var error = _v0.a;
			return $elm$json$Json$Decode$fail('Error decoding ethereum address with message: ' + error);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Session$decodeAccount = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Session$Account,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'address', $author$project$EthereumAddress$decoder),
	A2($elm$json$Json$Decode$field, 'keystore', $elm$json$Json$Decode$string));
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $turboMaCk$any_dict$Dict$Any$AnyDict = $elm$core$Basics$identity;
var $turboMaCk$any_dict$Dict$Any$fromList = F2(
	function (f, xs) {
		return {
			a: $elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (_v0) {
						var k = _v0.a;
						var v = _v0.b;
						return _Utils_Tuple2(
							f(k),
							_Utils_Tuple2(k, v));
					},
					xs)),
			B: f
		};
	});
var $author$project$EthereumAddress$add0x = function (str) {
	return (A2($elm$core$String$startsWith, '0x', str) || A2($elm$core$String$startsWith, '0X', str)) ? str : ('0x' + str);
};
var $author$project$EthereumAddress$toString = function (_v0) {
	var addressStr = _v0;
	return $author$project$EthereumAddress$add0x(addressStr);
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Session$decodeAccounts = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Dict$values,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				function (account) {
					return _Utils_Tuple2(account.aF, account);
				}),
			$turboMaCk$any_dict$Dict$Any$fromList($author$project$EthereumAddress$toString))),
	$elm$json$Json$Decode$dict($author$project$Session$decodeAccount));
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Session$decodeStorage = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Session$Storage,
	A2($elm$json$Json$Decode$field, 'accounts', $author$project$Session$decodeAccounts),
	A2(
		$elm$json$Json$Decode$field,
		'selectedAccount',
		$elm$json$Json$Decode$maybe($author$project$EthereumAddress$decoder)));
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $turboMaCk$any_dict$Dict$Any$empty = function (toKey) {
	return {a: $elm$core$Dict$empty, B: toKey};
};
var $francescortiz$elm_queue$Queue$QueueUnkeyed = $elm$core$Basics$identity;
var $francescortiz$elm_queue$Queue$emptyUnkeyed = function (poolSize) {
	return {j: _List_Nil, g: _List_Nil, ab: poolSize};
};
var $author$project$Constants$fallbackGasRelayUrl = '$GAS_RELAY_URL';
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Page$Initialize$init = _Utils_Tuple2(
	{f: '', aa: ''},
	$elm$core$Platform$Cmd$none);
var $author$project$Page$Unlock$init = _Utils_Tuple2(
	{f: ''},
	$elm$core$Platform$Cmd$none);
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $turboMaCk$any_dict$Dict$Any$isEmpty = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$isEmpty(dict);
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$PostMessage$messageReady = 'octovault-ready';
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ports$readFromSessionStorage = _Platform_outgoingPort('readFromSessionStorage', $elm$json$Json$Encode$string);
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$PostMessage$sendMessage = _Platform_outgoingPort(
	'sendMessage',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Basics$identity(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$OctoVault$init = F3(
	function (flags, url, key) {
		var decodedStorage = function () {
			var _v5 = flags.aX;
			if (_v5.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var storage_ = _v5.a;
				return $elm$core$Result$toMaybe(
					A2($elm$json$Json$Decode$decodeString, $author$project$Session$decodeStorage, storage_));
			}
		}();
		var accounts = A2(
			$elm$core$Maybe$withDefault,
			$turboMaCk$any_dict$Dict$Any$empty($author$project$EthereumAddress$toString),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.i;
				},
				decodedStorage));
		var _v0 = function () {
			var initialize = function (_v3) {
				var a = _v3.a;
				var b = _v3.b;
				return _Utils_Tuple2(
					$author$project$Model$Initialize(a),
					A2($elm$core$Platform$Cmd$map, $author$project$Model$FromInitialize, b));
			}($author$project$Page$Initialize$init);
			if (decodedStorage.$ === 1) {
				return initialize;
			} else {
				var storage_ = decodedStorage.a;
				return $turboMaCk$any_dict$Dict$Any$isEmpty(storage_.i) ? initialize : function (_v2) {
					var a = _v2.a;
					var b = _v2.b;
					return _Utils_Tuple2(
						$author$project$Model$Unlock(a),
						A2($elm$core$Platform$Cmd$map, $author$project$Model$FromUnlock, b));
				}($author$project$Page$Unlock$init);
			}
		}();
		var subModel = _v0.a;
		var subCmd = _v0.b;
		var _v4 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(false, 'https://interaction.disabled.example.com'),
			A2(
				$elm$core$Maybe$map,
				function (x) {
					return _Utils_Tuple2(true, x);
				},
				flags.bz));
		var isEmbedded = _v4.a;
		var allowedOrigin = _v4.b;
		var session = {
			i: accounts,
			bB: false,
			a5: $author$project$Constants$fallbackGasRelayUrl,
			s: isEmbedded,
			J: !isEmbedded,
			f: $elm$core$Maybe$Nothing,
			t: A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.t;
				},
				decodedStorage),
			as: flags.as
		};
		return _Utils_Tuple2(
			{
				bz: allowedOrigin,
				bG: flags.bG,
				bV: $francescortiz$elm_queue$Queue$emptyUnkeyed(1),
				b2: subModel,
				b7: session,
				b8: false,
				b9: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						subCmd,
						session.s ? $author$project$PostMessage$sendMessage(
						_Utils_Tuple2(
							$elm$json$Json$Encode$string($author$project$PostMessage$messageReady),
							allowedOrigin)) : $elm$core$Platform$Cmd$none,
						$author$project$Ports$readFromSessionStorage('sspKey')
					])));
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $author$project$Model$AccountFetchResult = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$CloseDelayed = function (a) {
	return {$: 20, a: a};
};
var $author$project$Model$ExportPrivateKeyResult = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$FromGasRelay = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$ReceiveMessage = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$SessionStorageRead = function (a) {
	return {$: 13, a: a};
};
var $author$project$Model$SignOnJsResult = function (a) {
	return {$: 12, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$OctoVault$fetchResultDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2(
		$elm$json$Json$Decode$index,
		0,
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$index,
		1,
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
					$elm$json$Json$Decode$maybe($author$project$Session$decodeAccount)
				]))));
var $author$project$OctoVault$decodeFetchResult = function (value) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$OctoVault$fetchResultDecoder, value);
};
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {bg: processes, br: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.bg;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.br);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Ports$exportPrivateKeyResult = _Platform_incomingPort('exportPrivateKeyResult', $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Ports$fetchResult = _Platform_incomingPort('fetchResult', $elm$json$Json$Decode$value);
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Ports$readFromSessionStorageResponse = _Platform_incomingPort(
	'readFromSessionStorageResponse',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$PostMessage$receiveMessage = _Platform_incomingPort(
	'receiveMessage',
	A2(
		$elm$json$Json$Decode$andThen,
		function (source) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (origin) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (data) {
							return $elm$json$Json$Decode$succeed(
								{am: data, ba: origin, bp: source});
						},
						A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value));
				},
				A2($elm$json$Json$Decode$field, 'origin', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'source', $elm$json$Json$Decode$value)));
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Ports$signOnJsResult = _Platform_incomingPort(
	'signOnJsResult',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (_v2) {
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple3(_v0, _v1, _v2));
						},
						A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$value));
				},
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$int));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Page$GasRelay$ComposedTransactions = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$GasRelay$SignAndSendToGasRelay = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$GasRelay$composedTransactions = _Platform_incomingPort('composedTransactions', $elm$json$Json$Decode$value);
var $author$project$Page$GasRelay$signedTransactions = _Platform_incomingPort('signedTransactions', $elm$json$Json$Decode$value);
var $author$project$Page$GasRelay$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Page$GasRelay$signedTransactions($author$project$Page$GasRelay$SignAndSendToGasRelay),
				$author$project$Page$GasRelay$composedTransactions($author$project$Page$GasRelay$ComposedTransactions)
			]));
};
var $author$project$Page$Unlock$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$OctoVault$subscriptions = function (model) {
	var subPageSubscriptions = function () {
		var _v0 = model.b2;
		switch (_v0.$) {
			case 5:
				var subModel = _v0.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Model$FromGasRelay,
					$author$project$Page$GasRelay$subscriptions(subModel));
			case 0:
				var subModel = _v0.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Model$FromUnlock,
					$author$project$Page$Unlock$subscriptions(subModel));
			default:
				return $elm$core$Platform$Sub$none;
		}
	}();
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$PostMessage$receiveMessage($author$project$Model$ReceiveMessage),
				$author$project$Ports$signOnJsResult($author$project$Model$SignOnJsResult),
				$author$project$Ports$fetchResult(
				A2($elm$core$Basics$composeR, $author$project$OctoVault$decodeFetchResult, $author$project$Model$AccountFetchResult)),
				$author$project$Ports$exportPrivateKeyResult($author$project$Model$ExportPrivateKeyResult),
				$author$project$Ports$readFromSessionStorageResponse($author$project$Model$SessionStorageRead),
				subPageSubscriptions,
				model.b8 ? A2($elm$time$Time$every, 500, $author$project$Model$CloseDelayed) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Page$GasRelay$AddTransactions = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Model$Close = {$: 19};
var $author$project$Model$Create = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$FromCreate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$FromHome = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$FromImport = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$FromSign = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$GasRelay = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$Home = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Import = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$PostSSPDataResult = function (a) {
	return {$: 15, a: a};
};
var $author$project$Model$SSPDataGenerated = function (a) {
	return {$: 16, a: a};
};
var $author$project$Model$SSPDataResult = function (a) {
	return {$: 14, a: a};
};
var $author$project$Model$Sign = function (a) {
	return {$: 6, a: a};
};
var $Chadtech$return$Return2$addCmd = F2(
	function (newCmd, _v0) {
		var model_ = _v0.a;
		var cmd_ = _v0.b;
		return _Utils_Tuple2(
			model_,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[newCmd, cmd_])));
	});
var $author$project$Ports$alert = _Platform_outgoingPort('alert', $elm$json$Json$Encode$string);
var $ccapndave$elm_update_extra$Update$Extra$andThen = F3(
	function (update, msg, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = A2(update, msg, model);
		var model_ = _v1.a;
		var cmd_ = _v1.b;
		return _Utils_Tuple2(
			model_,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, cmd_])));
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Ports$create = _Platform_outgoingPort(
	'create',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.p)),
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string($.f))
				]));
	});
var $author$project$PostMessage$ExecuteTransactions = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$PostMessage$SetGasRelayUrl = function (a) {
	return {$: 2, a: a};
};
var $author$project$PostMessage$SetOpen = function (a) {
	return {$: 3, a: a};
};
var $author$project$PostMessage$Sign = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$PostMessage$arrayAsTuple2 = F2(
	function (a, b) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (aVal) {
				return A2(
					$elm$json$Json$Decode$andThen,
					function (bVal) {
						return $elm$json$Json$Decode$succeed(
							_Utils_Tuple2(aVal, bVal));
					},
					A2($elm$json$Json$Decode$index, 1, b));
			},
			A2($elm$json$Json$Decode$index, 0, a));
	});
var $TSFoster$elm_tuple_extra$Tuple3$join = F3(
	function (a, b, c) {
		return _Utils_Tuple3(a, b, c);
	});
var $author$project$PostMessage$arrayAsTuple3 = F3(
	function (a, b, c) {
		return A4(
			$elm$json$Json$Decode$map3,
			$TSFoster$elm_tuple_extra$Tuple3$join,
			A2($elm$json$Json$Decode$index, 0, a),
			A2($elm$json$Json$Decode$index, 1, b),
			A2($elm$json$Json$Decode$index, 2, c));
	});
var $author$project$PostMessage$executeTransactions = 'octovault-execute';
var $author$project$PostMessage$messageSign = 'octovault-sign';
var $author$project$PostMessage$setGasRelayUrl = 'set-gas-relay-url';
var $author$project$PostMessage$setOpen = 'set-open';
var $author$project$PostMessage$decodeMessageToIframe = function (postMessageEvent) {
	return A2(
		$elm$json$Json$Decode$decodeValue,
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$andThen,
					function (v) {
						return $elm$json$Json$Decode$fail('Not a known MessageToIframe: ' + v);
					},
					$elm$json$Json$Decode$string),
					A2(
					$elm$json$Json$Decode$andThen,
					function (_v0) {
						var k = _v0.a;
						var requestId = _v0.b;
						var msgData = _v0.c;
						return _Utils_eq(k, $author$project$PostMessage$messageSign) ? $elm$json$Json$Decode$succeed(
							A2($author$project$PostMessage$Sign, requestId, msgData)) : $elm$json$Json$Decode$fail('Not a known annotated value key: ' + k);
					},
					A3($author$project$PostMessage$arrayAsTuple3, $elm$json$Json$Decode$string, $elm$json$Json$Decode$int, $elm$json$Json$Decode$string)),
					A2(
					$elm$json$Json$Decode$andThen,
					function (_v1) {
						var k = _v1.a;
						var requestId = _v1.b;
						var msgData = _v1.c;
						return _Utils_eq(k, $author$project$PostMessage$executeTransactions) ? $elm$json$Json$Decode$succeed(
							A2($author$project$PostMessage$ExecuteTransactions, requestId, msgData)) : $elm$json$Json$Decode$fail('Not a known annotated value key: ' + k);
					},
					A3($author$project$PostMessage$arrayAsTuple3, $elm$json$Json$Decode$string, $elm$json$Json$Decode$int, $elm$json$Json$Decode$value)),
					A2(
					$elm$json$Json$Decode$andThen,
					function (_v2) {
						var k = _v2.a;
						var v = _v2.b;
						return _Utils_eq(k, $author$project$PostMessage$setGasRelayUrl) ? $elm$json$Json$Decode$succeed(
							$author$project$PostMessage$SetGasRelayUrl(v)) : $elm$json$Json$Decode$fail('Not a known annotated string key: ' + k);
					},
					A2($author$project$PostMessage$arrayAsTuple2, $elm$json$Json$Decode$string, $elm$json$Json$Decode$string)),
					A2(
					$elm$json$Json$Decode$andThen,
					function (_v3) {
						var k = _v3.a;
						var v = _v3.b;
						return _Utils_eq(k, $author$project$PostMessage$setOpen) ? $elm$json$Json$Decode$succeed(
							$author$project$PostMessage$SetOpen(v)) : $elm$json$Json$Decode$fail('Not a known annotated string key: ' + k);
					},
					A2($author$project$PostMessage$arrayAsTuple2, $elm$json$Json$Decode$string, $elm$json$Json$Decode$bool))
				])),
		postMessageEvent.am);
};
var $author$project$Constants$defaultKeyName = 'Key 1';
var $author$project$EthereumAddress$encode = function (address) {
	return $elm$json$Json$Encode$string(
		$author$project$EthereumAddress$toString(address));
};
var $francescortiz$elm_queue$Queue$enqueueUnkeyed = F2(
	function (item, _v0) {
		var queue = _v0;
		return _Utils_update(
			queue,
			{
				g: A2($elm$core$List$cons, item, queue.g)
			});
	});
var $author$project$PostMessage$executeTransactionsResponse = 'octovault-execute-response';
var $author$project$Ports$exportPrivateKey = _Platform_outgoingPort(
	'exportPrivateKey',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'keystore',
					$elm$json$Json$Encode$string($.W)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.p)),
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string($.f))
				]));
	});
var $NoRedInk$elm_string_conversions$String$Conversions$fromString = function (string) {
	return A2(
		$elm$json$Json$Encode$encode,
		0,
		$elm$json$Json$Encode$string(string));
};
var $NoRedInk$elm_string_conversions$String$Conversions$withUnionConstructor = F2(
	function (tag, args) {
		var needsParens = function (a) {
			return A2($elm$core$String$contains, ' ', a) && ((!A2($elm$core$String$startsWith, '{', a)) && ((!A2($elm$core$String$startsWith, '(', a)) && ((!A2($elm$core$String$startsWith, '[', a)) && ((!A2($elm$core$String$startsWith, '\"', a)) && (!A2($elm$core$String$startsWith, '\'', a))))));
		};
		var argsString = A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				function (arg) {
					return needsParens(arg) ? ('(' + (arg + ')')) : arg;
				},
				args));
		return tag + (' ' + argsString);
	});
var $NoRedInk$elm_string_conversions$String$Conversions$fromHttpError = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return A2(
				$NoRedInk$elm_string_conversions$String$Conversions$withUnionConstructor,
				'BadUrl',
				_List_fromArray(
					[
						$NoRedInk$elm_string_conversions$String$Conversions$fromString(url)
					]));
		case 1:
			return A2($NoRedInk$elm_string_conversions$String$Conversions$withUnionConstructor, 'Timeout', _List_Nil);
		case 2:
			return A2($NoRedInk$elm_string_conversions$String$Conversions$withUnionConstructor, 'NetworkError', _List_Nil);
		case 3:
			var statusCode = error.a;
			return A2(
				$NoRedInk$elm_string_conversions$String$Conversions$withUnionConstructor,
				'BadStatus',
				_List_fromArray(
					[
						$elm$core$String$fromInt(statusCode)
					]));
		default:
			var body = error.a;
			return A2(
				$NoRedInk$elm_string_conversions$String$Conversions$withUnionConstructor,
				'BadBody',
				_List_fromArray(
					[
						$NoRedInk$elm_string_conversions$String$Conversions$fromString(body)
					]));
	}
};
var $elm$random$Random$Generate = $elm$core$Basics$identity;
var $elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		A2($elm$random$Random$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		A2($elm$random$Random$Seed, state2, incr));
};
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$random$Random$init = A2(
	$elm$core$Task$andThen,
	function (time) {
		return $elm$core$Task$succeed(
			$elm$random$Random$initialSeed(
				$elm$time$Time$posixToMillis(time)));
	},
	$elm$time$Time$now);
var $elm$random$Random$step = F2(
	function (_v0, seed) {
		var generator = _v0;
		return generator(seed);
	});
var $elm$random$Random$onEffects = F3(
	function (router, commands, seed) {
		if (!commands.b) {
			return $elm$core$Task$succeed(seed);
		} else {
			var generator = commands.a;
			var rest = commands.b;
			var _v1 = A2($elm$random$Random$step, generator, seed);
			var value = _v1.a;
			var newSeed = _v1.b;
			return A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$random$Random$onEffects, router, rest, newSeed);
				},
				A2($elm$core$Platform$sendToApp, router, value));
		}
	});
var $elm$random$Random$onSelfMsg = F3(
	function (_v0, _v1, seed) {
		return $elm$core$Task$succeed(seed);
	});
var $elm$random$Random$Generator = $elm$core$Basics$identity;
var $elm$random$Random$map = F2(
	function (func, _v0) {
		var genA = _v0;
		return function (seed0) {
			var _v1 = genA(seed0);
			var a = _v1.a;
			var seed1 = _v1.b;
			return _Utils_Tuple2(
				func(a),
				seed1);
		};
	});
var $elm$random$Random$cmdMap = F2(
	function (func, _v0) {
		var generator = _v0;
		return A2($elm$random$Random$map, func, generator);
	});
_Platform_effectManagers['Random'] = _Platform_createManager($elm$random$Random$init, $elm$random$Random$onEffects, $elm$random$Random$onSelfMsg, $elm$random$Random$cmdMap);
var $elm$random$Random$command = _Platform_leaf('Random');
var $elm$random$Random$generate = F2(
	function (tagger, generator) {
		return $elm$random$Random$command(
			A2($elm$random$Random$map, tagger, generator));
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $turboMaCk$any_dict$Dict$Any$get = F2(
	function (k, _v0) {
		var dict = _v0.a;
		var toKey = _v0.B;
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$Dict$get,
				toKey(k),
				dict));
	});
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.ca));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {bk: reqs, bq: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.cg;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.bk));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.bq)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					by: r.by,
					ay: r.ay,
					a3: A2(_Http_mapExpect, func, r.a3),
					bM: r.bM,
					bU: r.bU,
					ce: r.ce,
					cg: r.cg,
					bs: r.bs
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{by: false, ay: r.ay, a3: r.a3, bM: r.bM, bU: r.bU, ce: r.ce, cg: r.cg, bs: r.bs}));
};
var $author$project$Constants$secureSessionProviderUrl = 'https://ssp.flexidao.com/';
var $author$project$Model$SSPData = F2(
	function (key, salt) {
		return {bS: key, b5: salt};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$OctoVault$sspDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'salt',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'key',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$SSPData)));
var $author$project$OctoVault$getSSPData = F2(
	function (msg, key) {
		return $elm$http$Http$request(
			{
				ay: $elm$http$Http$emptyBody,
				a3: A2($elm$http$Http$expectJson, msg, $author$project$OctoVault$sspDataDecoder),
				bM: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-Auth-Key', key)
					]),
				bU: 'GET',
				ce: $elm$core$Maybe$Nothing,
				cg: $elm$core$Maybe$Nothing,
				bs: $author$project$Constants$secureSessionProviderUrl
			});
	});
var $author$project$Page$Home$init = _Utils_Tuple2(
	{bH: $elm$core$Maybe$Nothing, an: $elm$core$Maybe$Nothing, L: $elm$core$Maybe$Nothing},
	$elm$core$Platform$Cmd$none);
var $author$project$OctoVault$goHome = function (model) {
	var _v0 = $author$project$Page$Home$init;
	var newSubModel = _v0.a;
	var subCmd = _v0.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				b2: $author$project$Model$Home(newSubModel)
			}),
		A2($elm$core$Platform$Cmd$map, $author$project$Model$FromHome, subCmd));
};
var $author$project$OctoVault$setPage = F2(
	function (subPage, model) {
		return _Utils_update(
			model,
			{b2: subPage});
	});
var $Chadtech$return$Return2$withNoCmd = function (model_) {
	return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
};
var $author$project$OctoVault$handleCreateReply = F3(
	function (subModel, maybeReply, model) {
		if (maybeReply.$ === 1) {
			return $Chadtech$return$Return2$withNoCmd(
				A2(
					$author$project$OctoVault$setPage,
					$author$project$Model$Create(subModel),
					model));
		} else {
			if (!maybeReply.a.$) {
				var accountDetails = maybeReply.a.a;
				var session = model.b7;
				var _v1 = session.f;
				if (!_v1.$) {
					var password = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b7: _Utils_update(
									session,
									{bB: true})
							}),
						$author$project$Ports$create(
							{p: accountDetails.p, f: password}));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$Ports$alert('Wrong application state: no password.'));
				}
			} else {
				var _v2 = maybeReply.a;
				return $author$project$OctoVault$goHome(model);
			}
		}
	});
var $author$project$Ports$import_ = _Platform_outgoingPort(
	'import_',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.p)),
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string($.f)),
					_Utils_Tuple2(
					'privateKey',
					$elm$json$Json$Encode$string($.be))
				]));
	});
var $author$project$OctoVault$handleImportReply = F3(
	function (subModel, maybeReply, model) {
		if (maybeReply.$ === 1) {
			return $Chadtech$return$Return2$withNoCmd(
				A2(
					$author$project$OctoVault$setPage,
					$author$project$Model$Import(subModel),
					model));
		} else {
			if (!maybeReply.a.$) {
				var accountDetails = maybeReply.a.a;
				var session = model.b7;
				var _v1 = session.f;
				if (!_v1.$) {
					var password = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b7: _Utils_update(
									session,
									{bB: true})
							}),
						$author$project$Ports$import_(
							{p: accountDetails.p, f: password, be: accountDetails.be}));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$Ports$alert('Wrong application state: no password.'));
				}
			} else {
				var _v2 = maybeReply.a;
				return $author$project$OctoVault$goHome(model);
			}
		}
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $Chadtech$return$Return3$incorp = F3(
	function (f, model_, _v0) {
		var subModel = _v0.a;
		var cmd_ = _v0.b;
		var reply_ = _v0.c;
		return A2(
			$Chadtech$return$Return2$addCmd,
			cmd_,
			A3(f, subModel, reply_, model_));
	});
var $author$project$Page$Create$init = _Utils_Tuple2(
	{p: ''},
	$elm$core$Platform$Cmd$none);
var $author$project$Page$GasRelay$NotConfirmed = {$: 0};
var $author$project$Page$GasRelay$init = _Utils_Tuple2(
	{k: $elm$core$Maybe$Nothing, A: $author$project$Page$GasRelay$NotConfirmed, ac: $elm$core$Maybe$Nothing, ae: 0, q: $elm$core$Dict$empty, m: 0},
	$elm$core$Platform$Cmd$none);
var $author$project$Page$Import$init = _Utils_Tuple2(
	{p: '', be: ''},
	$elm$core$Platform$Cmd$none);
var $author$project$Page$Sign$init = F2(
	function (requestId, message) {
		return _Utils_Tuple2(
			{aq: message, ac: requestId},
			$elm$core$Platform$Cmd$none);
	});
var $turboMaCk$any_dict$Dict$Any$insert = F3(
	function (k, v, _v0) {
		var inner = _v0;
		return _Utils_update(
			inner,
			{
				a: A3(
					$elm$core$Dict$insert,
					inner.B(k),
					_Utils_Tuple2(k, v),
					inner.a)
			});
	});
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$OctoVault$isOperationAllowed = function (model) {
	var validPage = function (page) {
		switch (page.$) {
			case 0:
				return false;
			case 4:
				return false;
			case 3:
				return true;
			case 1:
				return true;
			case 2:
				return true;
			case 5:
				return true;
			default:
				return true;
		}
	}(model.b2);
	var selectedAccount = model.b7.t;
	var validAccount = function () {
		if (!selectedAccount.$) {
			return true;
		} else {
			return false;
		}
	}();
	return validAccount && validPage;
};
var $author$project$Ports$log = _Platform_outgoingPort('log', $elm$json$Json$Encode$string);
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $Chadtech$return$Return2$mapCmd = function (f) {
	return $elm$core$Tuple$mapSecond(
		$elm$core$Platform$Cmd$map(f));
};
var $Chadtech$return$Return3$mapCmd = F2(
	function (f, _v0) {
		var model_ = _v0.a;
		var cmd_ = _v0.b;
		var reply_ = _v0.c;
		return _Utils_Tuple3(
			model_,
			A2($elm$core$Platform$Cmd$map, f, cmd_),
			reply_);
	});
var $author$project$PostMessage$messageAccount = 'octovault-account';
var $author$project$PostMessage$messageClose = 'octovault-close';
var $author$project$PostMessage$messageOpen = 'octovault-open';
var $author$project$PostMessage$messageSigned = 'octovault-signed';
var $author$project$Components$notBusyAnymore = function (x) {
	return _Utils_update(
		x,
		{bB: false});
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Ports$open = _Platform_outgoingPort(
	'open',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'keystore',
					$elm$json$Json$Encode$string($.W)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.p)),
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string($.f))
				]));
	});
var $author$project$OctoVault$encodeSSPData = function (sspData) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$string(sspData.bS)),
				_Utils_Tuple2(
				'salt',
				$elm$json$Json$Encode$string(sspData.b5))
			]));
};
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$http$Http$post = function (r) {
	return $elm$http$Http$request(
		{ay: r.ay, a3: r.a3, bM: _List_Nil, bU: 'POST', ce: $elm$core$Maybe$Nothing, cg: $elm$core$Maybe$Nothing, bs: r.bs});
};
var $author$project$OctoVault$postSSPData = F2(
	function (msg, sspData) {
		return $elm$http$Http$post(
			{
				ay: $elm$http$Http$jsonBody(
					$author$project$OctoVault$encodeSSPData(sspData)),
				a3: $elm$http$Http$expectWhatever(msg),
				bs: $author$project$Constants$secureSessionProviderUrl
			});
	});
var $turboMaCk$any_dict$Dict$Any$remove = F2(
	function (k, _v0) {
		var inner = _v0;
		return _Utils_update(
			inner,
			{
				a: A2(
					$elm$core$Dict$remove,
					inner.B(k),
					inner.a)
			});
	});
var $author$project$Ports$signOnJs = _Platform_outgoingPort(
	'signOnJs',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$int(a),
					$elm$core$Basics$identity(b)
				]));
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$random$Random$andThen = F2(
	function (callback, _v0) {
		var genA = _v0;
		return function (seed) {
			var _v1 = genA(seed);
			var result = _v1.a;
			var newSeed = _v1.b;
			var _v2 = callback(result);
			var genB = _v2;
			return genB(newSeed);
		};
	});
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$float = F2(
	function (a, b) {
		return function (seed0) {
			var seed1 = $elm$random$Random$next(seed0);
			var range = $elm$core$Basics$abs(b - a);
			var n1 = $elm$random$Random$peel(seed1);
			var n0 = $elm$random$Random$peel(seed0);
			var lo = (134217727 & n1) * 1.0;
			var hi = (67108863 & n0) * 1.0;
			var val = ((hi * 134217728.0) + lo) / 9007199254740992.0;
			var scaled = (val * range) + a;
			return _Utils_Tuple2(
				scaled,
				$elm$random$Random$next(seed1));
		};
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm_community$random_extra$Random$Extra$frequency = F2(
	function (head, pairs) {
		var total = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeL, $elm$core$Basics$abs, $elm$core$Tuple$first),
				A2($elm$core$List$cons, head, pairs)));
		var pick = F2(
			function (someChoices, n) {
				pick:
				while (true) {
					if (someChoices.b) {
						var _v1 = someChoices.a;
						var k = _v1.a;
						var g = _v1.b;
						var rest = someChoices.b;
						if (_Utils_cmp(n, k) < 1) {
							return g;
						} else {
							var $temp$someChoices = rest,
								$temp$n = n - k;
							someChoices = $temp$someChoices;
							n = $temp$n;
							continue pick;
						}
					} else {
						return head.b;
					}
				}
			});
		return A2(
			$elm$random$Random$andThen,
			pick(
				A2($elm$core$List$cons, head, pairs)),
			A2($elm$random$Random$float, 0, total));
	});
var $elm_community$random_extra$Random$Extra$choices = F2(
	function (hd, gens) {
		return A2(
			$elm_community$random_extra$Random$Extra$frequency,
			_Utils_Tuple2(1, hd),
			A2(
				$elm$core$List$map,
				function (g) {
					return _Utils_Tuple2(1, g);
				},
				gens));
	});
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$random$Random$int = F2(
	function (a, b) {
		return function (seed0) {
			var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _v0.a;
			var hi = _v0.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo,
					$elm$random$Random$next(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = $elm$random$Random$peel(seed);
						var seedN = $elm$random$Random$next(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var $elm_community$random_extra$Random$Char$char = F2(
	function (start, end) {
		return A2(
			$elm$random$Random$map,
			$elm$core$Char$fromCode,
			A2($elm$random$Random$int, start, end));
	});
var $elm_community$random_extra$Random$Char$lowerCaseLatin = A2($elm_community$random_extra$Random$Char$char, 97, 122);
var $elm_community$random_extra$Random$Char$upperCaseLatin = A2($elm_community$random_extra$Random$Char$char, 65, 90);
var $elm_community$random_extra$Random$Char$latin = A2(
	$elm_community$random_extra$Random$Extra$choices,
	$elm_community$random_extra$Random$Char$lowerCaseLatin,
	_List_fromArray(
		[$elm_community$random_extra$Random$Char$upperCaseLatin]));
var $elm_community$random_extra$Random$Char$english = $elm_community$random_extra$Random$Char$latin;
var $elm$random$Random$map2 = F3(
	function (func, _v0, _v1) {
		var genA = _v0;
		var genB = _v1;
		return function (seed0) {
			var _v2 = genA(seed0);
			var a = _v2.a;
			var seed1 = _v2.b;
			var _v3 = genB(seed1);
			var b = _v3.a;
			var seed2 = _v3.b;
			return _Utils_Tuple2(
				A2(func, a, b),
				seed2);
		};
	});
var $elm$random$Random$listHelp = F4(
	function (revList, n, gen, seed) {
		listHelp:
		while (true) {
			if (n < 1) {
				return _Utils_Tuple2(revList, seed);
			} else {
				var _v0 = gen(seed);
				var value = _v0.a;
				var newSeed = _v0.b;
				var $temp$revList = A2($elm$core$List$cons, value, revList),
					$temp$n = n - 1,
					$temp$gen = gen,
					$temp$seed = newSeed;
				revList = $temp$revList;
				n = $temp$n;
				gen = $temp$gen;
				seed = $temp$seed;
				continue listHelp;
			}
		}
	});
var $elm$random$Random$list = F2(
	function (n, _v0) {
		var gen = _v0;
		return function (seed) {
			return A4($elm$random$Random$listHelp, _List_Nil, n, gen, seed);
		};
	});
var $elm_community$random_extra$Random$String$string = F2(
	function (stringLength, charGenerator) {
		return A2(
			$elm$random$Random$map,
			$elm$core$String$fromList,
			A2($elm$random$Random$list, stringLength, charGenerator));
	});
var $author$project$OctoVault$sspDataGenerator = A3(
	$elm$random$Random$map2,
	$author$project$Model$SSPData,
	A2($elm_community$random_extra$Random$String$string, 32, $elm_community$random_extra$Random$Char$english),
	A2($elm_community$random_extra$Random$String$string, 200, $elm_community$random_extra$Random$Char$english));
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $francescortiz$elm_queue$Queue$startUnkeyed = function (_v0) {
	var queue = _v0;
	var poolSize = queue.ab;
	var availableLanes = A2(
		$elm$core$Basics$max,
		0,
		function (l_) {
			return poolSize - l_;
		}(
			$elm$core$List$length(queue.j)));
	var _v1 = function (_v2) {
		var a = _v2.a;
		var b = _v2.b;
		return _Utils_Tuple2(
			a,
			$elm$core$List$reverse(b));
	}(
		A2(
			$elm_community$list_extra$List$Extra$splitAt,
			availableLanes,
			$elm$core$List$reverse(queue.g)));
	var newLanes = _v1.a;
	var newBacklog = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			queue,
			{g: newBacklog}),
		newLanes);
};
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $author$project$Session$encodeAccount = function (account) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(account.p)),
				_Utils_Tuple2(
				'address',
				$author$project$EthereumAddress$encode(account.aF)),
				_Utils_Tuple2(
				'keystore',
				$elm$json$Json$Encode$string(account.W))
			]));
};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $turboMaCk$any_dict$Dict$Any$toDict = function (_v0) {
	var dict = _v0.a;
	return A2(
		$elm$core$Dict$map,
		$elm$core$Basics$always($elm$core$Tuple$second),
		dict);
};
var $author$project$Session$encodeAccounts = function (accountsDict) {
	return A3(
		$elm$json$Json$Encode$dict,
		$elm$core$Basics$identity,
		$author$project$Session$encodeAccount,
		$turboMaCk$any_dict$Dict$Any$toDict(accountsDict));
};
var $author$project$Session$encodeStorage = function (storage) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'accounts',
				$author$project$Session$encodeAccounts(storage.i)),
				_Utils_Tuple2(
				'selectedAccount',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $author$project$EthereumAddress$encode, storage.t)))
			]));
};
var $author$project$Ports$store = _Platform_outgoingPort('store', $elm$json$Json$Encode$string);
var $author$project$OctoVault$storeStorage = function (session) {
	return $author$project$Ports$store(
		A2(
			$elm$json$Json$Encode$encode,
			0,
			$author$project$Session$encodeStorage(
				{i: session.i, t: session.t})));
};
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var $turboMaCk$any_dict$Dict$Any$toList = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$values(dict);
};
var $turboMaCk$any_dict$Dict$Any$values = A2(
	$elm$core$Basics$composeL,
	$elm$core$List$map($elm$core$Tuple$second),
	$turboMaCk$any_dict$Dict$Any$toList);
var $author$project$OctoVault$unlockAccount = F2(
	function (password, model) {
		var session = model.b7;
		var newSession = _Utils_update(
			session,
			{
				bB: true,
				f: $elm$core$Maybe$Just(password)
			});
		var accounts = newSession.i;
		var fallbackAccount = $elm$core$List$head(
			$turboMaCk$any_dict$Dict$Any$values(accounts));
		var account_ = function () {
			var _v1 = newSession.t;
			if (!_v1.$) {
				var acc = _v1.a;
				return A2(
					$elm_community$maybe_extra$Maybe$Extra$orElse,
					fallbackAccount,
					A2($turboMaCk$any_dict$Dict$Any$get, acc, accounts));
			} else {
				return fallbackAccount;
			}
		}();
		if (!account_.$) {
			var account = account_.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{b7: newSession}),
				$author$project$Ports$open(
					{W: account.W, p: account.p, f: password}));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $turboMaCk$any_dict$Dict$Any$update = F3(
	function (k, f, _v0) {
		var inner = _v0;
		var updateDict = A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Maybe$map(
					function (b) {
						return _Utils_Tuple2(k, b);
					}),
				f),
			$elm$core$Maybe$map($elm$core$Tuple$second));
		return _Utils_update(
			inner,
			{
				a: A3(
					$elm$core$Dict$update,
					inner.B(k),
					updateDict,
					inner.a)
			});
	});
var $author$project$Page$Create$CreateAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Create$GoToHome = {$: 1};
var $rtfeldman$elm_validate$Validate$Validator = $elm$core$Basics$identity;
var $rtfeldman$elm_validate$Validate$all = function (validators) {
	var newGetErrors = function (subject) {
		var accumulateErrors = F2(
			function (_v0, totalErrors) {
				var getErrors = _v0;
				return _Utils_ap(
					totalErrors,
					getErrors(subject));
			});
		return A3($elm$core$List$foldl, accumulateErrors, _List_Nil, validators);
	};
	return newGetErrors;
};
var $rtfeldman$elm_validate$Validate$ifTrue = F2(
	function (test, error) {
		var getErrors = function (subject) {
			return test(subject) ? _List_fromArray(
				[error]) : _List_Nil;
		};
		return getErrors;
	});
var $rtfeldman$elm_validate$Validate$isWhitespaceChar = function (_char) {
	return (_char === ' ') || ((_char === '\n') || ((_char === '\t') || (_char === '\u000D')));
};
var $rtfeldman$elm_validate$Validate$isBlank = function (str) {
	isBlank:
	while (true) {
		var _v0 = $elm$core$String$uncons(str);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var _char = _v1.a;
			var rest = _v1.b;
			if ($rtfeldman$elm_validate$Validate$isWhitespaceChar(_char)) {
				var $temp$str = rest;
				str = $temp$str;
				continue isBlank;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
};
var $rtfeldman$elm_validate$Validate$ifBlank = F2(
	function (subjectToString, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return $rtfeldman$elm_validate$Validate$isBlank(
					subjectToString(subject));
			},
			error);
	});
var $author$project$Page$Create$formValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.p;
			},
			'Please enter a name.')
		]));
var $rtfeldman$elm_validate$Validate$fromValid = function (_v0) {
	var subject = _v0;
	return subject;
};
var $rtfeldman$elm_validate$Validate$Valid = $elm$core$Basics$identity;
var $rtfeldman$elm_validate$Validate$validate = F2(
	function (_v0, subject) {
		var getErrors = _v0;
		var _v1 = getErrors(subject);
		if (!_v1.b) {
			return $elm$core$Result$Ok(subject);
		} else {
			var errors = _v1;
			return $elm$core$Result$Err(errors);
		}
	});
var $Chadtech$return$Return3$withNoReply = function (_v0) {
	var model_ = _v0.a;
	var cmd_ = _v0.b;
	return _Utils_Tuple3(model_, cmd_, $elm$core$Maybe$Nothing);
};
var $Chadtech$return$Return3$withReply = F2(
	function (reply_, _v0) {
		var model_ = _v0.a;
		var cmd_ = _v0.b;
		return _Utils_Tuple3(
			model_,
			cmd_,
			$elm$core$Maybe$Just(reply_));
	});
var $author$project$Page$Create$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				var name = msg.a;
				return $Chadtech$return$Return3$withNoReply(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{p: name}),
						$elm$core$Platform$Cmd$none));
			case 1:
				var validateResult = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Page$Create$formValidator, model);
				if (!validateResult.$) {
					var validSubject = validateResult.a;
					var subject = $rtfeldman$elm_validate$Validate$fromValid(validSubject);
					var accountData = function (s) {
						return {p: s.p};
					}(subject);
					return A2(
						$Chadtech$return$Return3$withReply,
						$author$project$Page$Create$CreateAccount(accountData),
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				} else {
					var errors = validateResult.a;
					return $Chadtech$return$Return3$withNoReply(
						_Utils_Tuple2(
							model,
							A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Maybe$map,
									$author$project$Ports$alert,
									$elm$core$List$head(errors)))));
				}
			default:
				return A2(
					$Chadtech$return$Return3$withReply,
					$author$project$Page$Create$GoToHome,
					$Chadtech$return$Return2$withNoCmd(model));
		}
	});
var $author$project$Page$GasRelay$Close = {$: 1};
var $author$project$Page$GasRelay$Error = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$GasRelay$ExecuteSignedResponse = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Page$GasRelay$Open = {$: 0};
var $author$project$Page$GasRelay$Sent = {$: 1};
var $author$project$Page$GasRelay$Terminated = {$: 2};
var $author$project$Page$GasRelay$getComposedTransactions = _Platform_outgoingPort('getComposedTransactions', $elm$core$Basics$identity);
var $author$project$Page$GasRelay$NonceResponse = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $cmditch$elm_bigint$BigInt$BigIntNotNormalised = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $cmditch$elm_bigint$BigInt$MagnitudeNotNormalised = $elm$core$Basics$identity;
var $cmditch$elm_bigint$BigInt$Positive = 0;
var $cmditch$elm_bigint$BigInt$Magnitude = $elm$core$Basics$identity;
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $cmditch$elm_bigint$BigInt$isNegativeMagnitude = function (digits) {
	var _v0 = $elm_community$list_extra$List$Extra$last(digits);
	if (_v0.$ === 1) {
		return false;
	} else {
		var x = _v0.a;
		return x < 0;
	}
};
var $cmditch$elm_bigint$BigInt$Neg = function (a) {
	return {$: 1, a: a};
};
var $cmditch$elm_bigint$BigInt$Pos = function (a) {
	return {$: 0, a: a};
};
var $cmditch$elm_bigint$BigInt$Zer = {$: 2};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $cmditch$elm_bigint$BigInt$mkBigInt = F2(
	function (s, mag) {
		var digits = mag;
		if ($elm$core$List$isEmpty(digits)) {
			return $cmditch$elm_bigint$BigInt$Zer;
		} else {
			switch (s) {
				case 2:
					return $cmditch$elm_bigint$BigInt$Zer;
				case 0:
					return $cmditch$elm_bigint$BigInt$Pos(mag);
				default:
					return $cmditch$elm_bigint$BigInt$Neg(mag);
			}
		}
	});
var $cmditch$elm_bigint$BigInt$mkBigIntNotNormalised = F2(
	function (s, digits) {
		return A2($cmditch$elm_bigint$BigInt$BigIntNotNormalised, s, digits);
	});
var $elm_community$list_extra$List$Extra$dropWhileRight = function (p) {
	return A2(
		$elm$core$List$foldr,
		F2(
			function (x, xs) {
				return (p(x) && $elm$core$List$isEmpty(xs)) ? _List_Nil : A2($elm$core$List$cons, x, xs);
			}),
		_List_Nil);
};
var $cmditch$elm_bigint$BigInt$dropZeroes = $elm_community$list_extra$List$Extra$dropWhileRight(
	$elm$core$Basics$eq(0));
var $cmditch$elm_bigint$Constants$maxDigitMagnitude = 7;
var $cmditch$elm_bigint$Constants$maxDigitValue = (-1) + A2($elm$core$Basics$pow, 10, $cmditch$elm_bigint$Constants$maxDigitMagnitude);
var $cmditch$elm_bigint$BigInt$baseDigit = $cmditch$elm_bigint$Constants$maxDigitValue + 1;
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $cmditch$elm_bigint$BigInt$normaliseDigit = function (x) {
	return (x < 0) ? A2(
		$elm$core$Tuple$mapFirst,
		$elm$core$Basics$add(-1),
		$cmditch$elm_bigint$BigInt$normaliseDigit(x + $cmditch$elm_bigint$BigInt$baseDigit)) : _Utils_Tuple2((x / $cmditch$elm_bigint$BigInt$baseDigit) | 0, x % $cmditch$elm_bigint$BigInt$baseDigit);
};
var $cmditch$elm_bigint$BigInt$normaliseDigitList = F2(
	function (carry, xs) {
		normaliseDigitList:
		while (true) {
			if (!xs.b) {
				if (_Utils_cmp(carry, $cmditch$elm_bigint$BigInt$baseDigit) > 0) {
					var $temp$carry = 0,
						$temp$xs = _List_fromArray(
						[carry]);
					carry = $temp$carry;
					xs = $temp$xs;
					continue normaliseDigitList;
				} else {
					return _List_fromArray(
						[carry]);
				}
			} else {
				var x = xs.a;
				var xs_ = xs.b;
				var _v1 = $cmditch$elm_bigint$BigInt$normaliseDigit(x + carry);
				var newCarry = _v1.a;
				var x_ = _v1.b;
				return A2(
					$elm$core$List$cons,
					x_,
					A2($cmditch$elm_bigint$BigInt$normaliseDigitList, newCarry, xs_));
			}
		}
	});
var $cmditch$elm_bigint$BigInt$normaliseMagnitude = function (_v0) {
	var xs = _v0;
	return $cmditch$elm_bigint$BigInt$dropZeroes(
		A2($cmditch$elm_bigint$BigInt$normaliseDigitList, 0, xs));
};
var $cmditch$elm_bigint$BigInt$reverseMagnitude = $elm$core$List$map($elm$core$Basics$negate);
var $cmditch$elm_bigint$BigInt$Negative = 1;
var $cmditch$elm_bigint$BigInt$Zero = 2;
var $cmditch$elm_bigint$BigInt$signNegate = function (sign_) {
	switch (sign_) {
		case 0:
			return 1;
		case 1:
			return 0;
		default:
			return 2;
	}
};
var $cmditch$elm_bigint$BigInt$normalise = function (_v0) {
	normalise:
	while (true) {
		var s = _v0.a;
		var digits = _v0.b;
		var _v1 = $cmditch$elm_bigint$BigInt$normaliseMagnitude(digits);
		var normalisedMag = _v1;
		if ($cmditch$elm_bigint$BigInt$isNegativeMagnitude(normalisedMag)) {
			var $temp$_v0 = A2(
				$cmditch$elm_bigint$BigInt$mkBigIntNotNormalised,
				$cmditch$elm_bigint$BigInt$signNegate(s),
				$cmditch$elm_bigint$BigInt$reverseMagnitude(normalisedMag));
			_v0 = $temp$_v0;
			continue normalise;
		} else {
			return A2($cmditch$elm_bigint$BigInt$mkBigInt, s, normalisedMag);
		}
	}
};
var $cmditch$elm_bigint$BigInt$MagnitudePair = $elm$core$Basics$identity;
var $cmditch$elm_bigint$BigInt$sameSizeRaw = F2(
	function (xs, ys) {
		var _v0 = _Utils_Tuple2(xs, ys);
		if (!_v0.a.b) {
			if (!_v0.b.b) {
				return _List_Nil;
			} else {
				var _v2 = _v0.b;
				var y = _v2.a;
				var ys_ = _v2.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(0, y),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, _List_Nil, ys_));
			}
		} else {
			if (!_v0.b.b) {
				var _v1 = _v0.a;
				var x = _v1.a;
				var xs_ = _v1.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(x, 0),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs_, _List_Nil));
			} else {
				var _v3 = _v0.a;
				var x = _v3.a;
				var xs_ = _v3.b;
				var _v4 = _v0.b;
				var y = _v4.a;
				var ys_ = _v4.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(x, y),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs_, ys_));
			}
		}
	});
var $cmditch$elm_bigint$BigInt$sameSizeNotNormalized = F2(
	function (_v0, _v1) {
		var xs = _v0;
		var ys = _v1;
		return A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs, ys);
	});
var $cmditch$elm_bigint$BigInt$toPositiveSign = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return A2($cmditch$elm_bigint$BigInt$mkBigIntNotNormalised, 2, _List_Nil);
		case 1:
			var digits = bigInt.a;
			return A2(
				$cmditch$elm_bigint$BigInt$mkBigIntNotNormalised,
				0,
				$cmditch$elm_bigint$BigInt$reverseMagnitude(digits));
		default:
			var digits = bigInt.a;
			return A2($cmditch$elm_bigint$BigInt$mkBigIntNotNormalised, 0, digits);
	}
};
var $cmditch$elm_bigint$BigInt$add = F2(
	function (a, b) {
		var _v0 = $cmditch$elm_bigint$BigInt$toPositiveSign(b);
		var mb = _v0.b;
		var _v1 = $cmditch$elm_bigint$BigInt$toPositiveSign(a);
		var ma = _v1.b;
		var _v2 = A2($cmditch$elm_bigint$BigInt$sameSizeNotNormalized, ma, mb);
		var pairs = _v2;
		var added = A2(
			$elm$core$List$map,
			function (_v3) {
				var a_ = _v3.a;
				var b_ = _v3.b;
				return a_ + b_;
			},
			pairs);
		return $cmditch$elm_bigint$BigInt$normalise(
			A2($cmditch$elm_bigint$BigInt$BigIntNotNormalised, 0, added));
	});
var $elm_community$maybe_extra$Maybe$Extra$traverse = function (f) {
	var step = F2(
		function (e, acc) {
			var _v0 = f(e);
			if (_v0.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = _v0.a;
				return A2(
					$elm$core$Maybe$map,
					$elm$core$List$cons(x),
					acc);
			}
		});
	return A2(
		$elm$core$List$foldr,
		step,
		$elm$core$Maybe$Just(_List_Nil));
};
var $elm_community$maybe_extra$Maybe$Extra$combine = $elm_community$maybe_extra$Maybe$Extra$traverse($elm$core$Basics$identity);
var $cmditch$elm_bigint$BigInt$signFromInt = function (x) {
	var _v0 = A2($elm$core$Basics$compare, x, 0);
	switch (_v0) {
		case 0:
			return 1;
		case 2:
			return 0;
		default:
			return 2;
	}
};
var $cmditch$elm_bigint$BigInt$fromInt = function (x) {
	return $cmditch$elm_bigint$BigInt$normalise(
		A2(
			$cmditch$elm_bigint$BigInt$BigIntNotNormalised,
			$cmditch$elm_bigint$BigInt$signFromInt(x),
			_List_fromArray(
				[
					$elm$core$Basics$abs(x)
				])));
};
var $cmditch$elm_bigint$BigInt$magnitude = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return _List_Nil;
		case 0:
			var mag = bigInt.a;
			return mag;
		default:
			var mag = bigInt.a;
			return mag;
	}
};
var $cmditch$elm_bigint$BigInt$mulSingleDigit = F2(
	function (_v0, d) {
		var xs = _v0;
		return $cmditch$elm_bigint$BigInt$normaliseMagnitude(
			A2(
				$elm$core$List$map,
				$elm$core$Basics$mul(d),
				xs));
	});
var $cmditch$elm_bigint$BigInt$mulMagnitudes = F2(
	function (_v0, _v1) {
		var mag1 = _v0;
		var mag2 = _v1;
		if (!mag1.b) {
			return _List_Nil;
		} else {
			if (!mag1.b.b) {
				var m = mag1.a;
				return A2($cmditch$elm_bigint$BigInt$mulSingleDigit, mag2, m);
			} else {
				var m = mag1.a;
				var mx = mag1.b;
				var accum = A2($cmditch$elm_bigint$BigInt$mulSingleDigit, mag2, m);
				var _v3 = A2($cmditch$elm_bigint$BigInt$mulMagnitudes, mx, mag2);
				var rest = _v3;
				var bigInt = A2(
					$cmditch$elm_bigint$BigInt$add,
					A2($cmditch$elm_bigint$BigInt$mkBigInt, 0, accum),
					A2(
						$cmditch$elm_bigint$BigInt$mkBigInt,
						0,
						A2($elm$core$List$cons, 0, rest)));
				return $cmditch$elm_bigint$BigInt$magnitude(bigInt);
			}
		}
	});
var $cmditch$elm_bigint$BigInt$sign = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return 2;
		case 0:
			return 0;
		default:
			return 1;
	}
};
var $cmditch$elm_bigint$BigInt$signProduct = F2(
	function (x, y) {
		return ((x === 2) || (y === 2)) ? 2 : (_Utils_eq(x, y) ? 0 : 1);
	});
var $cmditch$elm_bigint$BigInt$mul = F2(
	function (int1, int2) {
		return A2(
			$cmditch$elm_bigint$BigInt$mkBigInt,
			A2(
				$cmditch$elm_bigint$BigInt$signProduct,
				$cmditch$elm_bigint$BigInt$sign(int1),
				$cmditch$elm_bigint$BigInt$sign(int2)),
			A2(
				$cmditch$elm_bigint$BigInt$mulMagnitudes,
				$cmditch$elm_bigint$BigInt$magnitude(int1),
				$cmditch$elm_bigint$BigInt$magnitude(int2)));
	});
var $cmditch$elm_bigint$BigInt$eightHexDigits = A2(
	$cmditch$elm_bigint$BigInt$mul,
	$cmditch$elm_bigint$BigInt$fromInt(2),
	$cmditch$elm_bigint$BigInt$fromInt(2147483648));
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, xs) {
		var xs_ = A2($elm$core$List$drop, step, xs);
		var okayXs = $elm$core$List$length(xs) > 0;
		var okayArgs = (size > 0) && (step > 0);
		return (okayArgs && okayXs) ? A2(
			$elm$core$List$cons,
			A2($elm$core$List$take, size, xs),
			A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, step, xs_)) : _List_Nil;
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $cmditch$elm_bigint$Constants$hexDigitMagnitude = 8;
var $cmditch$elm_bigint$BigInt$zero = $cmditch$elm_bigint$BigInt$fromInt(0);
var $cmditch$elm_bigint$BigInt$fromHexString_ = function (x) {
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$reverse,
			A2(
				$elm$core$List$foldl,
				F2(
					function (e, s) {
						return A2(
							$cmditch$elm_bigint$BigInt$add,
							$cmditch$elm_bigint$BigInt$fromInt(e),
							A2($cmditch$elm_bigint$BigInt$mul, s, $cmditch$elm_bigint$BigInt$eightHexDigits));
					}),
				$cmditch$elm_bigint$BigInt$zero)),
		$elm_community$maybe_extra$Maybe$Extra$combine(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$reverse,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$fromList,
						A2($elm$core$Basics$composeR, $rtfeldman$elm_hex$Hex$fromString, $elm$core$Result$toMaybe))),
				A2(
					$elm_community$list_extra$List$Extra$greedyGroupsOf,
					$cmditch$elm_bigint$Constants$hexDigitMagnitude,
					$elm$core$List$reverse(x)))));
};
var $cmditch$elm_bigint$BigInt$fromHexString = function (x) {
	var _v0 = $elm$core$String$toList(
		$elm$core$String$toLower(x));
	_v0$9:
	while (true) {
		if (!_v0.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			switch (_v0.a) {
				case '-':
					if (_v0.b.b) {
						if ((('0' === _v0.b.a) && _v0.b.b.b) && ('x' === _v0.b.b.a)) {
							if (!_v0.b.b.b.b) {
								var _v1 = _v0.b;
								var _v2 = _v1.b;
								return $elm$core$Maybe$Nothing;
							} else {
								var _v3 = _v0.b;
								var _v4 = _v3.b;
								var xs = _v4.b;
								return A2(
									$elm$core$Maybe$map,
									$cmditch$elm_bigint$BigInt$mul(
										$cmditch$elm_bigint$BigInt$fromInt(-1)),
									$cmditch$elm_bigint$BigInt$fromHexString_(xs));
							}
						} else {
							var xs = _v0.b;
							return A2(
								$elm$core$Maybe$map,
								$cmditch$elm_bigint$BigInt$mul(
									$cmditch$elm_bigint$BigInt$fromInt(-1)),
								$cmditch$elm_bigint$BigInt$fromHexString_(xs));
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				case '+':
					if (!_v0.b.b) {
						return $elm$core$Maybe$Nothing;
					} else {
						var xs = _v0.b;
						return $cmditch$elm_bigint$BigInt$fromHexString_(xs);
					}
				case '0':
					if (_v0.b.b && ('x' === _v0.b.a)) {
						if (!_v0.b.b.b) {
							var _v5 = _v0.b;
							return $elm$core$Maybe$Nothing;
						} else {
							var _v6 = _v0.b;
							var xs = _v6.b;
							return $cmditch$elm_bigint$BigInt$fromHexString_(xs);
						}
					} else {
						break _v0$9;
					}
				default:
					break _v0$9;
			}
		}
	}
	var xs = _v0;
	return $cmditch$elm_bigint$BigInt$fromHexString_(xs);
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $cmditch$elm_bigint$BigInt$fillZeroes = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$String$padLeft, $cmditch$elm_bigint$Constants$maxDigitMagnitude, '0'),
	$elm$core$String$fromInt);
var $cmditch$elm_bigint$BigInt$revMagnitudeToString = function (_v0) {
	var digits = _v0;
	var _v1 = $elm$core$List$reverse(digits);
	if (!_v1.b) {
		return '0';
	} else {
		var x = _v1.a;
		var xs = _v1.b;
		return $elm$core$String$concat(
			A2(
				$elm$core$List$cons,
				$elm$core$String$fromInt(x),
				A2($elm$core$List$map, $cmditch$elm_bigint$BigInt$fillZeroes, xs)));
	}
};
var $cmditch$elm_bigint$BigInt$toString = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return '0';
		case 0:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$revMagnitudeToString(mag);
		default:
			var mag = bigInt.a;
			return '-' + $cmditch$elm_bigint$BigInt$revMagnitudeToString(mag);
	}
};
var $author$project$Page$GasRelay$bigIntToIntDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (v) {
		return function (i) {
			if (!i.$) {
				var i_ = i.a;
				return $elm$json$Json$Decode$succeed(i_);
			} else {
				return $elm$json$Json$Decode$fail(
					'The big number could not be converted to int: ' + $cmditch$elm_bigint$BigInt$toString(v));
			}
		}(
			$elm$core$String$toInt(
				$cmditch$elm_bigint$BigInt$toString(v)));
	},
	A2(
		$elm$json$Json$Decode$andThen,
		function (b) {
			if (!b.$) {
				var b_ = b.a;
				return $elm$json$Json$Decode$succeed(b_);
			} else {
				return $elm$json$Json$Decode$fail('Unable to convert hex string to big number');
			}
		},
		A2($elm$json$Json$Decode$map, $cmditch$elm_bigint$BigInt$fromHexString, $elm$json$Json$Decode$string)));
var $author$project$Page$GasRelay$getNonce = F2(
	function (session, request) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jsonrpc',
					$elm$json$Json$Encode$string('2.0')),
					_Utils_Tuple2(
					'method',
					$elm$json$Json$Encode$string(request.bU)),
					_Utils_Tuple2(
					'params',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'from',
								$elm$json$Json$Encode$string(request.Z.k))
							]))),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(request.U))
				]));
		return $elm$http$Http$post(
			{
				ay: $elm$http$Http$jsonBody(body),
				a3: A2(
					$elm$http$Http$expectJson,
					$author$project$Page$GasRelay$NonceResponse,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['result', '_hex']),
						$author$project$Page$GasRelay$bigIntToIntDecoder)),
				bs: session.a5
			});
	});
var $author$project$Page$GasRelay$getSignedTransactions = _Platform_outgoingPort(
	'getSignedTransactions',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Basics$identity(a),
					$elm$json$Json$Encode$int(b)
				]));
	});
var $author$project$Page$GasRelay$getTxDict = F2(
	function (txs, txId) {
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, a) {
						var newTxId = i + txId;
						return _Utils_Tuple2(
							newTxId,
							_Utils_update(
								a,
								{m: newTxId}));
					}),
				A2(
					$elm$core$List$filterMap,
					function (tx) {
						var _v0 = tx.u;
						switch (_v0.$) {
							case 1:
								return $elm$core$Maybe$Nothing;
							case 2:
								return $elm$core$Maybe$Nothing;
							case 0:
								return $elm$core$Maybe$Just(tx);
							default:
								return $elm$core$Maybe$Nothing;
						}
					},
					txs)));
	});
var $author$project$Page$GasRelay$Unsigned = {$: 0};
var $author$project$Page$GasRelay$getTxsFromMsg = function (incomingMsg) {
	var batch = incomingMsg.a_;
	return A2(
		$elm$core$List$map,
		function (tx) {
			return {
				ai: tx.ai,
				y: tx.y,
				am: '',
				P: tx.P,
				D: $elm$json$Json$Encode$null,
				R: tx.R,
				S: tx.S,
				k: $elm$core$Maybe$Nothing,
				T: $elm$core$Maybe$Nothing,
				aO: 0,
				aP: 0,
				aQ: '0x0000000000000000000000000000000000000000',
				ar: tx.ar,
				u: $author$project$Page$GasRelay$Unsigned,
				av: $elm$core$Maybe$Nothing,
				m: 0,
				aY: $cmditch$elm_bigint$BigInt$fromInt(0)
			};
		},
		batch);
};
var $author$project$Page$GasRelay$IncomingMsg = F2(
	function (batch, from) {
		return {a_: batch, k: from};
	});
var $author$project$Page$GasRelay$IncomingTx = F6(
	function (executionSource, executionTarget, operationType, abi, args, delegation) {
		return {ai: abi, y: args, P: delegation, R: executionSource, S: executionTarget, ar: operationType};
	});
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Page$GasRelay$BigInt = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$GasRelay$BigIntList = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$GasRelay$Bool = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$GasRelay$BoolList = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$GasRelay$EthereumAddress = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$GasRelay$EthereumAddressList = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$GasRelay$Int = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$GasRelay$IntList = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$GasRelay$String = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$GasRelay$StringList = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$GasRelay$bigIntDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (b) {
		if (!b.$) {
			var b_ = b.a;
			return $elm$json$Json$Decode$succeed(b_);
		} else {
			return $elm$json$Json$Decode$fail('Unable to convert hex string to big number');
		}
	},
	A2($elm$json$Json$Decode$map, $cmditch$elm_bigint$BigInt$fromHexString, $elm$json$Json$Decode$string));
var $author$project$Page$GasRelay$solidityArgumentsDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$Page$GasRelay$Int, $elm$json$Json$Decode$int),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Page$GasRelay$IntList,
			$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
			A2($elm$json$Json$Decode$map, $author$project$Page$GasRelay$String, $elm$json$Json$Decode$string),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Page$GasRelay$StringList,
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
			A2($elm$json$Json$Decode$map, $author$project$Page$GasRelay$EthereumAddress, $author$project$EthereumAddress$decoder),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Page$GasRelay$EthereumAddressList,
			$elm$json$Json$Decode$list($author$project$EthereumAddress$decoder)),
			A2($elm$json$Json$Decode$map, $author$project$Page$GasRelay$BigInt, $author$project$Page$GasRelay$bigIntDecoder),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Page$GasRelay$BigIntList,
			$elm$json$Json$Decode$list($author$project$Page$GasRelay$bigIntDecoder)),
			A2($elm$json$Json$Decode$map, $author$project$Page$GasRelay$Bool, $elm$json$Json$Decode$bool),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Page$GasRelay$BoolList,
			$elm$json$Json$Decode$list($elm$json$Json$Decode$bool))
		]));
var $author$project$Page$GasRelay$incomingTxDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'delegation',
	$elm$json$Json$Decode$list($author$project$EthereumAddress$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'args',
		$elm$json$Json$Decode$list($author$project$Page$GasRelay$solidityArgumentsDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'abi',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'operationType',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'executionTarget',
					$author$project$EthereumAddress$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'executionSource',
						$author$project$EthereumAddress$decoder,
						$elm$json$Json$Decode$succeed($author$project$Page$GasRelay$IncomingTx)))))));
var $author$project$Page$GasRelay$incomingTxsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'from',
	$author$project$EthereumAddress$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'batch',
		$elm$json$Json$Decode$list($author$project$Page$GasRelay$incomingTxDecoder),
		$elm$json$Json$Decode$succeed($author$project$Page$GasRelay$IncomingMsg)));
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Page$GasRelay$returnErrorMessage = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return 'The URL ' + (url + ' was invalid.');
		case 1:
			return 'Unable to reach the gas-relay, try again.';
		case 2:
			return 'Unable to reach the gas-relay, check the network connection.';
		case 3:
			switch (error.a) {
				case 500:
					return 'The gas-relay had a problem, try again later.';
				case 400:
					return 'Verify your information and try again.';
				default:
					return 'Unknown error';
			}
		default:
			var errorMessage = error.a;
			return errorMessage;
	}
};
var $author$project$Page$GasRelay$TransactionResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$GasRelay$jsonRpcRequestEncoder = F3(
	function (method, requestId, paramsValue) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jsonrpc',
					$elm$json$Json$Encode$string('2.0')),
					_Utils_Tuple2(
					'method',
					$elm$json$Json$Encode$string(method)),
					_Utils_Tuple2(
					'params',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2('batch', paramsValue)
							]))),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(requestId))
				]));
	});
var $cmditch$elm_bigint$BigInt$bigIntToInt_ = function (bigInt) {
	_v0$3:
	while (true) {
		switch (bigInt.$) {
			case 2:
				return 0;
			case 0:
				if (bigInt.a.b) {
					if (!bigInt.a.b.b) {
						var _v1 = bigInt.a;
						var a = _v1.a;
						return a;
					} else {
						if (!bigInt.a.b.b.b) {
							var _v2 = bigInt.a;
							var a = _v2.a;
							var _v3 = _v2.b;
							var b = _v3.a;
							return (b * A2($elm$core$Basics$pow, 10, $cmditch$elm_bigint$Constants$maxDigitMagnitude)) + a;
						} else {
							break _v0$3;
						}
					}
				} else {
					break _v0$3;
				}
			default:
				break _v0$3;
		}
	}
	return 42;
};
var $cmditch$elm_bigint$BigInt$abs = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return $cmditch$elm_bigint$BigInt$Zer;
		case 1:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Pos(mag);
		default:
			var i = bigInt;
			return i;
	}
};
var $cmditch$elm_bigint$BigInt$compareMagnitude = F4(
	function (x, y, xs, ys) {
		compareMagnitude:
		while (true) {
			var _v0 = _Utils_Tuple2(xs, ys);
			if (!_v0.a.b) {
				if (!_v0.b.b) {
					return A2($elm$core$Basics$compare, x, y);
				} else {
					return 0;
				}
			} else {
				if (!_v0.b.b) {
					return 2;
				} else {
					var _v1 = _v0.a;
					var x_ = _v1.a;
					var xss = _v1.b;
					var _v2 = _v0.b;
					var y_ = _v2.a;
					var yss = _v2.b;
					if (_Utils_eq(x_, y_)) {
						var $temp$x = x,
							$temp$y = y,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					} else {
						var $temp$x = x_,
							$temp$y = y_,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					}
				}
			}
		}
	});
var $cmditch$elm_bigint$BigInt$orderNegate = function (x) {
	switch (x) {
		case 0:
			return 2;
		case 1:
			return 1;
		default:
			return 0;
	}
};
var $cmditch$elm_bigint$BigInt$compare = F2(
	function (int1, int2) {
		var _v0 = _Utils_Tuple2(int1, int2);
		switch (_v0.a.$) {
			case 0:
				if (!_v0.b.$) {
					var mag1 = _v0.a.a;
					var mag2 = _v0.b.a;
					return A4($cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag1, mag2);
				} else {
					return 2;
				}
			case 1:
				if (_v0.b.$ === 1) {
					var mag1 = _v0.a.a;
					var mag2 = _v0.b.a;
					return $cmditch$elm_bigint$BigInt$orderNegate(
						A4($cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag1, mag2));
				} else {
					return 0;
				}
			default:
				switch (_v0.b.$) {
					case 0:
						var _v1 = _v0.a;
						return 0;
					case 2:
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return 1;
					default:
						var _v4 = _v0.a;
						return 2;
				}
		}
	});
var $cmditch$elm_bigint$BigInt$gt = F2(
	function (x, y) {
		return A2($cmditch$elm_bigint$BigInt$compare, x, y) === 2;
	});
var $cmditch$elm_bigint$BigInt$lte = F2(
	function (x, y) {
		return !A2($cmditch$elm_bigint$BigInt$gt, x, y);
	});
var $cmditch$elm_bigint$BigInt$negate = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return $cmditch$elm_bigint$BigInt$Zer;
		case 0:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Neg(mag);
		default:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Pos(mag);
	}
};
var $cmditch$elm_bigint$BigInt$sub = F2(
	function (a, b) {
		return A2(
			$cmditch$elm_bigint$BigInt$add,
			a,
			$cmditch$elm_bigint$BigInt$negate(b));
	});
var $cmditch$elm_bigint$BigInt$divmodDigit_ = F4(
	function (to_test, padding, num, den) {
		if (!to_test) {
			return _Utils_Tuple2($cmditch$elm_bigint$BigInt$zero, num);
		} else {
			var x = $cmditch$elm_bigint$BigInt$fromInt(to_test);
			var candidate = A2(
				$cmditch$elm_bigint$BigInt$mul,
				A2($cmditch$elm_bigint$BigInt$mul, x, den),
				padding);
			var _v0 = A2($cmditch$elm_bigint$BigInt$lte, candidate, num) ? _Utils_Tuple2(
				A2($cmditch$elm_bigint$BigInt$mul, x, padding),
				A2($cmditch$elm_bigint$BigInt$sub, num, candidate)) : _Utils_Tuple2($cmditch$elm_bigint$BigInt$zero, num);
			var newdiv = _v0.a;
			var newmod = _v0.b;
			var _v1 = A4($cmditch$elm_bigint$BigInt$divmodDigit_, (to_test / 2) | 0, padding, newmod, den);
			var restdiv = _v1.a;
			var restmod = _v1.b;
			return _Utils_Tuple2(
				A2($cmditch$elm_bigint$BigInt$add, newdiv, restdiv),
				restmod);
		}
	});
var $cmditch$elm_bigint$BigInt$maxDigitBits = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $cmditch$elm_bigint$Constants$maxDigitValue));
var $cmditch$elm_bigint$BigInt$divmodDigit = F3(
	function (padding, x, y) {
		return A4(
			$cmditch$elm_bigint$BigInt$divmodDigit_,
			A2($elm$core$Basics$pow, 2, $cmditch$elm_bigint$BigInt$maxDigitBits),
			padding,
			x,
			y);
	});
var $cmditch$elm_bigint$BigInt$one = $cmditch$elm_bigint$BigInt$fromInt(1);
var $cmditch$elm_bigint$BigInt$repeatedly = F3(
	function (f, x, n) {
		return A3(
			$elm$core$List$foldl,
			$elm$core$Basics$always(f),
			x,
			A2($elm$core$List$range, 1, n));
	});
var $cmditch$elm_bigint$BigInt$padDigits = function (n) {
	return A3(
		$cmditch$elm_bigint$BigInt$repeatedly,
		$cmditch$elm_bigint$BigInt$mul(
			$cmditch$elm_bigint$BigInt$fromInt($cmditch$elm_bigint$BigInt$baseDigit)),
		$cmditch$elm_bigint$BigInt$one,
		n);
};
var $cmditch$elm_bigint$BigInt$divMod_ = F3(
	function (n, num, den) {
		if (!n) {
			return A3(
				$cmditch$elm_bigint$BigInt$divmodDigit,
				$cmditch$elm_bigint$BigInt$padDigits(n),
				num,
				den);
		} else {
			var _v0 = A3(
				$cmditch$elm_bigint$BigInt$divmodDigit,
				$cmditch$elm_bigint$BigInt$padDigits(n),
				num,
				den);
			var cdiv = _v0.a;
			var cmod = _v0.b;
			var _v1 = A3($cmditch$elm_bigint$BigInt$divMod_, n - 1, cmod, den);
			var rdiv = _v1.a;
			var rmod = _v1.b;
			return _Utils_Tuple2(
				A2($cmditch$elm_bigint$BigInt$add, cdiv, rdiv),
				rmod);
		}
	});
var $cmditch$elm_bigint$BigInt$toDigits = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return _List_Nil;
		case 0:
			var ds = bigInt.a;
			return ds;
		default:
			var ds = bigInt.a;
			return ds;
	}
};
var $cmditch$elm_bigint$BigInt$divmod = F2(
	function (num, den) {
		if (_Utils_eq(den, $cmditch$elm_bigint$BigInt$zero)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var cand_l = ($elm$core$List$length(
				$cmditch$elm_bigint$BigInt$toDigits(num)) - $elm$core$List$length(
				$cmditch$elm_bigint$BigInt$toDigits(den))) + 1;
			var _v0 = A3(
				$cmditch$elm_bigint$BigInt$divMod_,
				A2($elm$core$Basics$max, 0, cand_l),
				$cmditch$elm_bigint$BigInt$abs(num),
				$cmditch$elm_bigint$BigInt$abs(den));
			var d = _v0.a;
			var m = _v0.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A2(
						$cmditch$elm_bigint$BigInt$mkBigInt,
						A2(
							$cmditch$elm_bigint$BigInt$signProduct,
							$cmditch$elm_bigint$BigInt$sign(num),
							$cmditch$elm_bigint$BigInt$sign(den)),
						$cmditch$elm_bigint$BigInt$magnitude(d)),
					A2(
						$cmditch$elm_bigint$BigInt$mkBigInt,
						$cmditch$elm_bigint$BigInt$sign(num),
						$cmditch$elm_bigint$BigInt$magnitude(m))));
		}
	});
var $cmditch$elm_bigint$BigInt$hexMagnitudeToString = function (bigInt) {
	var _v0 = A2($cmditch$elm_bigint$BigInt$divmod, bigInt, $cmditch$elm_bigint$BigInt$eightHexDigits);
	if (_v0.$ === 1) {
		return 'Failure converting BigInt to hex string. Should be impossible. Open up issue on the elm-bigint repo.';
	} else {
		var _v1 = _v0.a;
		var d = _v1.a;
		var r = _v1.b;
		var rString = $rtfeldman$elm_hex$Hex$toString(
			$cmditch$elm_bigint$BigInt$bigIntToInt_(r));
		return _Utils_eq(
			d,
			$cmditch$elm_bigint$BigInt$fromInt(0)) ? rString : _Utils_ap(
			$cmditch$elm_bigint$BigInt$hexMagnitudeToString(d),
			A3($elm$core$String$padLeft, 8, '0', rString));
	}
};
var $cmditch$elm_bigint$BigInt$toHexString = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return '0';
		case 0:
			var mag = bigInt.a;
			return _Utils_eq(mag, _List_Nil) ? '0' : $cmditch$elm_bigint$BigInt$hexMagnitudeToString(
				$cmditch$elm_bigint$BigInt$Pos(mag));
		default:
			var mag = bigInt.a;
			return '-' + $cmditch$elm_bigint$BigInt$toHexString(
				A2(
					$cmditch$elm_bigint$BigInt$mul,
					$cmditch$elm_bigint$BigInt$fromInt(-1),
					bigInt));
	}
};
var $author$project$Page$GasRelay$ethBigNumberEncoder = function (bigInt) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_hex',
				$elm$json$Json$Encode$string(
					function (s) {
						return '0x' + s;
					}(
						$cmditch$elm_bigint$BigInt$toHexString(bigInt))))
			]));
};
var $author$project$Page$GasRelay$ethereumAddressEncoder = function (ethereumAddress) {
	return $elm$json$Json$Encode$string(
		$author$project$EthereumAddress$toString(ethereumAddress));
};
var $author$project$Page$GasRelay$functionCalledEncoder = function (functionData) {
	if (!functionData.$) {
		var functionData_ = functionData.a;
		return $elm$core$Maybe$Just(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(functionData_.p)),
						_Utils_Tuple2(
						'args',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, functionData_.y))
					])));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$GasRelay$maybeEthereumAddressEncoder = function (maybeEthereumAddress) {
	if (!maybeEthereumAddress.$) {
		var ethereumAddress = maybeEthereumAddress.a;
		return $author$project$Page$GasRelay$ethereumAddressEncoder(ethereumAddress);
	} else {
		return $elm$json$Json$Encode$string('');
	}
};
var $author$project$Page$GasRelay$solidityArgsEncoder = function (solidityArgument) {
	switch (solidityArgument.$) {
		case 2:
			var _int = solidityArgument.a;
			return $elm$json$Json$Encode$int(_int);
		case 3:
			var intList = solidityArgument.a;
			return A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, intList);
		case 0:
			var string = solidityArgument.a;
			return $elm$json$Json$Encode$string(string);
		case 1:
			var stringList = solidityArgument.a;
			return A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, stringList);
		case 6:
			var address = solidityArgument.a;
			return $elm$json$Json$Encode$string(
				$author$project$EthereumAddress$toString(address));
		case 4:
			var bigInt = solidityArgument.a;
			return $author$project$Page$GasRelay$ethBigNumberEncoder(bigInt);
		case 5:
			var bigIntList = solidityArgument.a;
			return A2($elm$json$Json$Encode$list, $author$project$Page$GasRelay$ethBigNumberEncoder, bigIntList);
		case 7:
			var ethereumAddressList = solidityArgument.a;
			return A2($elm$json$Json$Encode$list, $author$project$Page$GasRelay$ethereumAddressEncoder, ethereumAddressList);
		case 8:
			var bool = solidityArgument.a;
			return $elm$json$Json$Encode$bool(bool);
		default:
			var list = solidityArgument.a;
			return A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$bool, list);
	}
};
var $author$project$Page$GasRelay$transactionEncoder = function (transaction) {
	var commonFields = _Utils_ap(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'from',
				$author$project$Page$GasRelay$maybeEthereumAddressEncoder(transaction.k)),
				_Utils_Tuple2(
				'to',
				$author$project$Page$GasRelay$maybeEthereumAddressEncoder(transaction.av)),
				_Utils_Tuple2(
				'executionSource',
				$author$project$Page$GasRelay$ethereumAddressEncoder(transaction.R)),
				_Utils_Tuple2(
				'executionTarget',
				$author$project$Page$GasRelay$ethereumAddressEncoder(transaction.S)),
				_Utils_Tuple2(
				'value',
				$author$project$Page$GasRelay$ethBigNumberEncoder(transaction.aY)),
				_Utils_Tuple2(
				'gasPrice',
				$elm$json$Json$Encode$int(transaction.aP)),
				_Utils_Tuple2(
				'gasToken',
				$elm$json$Json$Encode$string(transaction.aQ)),
				_Utils_Tuple2(
				'gasLimit',
				$elm$json$Json$Encode$int(transaction.aO)),
				_Utils_Tuple2(
				'operationType',
				$elm$json$Json$Encode$int(transaction.ar)),
				_Utils_Tuple2(
				'txId',
				$elm$json$Json$Encode$int(transaction.m)),
				_Utils_Tuple2(
				'abi',
				$elm$json$Json$Encode$string(transaction.ai)),
				_Utils_Tuple2(
				'args',
				A2($elm$json$Json$Encode$list, $author$project$Page$GasRelay$solidityArgsEncoder, transaction.y)),
				_Utils_Tuple2(
				'delegation',
				A2($elm$json$Json$Encode$list, $author$project$Page$GasRelay$ethereumAddressEncoder, transaction.P)),
				_Utils_Tuple2(
				'data',
				$elm$json$Json$Encode$string(transaction.am)),
				_Utils_Tuple2('events', transaction.D)
			]),
		function () {
			var _v1 = $author$project$Page$GasRelay$functionCalledEncoder(transaction.T);
			if (!_v1.$) {
				var fc = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2('functionCalled', fc)
					]);
			} else {
				return _List_Nil;
			}
		}());
	var _v0 = transaction.u;
	switch (_v0.$) {
		case 1:
			var status = _v0.a;
			var allFields = _Utils_ap(
				commonFields,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'nonce',
						$elm$json$Json$Encode$int(status.Y)),
						_Utils_Tuple2(
						'rootSignatures',
						$elm$json$Json$Encode$string(status.ad)),
						_Utils_Tuple2(
						'merkleProof',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, status.X))
					]));
			return $elm$json$Json$Encode$object(allFields);
		case 2:
			var status = _v0.a;
			var allFields = _Utils_ap(
				commonFields,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'nonce',
						$elm$json$Json$Encode$int(status.Y)),
						_Utils_Tuple2(
						'rootSignatures',
						$elm$json$Json$Encode$string(status.ad)),
						_Utils_Tuple2(
						'merkleProof',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, status.X)),
						_Utils_Tuple2(
						'success',
						$elm$json$Json$Encode$bool(status.M)),
						_Utils_Tuple2(
						'transactionsHash',
						$elm$json$Json$Encode$string(status.ag)),
						_Utils_Tuple2(
						'blockNumber',
						$elm$json$Json$Encode$int(status.O)),
						_Utils_Tuple2('events', status.D)
					]));
			return $elm$json$Json$Encode$object(allFields);
		case 0:
			return $elm$json$Json$Encode$object(commonFields);
		default:
			var status = _v0.a;
			var allFields = _Utils_ap(
				commonFields,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'code',
						$elm$json$Json$Encode$int(status.ak)),
						_Utils_Tuple2(
						'message',
						$elm$json$Json$Encode$string(status.aq))
					]));
			return $elm$json$Json$Encode$object(allFields);
	}
};
var $author$project$Page$GasRelay$Failure = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$GasRelay$Success = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$GasRelay$FailureReceipt = F3(
	function (code, message, txId) {
		return {ak: code, aq: message, m: txId};
	});
var $author$project$Page$GasRelay$failureReceiptDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'txId',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'message',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'code',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Page$GasRelay$FailureReceipt))));
var $author$project$Page$GasRelay$SuccessReceipt = F5(
	function (transactionHash, blockNumber, success, txId, events) {
		return {O: blockNumber, D: events, M: success, ag: transactionHash, m: txId};
	});
var $author$project$Page$GasRelay$successReceiptDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'events',
	$elm$json$Json$Decode$value,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'txId',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'success',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'blockNumber',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'transactionHash',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Page$GasRelay$SuccessReceipt))))));
var $author$project$Page$GasRelay$transactionResponseDecoder = $elm$json$Json$Decode$list(
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $author$project$Page$GasRelay$Success, $author$project$Page$GasRelay$successReceiptDecoder),
				A2($elm$json$Json$Decode$map, $author$project$Page$GasRelay$Failure, $author$project$Page$GasRelay$failureReceiptDecoder)
			])));
var $author$project$Page$GasRelay$sendTransactions = F2(
	function (session, request) {
		var signedTx = request.Z;
		var encodedParams = A2($elm$json$Json$Encode$list, $author$project$Page$GasRelay$transactionEncoder, signedTx);
		var body = A3($author$project$Page$GasRelay$jsonRpcRequestEncoder, request.bU, request.U, encodedParams);
		return $elm$http$Http$post(
			{
				ay: $elm$http$Http$jsonBody(body),
				a3: A2(
					$elm$http$Http$expectJson,
					$author$project$Page$GasRelay$TransactionResponse,
					A2($elm$json$Json$Decode$field, 'result', $author$project$Page$GasRelay$transactionResponseDecoder)),
				bs: session.a5
			});
	});
var $author$project$Page$GasRelay$signedTxDict = function (signedTxs) {
	return $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			function (a) {
				return _Utils_Tuple2(a.m, a);
			},
			signedTxs));
};
var $author$project$Page$GasRelay$Transaction = function (from) {
	return function (to) {
		return function (executionSource) {
			return function (executionTarget) {
				return function (value) {
					return function (gasPrice) {
						return function (gasToken) {
							return function (gasLimit) {
								return function (operationType) {
									return function (txId) {
										return function (abi) {
											return function (args) {
												return function (delegation) {
													return function (data) {
														return function (status) {
															return function (functionCalled) {
																return function (events) {
																	return {ai: abi, y: args, am: data, P: delegation, D: events, R: executionSource, S: executionTarget, k: from, T: functionCalled, aO: gasLimit, aP: gasPrice, aQ: gasToken, ar: operationType, u: status, av: to, m: txId, aY: value};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Page$GasRelay$FunctionCalled = F2(
	function (name, args) {
		return {y: args, p: name};
	});
var $author$project$Page$GasRelay$functionCalledDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'args',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Page$GasRelay$FunctionCalled)));
var $author$project$Page$GasRelay$Executed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$GasRelay$ExecutedTxData = F7(
	function (nonce, rootSignatures, merkleProof, success, transactionHash, blockNumber, events) {
		return {O: blockNumber, D: events, X: merkleProof, Y: nonce, ad: rootSignatures, M: success, ag: transactionHash};
	});
var $author$project$Page$GasRelay$Signed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$GasRelay$SignedTxData = F3(
	function (nonce, rootSignatures, merkleProof) {
		return {X: merkleProof, Y: nonce, ad: rootSignatures};
	});
var $author$project$Page$GasRelay$transactionStatusDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Page$GasRelay$Executed,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'events',
				$elm$json$Json$Decode$value,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'blockNumber',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'transactionHash',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'success',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'merkleProof',
								$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'rootSignatures',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'nonce',
										$elm$json$Json$Decode$int,
										$elm$json$Json$Decode$succeed($author$project$Page$GasRelay$ExecutedTxData))))))))),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Page$GasRelay$Signed,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'merkleProof',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'rootSignatures',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'nonce',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Page$GasRelay$SignedTxData))))),
			$elm$json$Json$Decode$succeed($author$project$Page$GasRelay$Unsigned)
		]));
var $author$project$Page$GasRelay$transactionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'events',
	$elm$json$Json$Decode$value,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'functionCalled',
		$elm$json$Json$Decode$maybe($author$project$Page$GasRelay$functionCalledDecoder),
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$author$project$Page$GasRelay$transactionStatusDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'data',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'delegation',
					$elm$json$Json$Decode$list($author$project$EthereumAddress$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'args',
						$elm$json$Json$Decode$list($author$project$Page$GasRelay$solidityArgumentsDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'abi',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'txId',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'operationType',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'gasLimit',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'gasToken',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'gasPrice',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'value',
													A2($elm$json$Json$Decode$field, '_hex', $author$project$Page$GasRelay$bigIntDecoder),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'executionTarget',
														$author$project$EthereumAddress$decoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'executionSource',
															$author$project$EthereumAddress$decoder,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'to',
																$elm$json$Json$Decode$maybe($author$project$EthereumAddress$decoder),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'from',
																	$elm$json$Json$Decode$maybe($author$project$EthereumAddress$decoder),
																	$elm$json$Json$Decode$succeed($author$project$Page$GasRelay$Transaction))))))))))))))))));
var $author$project$Utils$updateDict = F3(
	function (dictNew, accessors, dictOld) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (key, outputDict) {
					return A3(
						$elm$core$Dict$update,
						key,
						function (v) {
							if (!v.$) {
								var valueInOld = v.a;
								var valueInNew_ = A2($elm$core$Dict$get, key, dictNew);
								if (!valueInNew_.$) {
									var valueInNew = valueInNew_.a;
									return $elm$core$Maybe$Just(
										A3(
											$elm$core$List$foldl,
											F2(
												function (_v2, d) {
													var getter = _v2.a;
													var setter = _v2.b;
													return A2(
														setter,
														d,
														getter(valueInNew));
												}),
											valueInOld,
											accessors));
								} else {
									return $elm$core$Maybe$Just(valueInOld);
								}
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						outputDict);
				}),
			dictOld,
			$elm$core$Dict$keys(dictNew));
	});
var $author$project$Page$GasRelay$Invalid = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$GasRelay$updatedTransactions = F2(
	function (receipt, transactions) {
		var _v0 = function () {
			if (!receipt.$) {
				var receipt_ = receipt.a;
				return _Utils_Tuple2(
					receipt_.m,
					function (x) {
						return $author$project$Page$GasRelay$Executed(
							{O: receipt_.O, D: receipt_.D, X: x.X, Y: x.Y, ad: x.ad, M: receipt_.M, ag: receipt_.ag});
					});
			} else {
				var receipt_ = receipt.a;
				return _Utils_Tuple2(
					receipt_.m,
					function (x) {
						return $author$project$Page$GasRelay$Invalid(
							{ak: receipt_.ak, aq: receipt_.aq});
					});
			}
		}();
		var txId = _v0.a;
		var statusUpdaterFn = _v0.b;
		return A3(
			$elm$core$Dict$update,
			txId,
			$elm$core$Maybe$map(
				function (value) {
					var _v2 = value.u;
					if (_v2.$ === 1) {
						var value_ = _v2.a;
						return _Utils_update(
							value,
							{
								u: statusUpdaterFn(value_)
							});
					} else {
						return value;
					}
				}),
			transactions);
	});
var $Chadtech$return$Return3$withNothing = function (model_) {
	return _Utils_Tuple3(model_, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
};
var $author$project$Page$GasRelay$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 5:
				var requestId = msg.a;
				var transactionsMsg = msg.b;
				return function (incomingMsg) {
					if (!incomingMsg.$) {
						var incomingMsg_ = incomingMsg.a;
						var txId = model.m;
						var transactions = $author$project$Page$GasRelay$getTxsFromMsg(incomingMsg_);
						var newTxId = txId + $elm$core$List$length(transactions);
						var newTransactions = A2($author$project$Page$GasRelay$getTxDict, transactions, txId);
						var newTransactionsList = A2(
							$elm$json$Json$Encode$list,
							$author$project$Page$GasRelay$transactionEncoder,
							$elm$core$Dict$values(newTransactions));
						var from = incomingMsg_.k;
						return A2(
							$Chadtech$return$Return3$withReply,
							$author$project$Page$GasRelay$Open,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										k: $elm$core$Maybe$Just(from),
										ac: $elm$core$Maybe$Just(requestId),
										q: newTransactions,
										m: newTxId
									}),
								$author$project$Page$GasRelay$getComposedTransactions(newTransactionsList)));
					} else {
						var err = incomingMsg.a;
						return $Chadtech$return$Return3$withNoReply(
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
					}
				}(
					A2($elm$json$Json$Decode$decodeValue, $author$project$Page$GasRelay$incomingTxsDecoder, transactionsMsg));
			case 6:
				var tx = msg.a;
				return function (a) {
					if (!a.$) {
						var batch = a.a;
						var txDict = $author$project$Page$GasRelay$signedTxDict(batch);
						var newTransactions = A3(
							$author$project$Utils$updateDict,
							txDict,
							_List_fromArray(
								[
									_Utils_Tuple2(
									function ($) {
										return $.k;
									},
									F2(
										function (x, v) {
											return _Utils_update(
												x,
												{k: v});
										}))
								]),
							A3(
								$author$project$Utils$updateDict,
								txDict,
								_List_fromArray(
									[
										_Utils_Tuple2(
										function ($) {
											return $.av;
										},
										F2(
											function (x, v) {
												return _Utils_update(
													x,
													{av: v});
											}))
									]),
								A3(
									$author$project$Utils$updateDict,
									txDict,
									_List_fromArray(
										[
											_Utils_Tuple2(
											function ($) {
												return $.T;
											},
											F2(
												function (x, v) {
													return _Utils_update(
														x,
														{T: v});
												}))
										]),
									A3(
										$author$project$Utils$updateDict,
										txDict,
										_List_fromArray(
											[
												_Utils_Tuple2(
												function ($) {
													return $.am;
												},
												F2(
													function (x, v) {
														return _Utils_update(
															x,
															{am: v});
													}))
											]),
										model.q))));
						return $Chadtech$return$Return3$withNoReply(
							_Utils_Tuple2(
								_Utils_update(
									model,
									{q: newTransactions}),
								$elm$core$Platform$Cmd$none));
					} else {
						return $Chadtech$return$Return3$withNoReply(
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
					}
				}(
					A2(
						$elm$json$Json$Decode$decodeValue,
						$elm$json$Json$Decode$list($author$project$Page$GasRelay$transactionDecoder),
						tx));
			case 0:
				var id = model.ae;
				var from = model.k;
				if (from.$ === 1) {
					return $Chadtech$return$Return3$withNoReply(
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				} else {
					var from_ = from.a;
					var address = $author$project$EthereumAddress$toString(from_);
					var request = {
						U: id,
						bU: 'lastNonce',
						Z: {k: address}
					};
					return $Chadtech$return$Return3$withNoReply(
						_Utils_Tuple2(
							_Utils_update(
								model,
								{A: $author$project$Page$GasRelay$Sent}),
							A2($author$project$Page$GasRelay$getNonce, session, request)));
				}
			case 1:
				var response = msg.a;
				if (!response.$) {
					var nonce = response.a;
					var transactions = $elm$core$Dict$values(model.q);
					var rpcId = model.ae + 1;
					var extractedTxs = A2($elm$json$Json$Encode$list, $author$project$Page$GasRelay$transactionEncoder, transactions);
					return $Chadtech$return$Return3$withNoReply(
						_Utils_Tuple2(
							_Utils_update(
								model,
								{ae: rpcId}),
							$author$project$Page$GasRelay$getSignedTransactions(
								_Utils_Tuple2(extractedTxs, nonce))));
				} else {
					var err = response.a;
					var _v5 = model.ac;
					if (!_v5.$) {
						var requestId_ = _v5.a;
						var message = $author$project$Page$GasRelay$returnErrorMessage(err);
						return A2(
							$Chadtech$return$Return3$withReply,
							A3(
								$author$project$Page$GasRelay$ExecuteSignedResponse,
								requestId_,
								A2(
									$elm$json$Json$Encode$list,
									$elm$json$Json$Encode$string,
									_List_fromArray(
										[message])),
								true),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										A: $author$project$Page$GasRelay$Error(message)
									}),
								$elm$core$Platform$Cmd$none));
					} else {
						return $Chadtech$return$Return3$withNothing(model);
					}
				}
			case 2:
				var transactions = msg.a;
				return function (a) {
					if (!a.$) {
						var batch = a.a;
						var txDict = $author$project$Page$GasRelay$signedTxDict(batch);
						var request = {U: model.ae, bU: 'executeSigned', Z: batch};
						var newTransactions = A3(
							$author$project$Utils$updateDict,
							txDict,
							_List_fromArray(
								[
									_Utils_Tuple2(
									function ($) {
										return $.u;
									},
									F2(
										function (x, v) {
											return _Utils_update(
												x,
												{u: v});
										}))
								]),
							model.q);
						return $Chadtech$return$Return3$withNoReply(
							_Utils_Tuple2(
								_Utils_update(
									model,
									{q: newTransactions}),
								A2($author$project$Page$GasRelay$sendTransactions, session, request)));
					} else {
						return $Chadtech$return$Return3$withNoReply(
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
					}
				}(
					A2(
						$elm$json$Json$Decode$decodeValue,
						$elm$json$Json$Decode$list($author$project$Page$GasRelay$transactionDecoder),
						transactions));
			case 3:
				var response = msg.a;
				if (!response.$) {
					var result = response.a;
					var signed = model.q;
					var requestId = model.ac;
					var newSignedTx = A3(
						$elm$core$List$foldl,
						F2(
							function (tx, signedTx) {
								return A2($author$project$Page$GasRelay$updatedTransactions, tx, signedTx);
							}),
						signed,
						result);
					var hasError = A2(
						$elm$core$List$member,
						false,
						A2(
							$elm$core$List$map,
							function (a) {
								var _v10 = a.u;
								switch (_v10.$) {
									case 2:
										var receipt = _v10.a;
										return receipt.M;
									case 0:
										return false;
									case 1:
										return false;
									default:
										return false;
								}
							},
							$elm$core$Dict$values(newSignedTx)));
					var executeSignedResponse = A2(
						$elm$json$Json$Encode$list,
						$author$project$Page$GasRelay$transactionEncoder,
						$elm$core$Dict$values(newSignedTx));
					if (!requestId.$) {
						var requestId_ = requestId.a;
						if (!hasError) {
							return A2(
								$Chadtech$return$Return3$withReply,
								A3($author$project$Page$GasRelay$ExecuteSignedResponse, requestId_, executeSignedResponse, hasError),
								_Utils_Tuple2(
									_Utils_update(
										model,
										{A: $author$project$Page$GasRelay$Terminated, q: newSignedTx}),
									$elm$core$Platform$Cmd$none));
						} else {
							var message = 'One or more transactions failed.';
							var messageEncode = A2(
								$elm$json$Json$Encode$list,
								$elm$json$Json$Encode$string,
								_List_fromArray(
									[message]));
							return A2(
								$Chadtech$return$Return3$withReply,
								A3($author$project$Page$GasRelay$ExecuteSignedResponse, requestId_, messageEncode, hasError),
								_Utils_Tuple2(
									_Utils_update(
										model,
										{
											A: $author$project$Page$GasRelay$Error(message),
											q: newSignedTx
										}),
									$elm$core$Platform$Cmd$none));
						}
					} else {
						return $Chadtech$return$Return3$withNoReply(
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
					}
				} else {
					var error = response.a;
					var _v11 = model.ac;
					if (!_v11.$) {
						var requestId_ = _v11.a;
						var messageError = $author$project$Page$GasRelay$returnErrorMessage(error);
						return A2(
							$Chadtech$return$Return3$withReply,
							A3(
								$author$project$Page$GasRelay$ExecuteSignedResponse,
								requestId_,
								A2(
									$elm$json$Json$Encode$list,
									$elm$json$Json$Encode$string,
									_List_fromArray(
										[messageError])),
								true),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										A: $author$project$Page$GasRelay$Error(messageError)
									}),
								$elm$core$Platform$Cmd$none));
					} else {
						return A2(
							$Chadtech$return$Return3$withReply,
							$author$project$Page$GasRelay$Close,
							$Chadtech$return$Return2$withNoCmd(model));
					}
				}
			default:
				return A2(
					$Chadtech$return$Return3$withReply,
					$author$project$Page$GasRelay$Close,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
		}
	});
var $author$project$Page$Home$Close = {$: 6};
var $author$project$Page$Home$ExportPrivateKey = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Home$GoToCreateAccount = {$: 1};
var $author$project$Page$Home$GoToImportAccount = {$: 0};
var $author$project$Page$Home$RemoveAccount = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Home$SetAccountName = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Home$SetSelectedAccount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Home$TriggerRemoveAccount = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Home$update = F3(
	function (session, msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					return $Chadtech$return$Return3$withNoReply(
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				case 1:
					return A2(
						$Chadtech$return$Return3$withReply,
						$author$project$Page$Home$GoToImportAccount,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				case 2:
					return A2(
						$Chadtech$return$Return3$withReply,
						$author$project$Page$Home$GoToCreateAccount,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				case 11:
					return A2(
						$Chadtech$return$Return3$withReply,
						$author$project$Page$Home$Close,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				case 3:
					var accountAddress = msg.a;
					return A2(
						$Chadtech$return$Return3$withReply,
						$author$project$Page$Home$SetSelectedAccount(accountAddress),
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				case 6:
					var account = msg.a;
					return $Chadtech$return$Return3$withNothing(
						_Utils_update(
							model,
							{
								L: $elm$core$Maybe$Just(account)
							}));
				case 7:
					var accountAddress = msg.a;
					return $Chadtech$return$Return3$withNothing(
						_Utils_update(
							model,
							{
								bH: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										$elm$core$Maybe$Just(
											$author$project$Page$Home$TriggerRemoveAccount(accountAddress)),
										'Remove private key?',
										'Are you sure you want to remove the privatge key?'))
							}));
				case 8:
					var accountAddress = msg.a;
					return A2(
						$Chadtech$return$Return3$withReply,
						$author$project$Page$Home$RemoveAccount(accountAddress),
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				case 9:
					var accountAddress = msg.a;
					return A2(
						$Chadtech$return$Return3$withReply,
						$author$project$Page$Home$ExportPrivateKey(accountAddress),
						$Chadtech$return$Return2$withNoCmd(model));
				case 10:
					var accountAddress = msg.a;
					return $Chadtech$return$Return3$withNoReply(
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									an: _Utils_eq(
										model.an,
										$elm$core$Maybe$Just(accountAddress)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(accountAddress),
									L: $elm$core$Maybe$Nothing
								}),
							$elm$core$Platform$Cmd$none));
				case 4:
					var account = msg.a;
					var newName = msg.b;
					var newAccount = _Utils_update(
						account,
						{p: newName});
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								L: $elm$core$Maybe$Just(newAccount)
							}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing);
				case 5:
					var account = msg.a;
					return A2(
						$Chadtech$return$Return3$withReply,
						A2($author$project$Page$Home$SetAccountName, account.aF, account.p),
						_Utils_Tuple2(
							_Utils_update(
								model,
								{L: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none));
				default:
					var outcome = msg.a;
					var newModel = _Utils_update(
						model,
						{bH: $elm$core$Maybe$Nothing});
					if (outcome.$ === 1) {
						return $Chadtech$return$Return3$withNothing(newModel);
					} else {
						var nextMsg = outcome.a;
						var $temp$session = session,
							$temp$msg = nextMsg,
							$temp$model = newModel;
						session = $temp$session;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					}
			}
		}
	});
var $author$project$Page$Import$GoToHome = {$: 1};
var $author$project$Page$Import$ImportAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Import$formValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.p;
			},
			'Please enter a name.'),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.be;
			},
			'Please paste a private key.')
		]));
var $author$project$Page$Import$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				var name = msg.a;
				return $Chadtech$return$Return3$withNoReply(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{p: name}),
						$elm$core$Platform$Cmd$none));
			case 1:
				var privateKey = msg.a;
				return $Chadtech$return$Return3$withNoReply(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{be: privateKey}),
						$elm$core$Platform$Cmd$none));
			case 2:
				var validateResult = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Page$Import$formValidator, model);
				if (!validateResult.$) {
					var validSubject = validateResult.a;
					var subject = $rtfeldman$elm_validate$Validate$fromValid(validSubject);
					var accountData = function (s) {
						return {p: s.p, be: s.be};
					}(subject);
					return A2(
						$Chadtech$return$Return3$withReply,
						$author$project$Page$Import$ImportAccount(accountData),
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				} else {
					var errors = validateResult.a;
					return $Chadtech$return$Return3$withNoReply(
						_Utils_Tuple2(
							model,
							A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Maybe$map,
									$author$project$Ports$alert,
									$elm$core$List$head(errors)))));
				}
			default:
				return A2(
					$Chadtech$return$Return3$withReply,
					$author$project$Page$Import$GoToHome,
					$Chadtech$return$Return2$withNoCmd(model));
		}
	});
var $author$project$Page$Initialize$Close = {$: 1};
var $author$project$Page$Initialize$NewPassword = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Initialize$formValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.f;
			},
			'Please type a password.'),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.aa;
			},
			'Please type password again.'),
			A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return !_Utils_eq(subject.f, subject.aa);
			},
			'Passwords do not match')
		]));
var $author$project$Page$Initialize$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				var password = msg.a;
				return $Chadtech$return$Return3$withNoReply(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{f: password}),
						$elm$core$Platform$Cmd$none));
			case 1:
				var password2 = msg.a;
				return $Chadtech$return$Return3$withNoReply(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{aa: password2}),
						$elm$core$Platform$Cmd$none));
			case 3:
				return A2(
					$Chadtech$return$Return3$withReply,
					$author$project$Page$Initialize$Close,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			default:
				var validateResult = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Page$Initialize$formValidator, model);
				if (!validateResult.$) {
					var validSubject = validateResult.a;
					var subject = $rtfeldman$elm_validate$Validate$fromValid(validSubject);
					var newPassword = subject.f;
					return A2(
						$Chadtech$return$Return3$withReply,
						$author$project$Page$Initialize$NewPassword(newPassword),
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				} else {
					var errors = validateResult.a;
					return $Chadtech$return$Return3$withNoReply(
						_Utils_Tuple2(
							model,
							A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Maybe$map,
									$author$project$Ports$alert,
									$elm$core$List$head(errors)))));
				}
		}
	});
var $author$project$Page$Sign$Close = {$: 1};
var $author$project$Page$Sign$SignMessage = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Page$Sign$update = F3(
	function (session, msg, model) {
		switch (msg) {
			case 0:
				return A2(
					$Chadtech$return$Return3$withReply,
					A2($author$project$Page$Sign$SignMessage, model.ac, model.aq),
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 1:
				return A2(
					$Chadtech$return$Return3$withReply,
					$author$project$Page$Sign$Close,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			default:
				return A2(
					$Chadtech$return$Return3$withReply,
					$author$project$Page$Sign$Close,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
		}
	});
var $author$project$Page$Unlock$Close = {$: 1};
var $author$project$Page$Unlock$PasswordProvided = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Unlock$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				var password = msg.a;
				return $Chadtech$return$Return3$withNoReply(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{f: password}),
						$elm$core$Platform$Cmd$none));
			case 1:
				return A2(
					$Chadtech$return$Return3$withReply,
					$author$project$Page$Unlock$PasswordProvided(model.f),
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			default:
				return A2(
					$Chadtech$return$Return3$withReply,
					$author$project$Page$Unlock$Close,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
		}
	});
var $Chadtech$return$Return2$withCmd = F2(
	function (cmd_, model_) {
		return _Utils_Tuple2(model_, cmd_);
	});
var $author$project$Ports$writeToSessionStorage = _Platform_outgoingPort(
	'writeToSessionStorage',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Encrypt$BlankMsg = {$: 0};
var $author$project$Encrypt$BlankSalt = {$: 1};
var $author$project$Encrypt$FailedToDecrypt = function (a) {
	return {$: 5, a: a};
};
var $author$project$Encrypt$FailedToReadBase64 = function (a) {
	return {$: 7, a: a};
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm_community$list_extra$List$Extra$indexedFoldl = F3(
	function (func, acc, list) {
		var step = F2(
			function (x, _v0) {
				var i = _v0.a;
				var thisAcc = _v0.b;
				return _Utils_Tuple2(
					i + 1,
					A3(func, i, x, thisAcc));
			});
		return A3(
			$elm$core$List$foldl,
			step,
			_Utils_Tuple2(0, acc),
			list).b;
	});
var $author$project$Coder$decodeChunk = F2(
	function (scheme, chunk) {
		var octets = scheme.bY;
		var chars = scheme.bF;
		var padChar = scheme.b1;
		var intToChar = scheme.bR;
		var charToInt = scheme.bE;
		var bitsPerChar = $elm$core$Basics$floor((octets * 8) / chars);
		return A2(
			$elm$core$Result$andThen,
			function (x) {
				return $elm$core$Result$Ok(
					A3(
						$elm_community$list_extra$List$Extra$indexedFoldl,
						F3(
							function (charIndex, _char, _v0) {
								var currentByte = _v0.a;
								var bytes = _v0.b;
								var octetIndex = $elm$core$Basics$floor(charIndex * (bitsPerChar / 8));
								var octetStart = octetIndex * 8;
								var octetEnd = octetStart + 8;
								var charStart = charIndex * bitsPerChar;
								var charEnd = charStart + bitsPerChar;
								var shift = octetEnd - charEnd;
								var nextByte = _Utils_eq(charEnd, octetEnd) ? $elm$core$Maybe$Just(0) : ((_Utils_cmp(charEnd, octetEnd) > 0) ? $elm$core$Maybe$Just(
									255 & ((shift < 0) ? (_char << (8 + shift)) : (_char >>> (8 - shift)))) : $elm$core$Maybe$Nothing);
								var _byte = currentByte | ((shift < 0) ? (_char >>> (-shift)) : (_char << shift));
								if (!nextByte.$) {
									var b = nextByte.a;
									return _Utils_Tuple2(
										b,
										_Utils_ap(
											bytes,
											_List_fromArray(
												[_byte])));
								} else {
									return _Utils_Tuple2(_byte, bytes);
								}
							}),
						_Utils_Tuple2(0, _List_Nil),
						x).b);
			},
			$elm_community$result_extra$Result$Extra$combine(
				A2($elm$core$List$map, charToInt, chunk)));
	});
var $elm_community$list_extra$List$Extra$groupsOfWithStep = F3(
	function (size, step, xs) {
		var xs_ = A2($elm$core$List$drop, step, xs);
		var thisGroup = A2($elm$core$List$take, size, xs);
		var okayLength = _Utils_eq(
			size,
			$elm$core$List$length(thisGroup));
		var okayArgs = (size > 0) && (step > 0);
		return (okayArgs && okayLength) ? A2(
			$elm$core$List$cons,
			thisGroup,
			A3($elm_community$list_extra$List$Extra$groupsOfWithStep, size, step, xs_)) : _List_Nil;
	});
var $elm_community$list_extra$List$Extra$groupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$groupsOfWithStep, size, size, xs);
	});
var $author$project$Coder$decode = F2(
	function (scheme, string) {
		var octets = scheme.bY;
		var chars = scheme.bF;
		var padChar = scheme.b1;
		var intToChar = scheme.bR;
		var charToInt = scheme.bE;
		return A2(
			$elm$core$Result$andThen,
			function (x) {
				var p = $elm$core$Basics$ceiling(
					($elm$core$List$length(
						A2($elm$core$String$indexes, padChar, string)) * octets) / chars);
				var output = $elm$core$List$concat(x);
				var s = $elm$core$List$length(output) - p;
				return $elm$core$Result$Ok(
					A2($elm$core$List$take, s, output));
			},
			$elm_community$result_extra$Result$Extra$combine(
				A2(
					$elm$core$List$map,
					$author$project$Coder$decodeChunk(scheme),
					A2(
						$elm_community$list_extra$List$Extra$groupsOf,
						chars,
						$elm$core$String$toList(string)))));
	});
var $author$project$Base64Bis$charToInt = function (_char) {
	switch (_char) {
		case 'A':
			return $elm$core$Result$Ok(0);
		case 'B':
			return $elm$core$Result$Ok(1);
		case 'C':
			return $elm$core$Result$Ok(2);
		case 'D':
			return $elm$core$Result$Ok(3);
		case 'E':
			return $elm$core$Result$Ok(4);
		case 'F':
			return $elm$core$Result$Ok(5);
		case 'G':
			return $elm$core$Result$Ok(6);
		case 'H':
			return $elm$core$Result$Ok(7);
		case 'I':
			return $elm$core$Result$Ok(8);
		case 'J':
			return $elm$core$Result$Ok(9);
		case 'K':
			return $elm$core$Result$Ok(10);
		case 'L':
			return $elm$core$Result$Ok(11);
		case 'M':
			return $elm$core$Result$Ok(12);
		case 'N':
			return $elm$core$Result$Ok(13);
		case 'O':
			return $elm$core$Result$Ok(14);
		case 'P':
			return $elm$core$Result$Ok(15);
		case 'Q':
			return $elm$core$Result$Ok(16);
		case 'R':
			return $elm$core$Result$Ok(17);
		case 'S':
			return $elm$core$Result$Ok(18);
		case 'T':
			return $elm$core$Result$Ok(19);
		case 'U':
			return $elm$core$Result$Ok(20);
		case 'V':
			return $elm$core$Result$Ok(21);
		case 'W':
			return $elm$core$Result$Ok(22);
		case 'X':
			return $elm$core$Result$Ok(23);
		case 'Y':
			return $elm$core$Result$Ok(24);
		case 'Z':
			return $elm$core$Result$Ok(25);
		case 'a':
			return $elm$core$Result$Ok(26);
		case 'b':
			return $elm$core$Result$Ok(27);
		case 'c':
			return $elm$core$Result$Ok(28);
		case 'd':
			return $elm$core$Result$Ok(29);
		case 'e':
			return $elm$core$Result$Ok(30);
		case 'f':
			return $elm$core$Result$Ok(31);
		case 'g':
			return $elm$core$Result$Ok(32);
		case 'h':
			return $elm$core$Result$Ok(33);
		case 'i':
			return $elm$core$Result$Ok(34);
		case 'j':
			return $elm$core$Result$Ok(35);
		case 'k':
			return $elm$core$Result$Ok(36);
		case 'l':
			return $elm$core$Result$Ok(37);
		case 'm':
			return $elm$core$Result$Ok(38);
		case 'n':
			return $elm$core$Result$Ok(39);
		case 'o':
			return $elm$core$Result$Ok(40);
		case 'p':
			return $elm$core$Result$Ok(41);
		case 'q':
			return $elm$core$Result$Ok(42);
		case 'r':
			return $elm$core$Result$Ok(43);
		case 's':
			return $elm$core$Result$Ok(44);
		case 't':
			return $elm$core$Result$Ok(45);
		case 'u':
			return $elm$core$Result$Ok(46);
		case 'v':
			return $elm$core$Result$Ok(47);
		case 'w':
			return $elm$core$Result$Ok(48);
		case 'x':
			return $elm$core$Result$Ok(49);
		case 'y':
			return $elm$core$Result$Ok(50);
		case 'z':
			return $elm$core$Result$Ok(51);
		case '0':
			return $elm$core$Result$Ok(52);
		case '1':
			return $elm$core$Result$Ok(53);
		case '2':
			return $elm$core$Result$Ok(54);
		case '3':
			return $elm$core$Result$Ok(55);
		case '4':
			return $elm$core$Result$Ok(56);
		case '5':
			return $elm$core$Result$Ok(57);
		case '6':
			return $elm$core$Result$Ok(58);
		case '7':
			return $elm$core$Result$Ok(59);
		case '8':
			return $elm$core$Result$Ok(60);
		case '9':
			return $elm$core$Result$Ok(61);
		case '+':
			return $elm$core$Result$Ok(62);
		case '/':
			return $elm$core$Result$Ok(63);
		case '=':
			return $elm$core$Result$Ok(0);
		default:
			return $elm$core$Result$Err('Invalid character');
	}
};
var $author$project$Base64Bis$intToChar = function (_int) {
	switch (_int) {
		case 0:
			return $elm$core$Result$Ok('A');
		case 1:
			return $elm$core$Result$Ok('B');
		case 2:
			return $elm$core$Result$Ok('C');
		case 3:
			return $elm$core$Result$Ok('D');
		case 4:
			return $elm$core$Result$Ok('E');
		case 5:
			return $elm$core$Result$Ok('F');
		case 6:
			return $elm$core$Result$Ok('G');
		case 7:
			return $elm$core$Result$Ok('H');
		case 8:
			return $elm$core$Result$Ok('I');
		case 9:
			return $elm$core$Result$Ok('J');
		case 10:
			return $elm$core$Result$Ok('K');
		case 11:
			return $elm$core$Result$Ok('L');
		case 12:
			return $elm$core$Result$Ok('M');
		case 13:
			return $elm$core$Result$Ok('N');
		case 14:
			return $elm$core$Result$Ok('O');
		case 15:
			return $elm$core$Result$Ok('P');
		case 16:
			return $elm$core$Result$Ok('Q');
		case 17:
			return $elm$core$Result$Ok('R');
		case 18:
			return $elm$core$Result$Ok('S');
		case 19:
			return $elm$core$Result$Ok('T');
		case 20:
			return $elm$core$Result$Ok('U');
		case 21:
			return $elm$core$Result$Ok('V');
		case 22:
			return $elm$core$Result$Ok('W');
		case 23:
			return $elm$core$Result$Ok('X');
		case 24:
			return $elm$core$Result$Ok('Y');
		case 25:
			return $elm$core$Result$Ok('Z');
		case 26:
			return $elm$core$Result$Ok('a');
		case 27:
			return $elm$core$Result$Ok('b');
		case 28:
			return $elm$core$Result$Ok('c');
		case 29:
			return $elm$core$Result$Ok('d');
		case 30:
			return $elm$core$Result$Ok('e');
		case 31:
			return $elm$core$Result$Ok('f');
		case 32:
			return $elm$core$Result$Ok('g');
		case 33:
			return $elm$core$Result$Ok('h');
		case 34:
			return $elm$core$Result$Ok('i');
		case 35:
			return $elm$core$Result$Ok('j');
		case 36:
			return $elm$core$Result$Ok('k');
		case 37:
			return $elm$core$Result$Ok('l');
		case 38:
			return $elm$core$Result$Ok('m');
		case 39:
			return $elm$core$Result$Ok('n');
		case 40:
			return $elm$core$Result$Ok('o');
		case 41:
			return $elm$core$Result$Ok('p');
		case 42:
			return $elm$core$Result$Ok('q');
		case 43:
			return $elm$core$Result$Ok('r');
		case 44:
			return $elm$core$Result$Ok('s');
		case 45:
			return $elm$core$Result$Ok('t');
		case 46:
			return $elm$core$Result$Ok('u');
		case 47:
			return $elm$core$Result$Ok('v');
		case 48:
			return $elm$core$Result$Ok('w');
		case 49:
			return $elm$core$Result$Ok('x');
		case 50:
			return $elm$core$Result$Ok('y');
		case 51:
			return $elm$core$Result$Ok('z');
		case 52:
			return $elm$core$Result$Ok('0');
		case 53:
			return $elm$core$Result$Ok('1');
		case 54:
			return $elm$core$Result$Ok('2');
		case 55:
			return $elm$core$Result$Ok('3');
		case 56:
			return $elm$core$Result$Ok('4');
		case 57:
			return $elm$core$Result$Ok('5');
		case 58:
			return $elm$core$Result$Ok('6');
		case 59:
			return $elm$core$Result$Ok('7');
		case 60:
			return $elm$core$Result$Ok('8');
		case 61:
			return $elm$core$Result$Ok('9');
		case 62:
			return $elm$core$Result$Ok('+');
		case 63:
			return $elm$core$Result$Ok('/');
		default:
			var x = _int;
			return $elm$core$Result$Err(
				'Invalid byte value \"' + ($elm$core$String$fromInt(x) + '\" for base64'));
	}
};
var $author$project$Base64Bis$scheme = {bE: $author$project$Base64Bis$charToInt, bF: 4, bR: $author$project$Base64Bis$intToChar, bY: 3, b1: '='};
var $author$project$Base64Bis$decode = $author$project$Coder$decode($author$project$Base64Bis$scheme);
var $author$project$Encrypt$endMarker = _List_fromArray(
	[2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71]);
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm_community$list_extra$List$Extra$isPrefixOf = F2(
	function (prefix, list) {
		var _v0 = _Utils_Tuple2(prefix, list);
		if (!_v0.a.b) {
			return true;
		} else {
			if (!_v0.b.b) {
				var _v1 = _v0.a;
				return false;
			} else {
				var _v2 = _v0.a;
				var p = _v2.a;
				var ps = _v2.b;
				var _v3 = _v0.b;
				var x = _v3.a;
				var xs = _v3.b;
				return _Utils_eq(p, x) && A2($elm_community$list_extra$List$Extra$isPrefixOf, ps, xs);
			}
		}
	});
var $author$project$Utils$listIndexOfHelp = F4(
	function (offset, infixHead, infixTail, list) {
		listIndexOfHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Just(offset);
			} else {
				var x = list.a;
				var xs = list.b;
				if (_Utils_eq(x, infixHead)) {
					return A2($elm_community$list_extra$List$Extra$isPrefixOf, infixTail, xs) ? $elm$core$Maybe$Just(offset) : $elm$core$Maybe$Nothing;
				} else {
					var $temp$offset = offset + 1,
						$temp$infixHead = infixHead,
						$temp$infixTail = infixTail,
						$temp$list = xs;
					offset = $temp$offset;
					infixHead = $temp$infixHead;
					infixTail = $temp$infixTail;
					list = $temp$list;
					continue listIndexOfHelp;
				}
			}
		}
	});
var $author$project$Utils$listIndexOf = F2(
	function (infixList, list) {
		if (!infixList.b) {
			return $elm$core$Maybe$Just(0);
		} else {
			var x = infixList.a;
			var xs = infixList.b;
			return A4($author$project$Utils$listIndexOfHelp, 0, x, xs, list);
		}
	});
var $author$project$Utils$listSplitFirst = F2(
	function (needle, list) {
		var _v0 = A2($author$project$Utils$listIndexOf, needle, list);
		if (!_v0.$) {
			var position = _v0.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$take, position, list));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$bytes$Bytes$Decode$string = function (n) {
	return _Bytes_read_string(n);
};
var $author$project$Encrypt$FailedToConverToToString = function (a) {
	return {$: 6, a: a};
};
var $elm$bytes$Bytes$Decode$fail = _Bytes_decodeFailure;
var $danfishgold$base64_bytes$Decode$intsDecoder = function (width) {
	return A2(
		$elm$bytes$Bytes$Decode$map,
		A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
		A2(
			$elm$bytes$Bytes$Decode$loop,
			_Utils_Tuple2(width, _List_Nil),
			function (_v0) {
				var len = _v0.a;
				var ints = _v0.b;
				return (len <= 0) ? $elm$bytes$Bytes$Decode$succeed(
					$elm$bytes$Bytes$Decode$Done(
						_Utils_Tuple2(len, ints))) : A2(
					$elm$bytes$Bytes$Decode$map,
					function (_int) {
						return $elm$bytes$Bytes$Decode$Loop(
							_Utils_Tuple2(
								len - 1,
								A2($elm$core$List$cons, _int, ints)));
					},
					$elm$bytes$Bytes$Decode$unsignedInt8);
			}));
};
var $danfishgold$base64_bytes$Basic$listFromMaybeList = function (xs) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$List$reverse,
		A3(
			$elm$core$List$foldl,
			F2(
				function (hd, res) {
					var _v0 = _Utils_Tuple2(res, hd);
					if (_v0.a.$ === 1) {
						var _v1 = _v0.a;
						return $elm$core$Maybe$Nothing;
					} else {
						if (_v0.b.$ === 1) {
							var _v2 = _v0.b;
							return $elm$core$Maybe$Nothing;
						} else {
							var tl = _v0.a.a;
							var x = _v0.b.a;
							return $elm$core$Maybe$Just(
								A2($elm$core$List$cons, x, tl));
						}
					}
				}),
			$elm$core$Maybe$Just(_List_Nil),
			xs));
};
var $danfishgold$base64_bytes$Basic$intToChar = function (n) {
	switch (n) {
		case 0:
			return $elm$core$Maybe$Just('A');
		case 1:
			return $elm$core$Maybe$Just('B');
		case 2:
			return $elm$core$Maybe$Just('C');
		case 3:
			return $elm$core$Maybe$Just('D');
		case 4:
			return $elm$core$Maybe$Just('E');
		case 5:
			return $elm$core$Maybe$Just('F');
		case 6:
			return $elm$core$Maybe$Just('G');
		case 7:
			return $elm$core$Maybe$Just('H');
		case 8:
			return $elm$core$Maybe$Just('I');
		case 9:
			return $elm$core$Maybe$Just('J');
		case 10:
			return $elm$core$Maybe$Just('K');
		case 11:
			return $elm$core$Maybe$Just('L');
		case 12:
			return $elm$core$Maybe$Just('M');
		case 13:
			return $elm$core$Maybe$Just('N');
		case 14:
			return $elm$core$Maybe$Just('O');
		case 15:
			return $elm$core$Maybe$Just('P');
		case 16:
			return $elm$core$Maybe$Just('Q');
		case 17:
			return $elm$core$Maybe$Just('R');
		case 18:
			return $elm$core$Maybe$Just('S');
		case 19:
			return $elm$core$Maybe$Just('T');
		case 20:
			return $elm$core$Maybe$Just('U');
		case 21:
			return $elm$core$Maybe$Just('V');
		case 22:
			return $elm$core$Maybe$Just('W');
		case 23:
			return $elm$core$Maybe$Just('X');
		case 24:
			return $elm$core$Maybe$Just('Y');
		case 25:
			return $elm$core$Maybe$Just('Z');
		case 26:
			return $elm$core$Maybe$Just('a');
		case 27:
			return $elm$core$Maybe$Just('b');
		case 28:
			return $elm$core$Maybe$Just('c');
		case 29:
			return $elm$core$Maybe$Just('d');
		case 30:
			return $elm$core$Maybe$Just('e');
		case 31:
			return $elm$core$Maybe$Just('f');
		case 32:
			return $elm$core$Maybe$Just('g');
		case 33:
			return $elm$core$Maybe$Just('h');
		case 34:
			return $elm$core$Maybe$Just('i');
		case 35:
			return $elm$core$Maybe$Just('j');
		case 36:
			return $elm$core$Maybe$Just('k');
		case 37:
			return $elm$core$Maybe$Just('l');
		case 38:
			return $elm$core$Maybe$Just('m');
		case 39:
			return $elm$core$Maybe$Just('n');
		case 40:
			return $elm$core$Maybe$Just('o');
		case 41:
			return $elm$core$Maybe$Just('p');
		case 42:
			return $elm$core$Maybe$Just('q');
		case 43:
			return $elm$core$Maybe$Just('r');
		case 44:
			return $elm$core$Maybe$Just('s');
		case 45:
			return $elm$core$Maybe$Just('t');
		case 46:
			return $elm$core$Maybe$Just('u');
		case 47:
			return $elm$core$Maybe$Just('v');
		case 48:
			return $elm$core$Maybe$Just('w');
		case 49:
			return $elm$core$Maybe$Just('x');
		case 50:
			return $elm$core$Maybe$Just('y');
		case 51:
			return $elm$core$Maybe$Just('z');
		case 52:
			return $elm$core$Maybe$Just('0');
		case 53:
			return $elm$core$Maybe$Just('1');
		case 54:
			return $elm$core$Maybe$Just('2');
		case 55:
			return $elm$core$Maybe$Just('3');
		case 56:
			return $elm$core$Maybe$Just('4');
		case 57:
			return $elm$core$Maybe$Just('5');
		case 58:
			return $elm$core$Maybe$Just('6');
		case 59:
			return $elm$core$Maybe$Just('7');
		case 60:
			return $elm$core$Maybe$Just('8');
		case 61:
			return $elm$core$Maybe$Just('9');
		case 62:
			return $elm$core$Maybe$Just('+');
		case 63:
			return $elm$core$Maybe$Just('/');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $danfishgold$base64_bytes$Decode$threeBytesToFourChars = F3(
	function (a, b, c) {
		var n = ((a * A2($elm$core$Basics$pow, 2, 16)) + (A2($elm$core$Maybe$withDefault, 0, b) * A2($elm$core$Basics$pow, 2, 8))) + A2($elm$core$Maybe$withDefault, 0, c);
		var c4 = _Utils_eq(c, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just('=') : $danfishgold$base64_bytes$Basic$intToChar(
			A2(
				$elm$core$Basics$modBy,
				A2($elm$core$Basics$pow, 2, 6),
				n));
		var c3 = (_Utils_eq(c, $elm$core$Maybe$Nothing) && _Utils_eq(b, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just('=') : $danfishgold$base64_bytes$Basic$intToChar(
			A2(
				$elm$core$Basics$modBy,
				A2($elm$core$Basics$pow, 2, 6),
				(n / A2($elm$core$Basics$pow, 2, 6)) | 0));
		var c2 = $danfishgold$base64_bytes$Basic$intToChar(
			A2(
				$elm$core$Basics$modBy,
				A2($elm$core$Basics$pow, 2, 6),
				(n / A2($elm$core$Basics$pow, 2, 12)) | 0));
		var c1 = $danfishgold$base64_bytes$Basic$intToChar(
			(n / A2($elm$core$Basics$pow, 2, 18)) | 0);
		return $danfishgold$base64_bytes$Basic$listFromMaybeList(
			_List_fromArray(
				[c1, c2, c3, c4]));
	});
var $danfishgold$base64_bytes$Basic$tripleMap = F2(
	function (fn, xs) {
		var reverseHelper = F3(
			function (fn_, xs_, ys) {
				reverseHelper:
				while (true) {
					if (xs_.b) {
						if (xs_.b.b) {
							if (xs_.b.b.b) {
								var hd = xs_.a;
								var _v1 = xs_.b;
								var nk = _v1.a;
								var _v2 = _v1.b;
								var tr = _v2.a;
								var tl = _v2.b;
								var $temp$fn_ = fn_,
									$temp$xs_ = tl,
									$temp$ys = A2(
									$elm$core$List$cons,
									A3(
										fn_,
										hd,
										$elm$core$Maybe$Just(nk),
										$elm$core$Maybe$Just(tr)),
									ys);
								fn_ = $temp$fn_;
								xs_ = $temp$xs_;
								ys = $temp$ys;
								continue reverseHelper;
							} else {
								var hd = xs_.a;
								var _v3 = xs_.b;
								var nk = _v3.a;
								return A2(
									$elm$core$List$cons,
									A3(
										fn_,
										hd,
										$elm$core$Maybe$Just(nk),
										$elm$core$Maybe$Nothing),
									ys);
							}
						} else {
							var hd = xs_.a;
							return A2(
								$elm$core$List$cons,
								A3(fn_, hd, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
								ys);
						}
					} else {
						return ys;
					}
				}
			});
		return $elm$core$List$reverse(
			A3(reverseHelper, fn, xs, _List_Nil));
	});
var $danfishgold$base64_bytes$Decode$intsToString = function (ints) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$String$fromList,
		A2(
			$elm$core$Maybe$map,
			$elm$core$List$concat,
			$danfishgold$base64_bytes$Basic$listFromMaybeList(
				A2($danfishgold$base64_bytes$Basic$tripleMap, $danfishgold$base64_bytes$Decode$threeBytesToFourChars, ints))));
};
var $danfishgold$base64_bytes$Decode$decoder = function (width) {
	return A2(
		$elm$bytes$Bytes$Decode$andThen,
		function (ints) {
			var _v0 = $danfishgold$base64_bytes$Decode$intsToString(ints);
			if (_v0.$ === 1) {
				return $elm$bytes$Bytes$Decode$fail;
			} else {
				var string = _v0.a;
				return $elm$bytes$Bytes$Decode$succeed(string);
			}
		},
		$danfishgold$base64_bytes$Decode$intsDecoder(width));
};
var $danfishgold$base64_bytes$Decode$fromBytes = function (bytes) {
	return A2(
		$elm$bytes$Bytes$Decode$decode,
		$danfishgold$base64_bytes$Decode$decoder(
			$elm$bytes$Bytes$width(bytes)),
		bytes);
};
var $danfishgold$base64_bytes$Base64$fromBytes = $danfishgold$base64_bytes$Decode$fromBytes;
var $elm$bytes$Bytes$Encode$Utf8 = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$string = function (str) {
	return A2(
		$elm$bytes$Bytes$Encode$Utf8,
		_Bytes_getStringWidth(str),
		str);
};
var $author$project$Encrypt$stringToEncodedInts = function (str) {
	return A2(
		$elm$core$Result$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$toList,
			$elm$core$List$map($elm$core$Char$toCode)),
		A2(
			$elm$core$Result$fromMaybe,
			$author$project$Encrypt$FailedToConverToToString('Not able to get base64 from salt bytes.'),
			$danfishgold$base64_bytes$Base64$fromBytes(
				$elm$bytes$Bytes$Encode$encode(
					$elm$bytes$Bytes$Encode$string(str)))));
};
var $danfishgold$base64_bytes$Encode$None = 0;
var $danfishgold$base64_bytes$Encode$One = 1;
var $danfishgold$base64_bytes$Encode$Two = 2;
var $danfishgold$base64_bytes$Basic$Nope = {$: 2};
var $danfishgold$base64_bytes$Basic$Number = function (a) {
	return {$: 0, a: a};
};
var $danfishgold$base64_bytes$Basic$Padding = {$: 1};
var $danfishgold$base64_bytes$Basic$charToInt6 = function (_char) {
	switch (_char) {
		case 'A':
			return $danfishgold$base64_bytes$Basic$Number(0);
		case 'B':
			return $danfishgold$base64_bytes$Basic$Number(1);
		case 'C':
			return $danfishgold$base64_bytes$Basic$Number(2);
		case 'D':
			return $danfishgold$base64_bytes$Basic$Number(3);
		case 'E':
			return $danfishgold$base64_bytes$Basic$Number(4);
		case 'F':
			return $danfishgold$base64_bytes$Basic$Number(5);
		case 'G':
			return $danfishgold$base64_bytes$Basic$Number(6);
		case 'H':
			return $danfishgold$base64_bytes$Basic$Number(7);
		case 'I':
			return $danfishgold$base64_bytes$Basic$Number(8);
		case 'J':
			return $danfishgold$base64_bytes$Basic$Number(9);
		case 'K':
			return $danfishgold$base64_bytes$Basic$Number(10);
		case 'L':
			return $danfishgold$base64_bytes$Basic$Number(11);
		case 'M':
			return $danfishgold$base64_bytes$Basic$Number(12);
		case 'N':
			return $danfishgold$base64_bytes$Basic$Number(13);
		case 'O':
			return $danfishgold$base64_bytes$Basic$Number(14);
		case 'P':
			return $danfishgold$base64_bytes$Basic$Number(15);
		case 'Q':
			return $danfishgold$base64_bytes$Basic$Number(16);
		case 'R':
			return $danfishgold$base64_bytes$Basic$Number(17);
		case 'S':
			return $danfishgold$base64_bytes$Basic$Number(18);
		case 'T':
			return $danfishgold$base64_bytes$Basic$Number(19);
		case 'U':
			return $danfishgold$base64_bytes$Basic$Number(20);
		case 'V':
			return $danfishgold$base64_bytes$Basic$Number(21);
		case 'W':
			return $danfishgold$base64_bytes$Basic$Number(22);
		case 'X':
			return $danfishgold$base64_bytes$Basic$Number(23);
		case 'Y':
			return $danfishgold$base64_bytes$Basic$Number(24);
		case 'Z':
			return $danfishgold$base64_bytes$Basic$Number(25);
		case 'a':
			return $danfishgold$base64_bytes$Basic$Number(26);
		case 'b':
			return $danfishgold$base64_bytes$Basic$Number(27);
		case 'c':
			return $danfishgold$base64_bytes$Basic$Number(28);
		case 'd':
			return $danfishgold$base64_bytes$Basic$Number(29);
		case 'e':
			return $danfishgold$base64_bytes$Basic$Number(30);
		case 'f':
			return $danfishgold$base64_bytes$Basic$Number(31);
		case 'g':
			return $danfishgold$base64_bytes$Basic$Number(32);
		case 'h':
			return $danfishgold$base64_bytes$Basic$Number(33);
		case 'i':
			return $danfishgold$base64_bytes$Basic$Number(34);
		case 'j':
			return $danfishgold$base64_bytes$Basic$Number(35);
		case 'k':
			return $danfishgold$base64_bytes$Basic$Number(36);
		case 'l':
			return $danfishgold$base64_bytes$Basic$Number(37);
		case 'm':
			return $danfishgold$base64_bytes$Basic$Number(38);
		case 'n':
			return $danfishgold$base64_bytes$Basic$Number(39);
		case 'o':
			return $danfishgold$base64_bytes$Basic$Number(40);
		case 'p':
			return $danfishgold$base64_bytes$Basic$Number(41);
		case 'q':
			return $danfishgold$base64_bytes$Basic$Number(42);
		case 'r':
			return $danfishgold$base64_bytes$Basic$Number(43);
		case 's':
			return $danfishgold$base64_bytes$Basic$Number(44);
		case 't':
			return $danfishgold$base64_bytes$Basic$Number(45);
		case 'u':
			return $danfishgold$base64_bytes$Basic$Number(46);
		case 'v':
			return $danfishgold$base64_bytes$Basic$Number(47);
		case 'w':
			return $danfishgold$base64_bytes$Basic$Number(48);
		case 'x':
			return $danfishgold$base64_bytes$Basic$Number(49);
		case 'y':
			return $danfishgold$base64_bytes$Basic$Number(50);
		case 'z':
			return $danfishgold$base64_bytes$Basic$Number(51);
		case '0':
			return $danfishgold$base64_bytes$Basic$Number(52);
		case '1':
			return $danfishgold$base64_bytes$Basic$Number(53);
		case '2':
			return $danfishgold$base64_bytes$Basic$Number(54);
		case '3':
			return $danfishgold$base64_bytes$Basic$Number(55);
		case '4':
			return $danfishgold$base64_bytes$Basic$Number(56);
		case '5':
			return $danfishgold$base64_bytes$Basic$Number(57);
		case '6':
			return $danfishgold$base64_bytes$Basic$Number(58);
		case '7':
			return $danfishgold$base64_bytes$Basic$Number(59);
		case '8':
			return $danfishgold$base64_bytes$Basic$Number(60);
		case '9':
			return $danfishgold$base64_bytes$Basic$Number(61);
		case '+':
			return $danfishgold$base64_bytes$Basic$Number(62);
		case '/':
			return $danfishgold$base64_bytes$Basic$Number(63);
		case '=':
			return $danfishgold$base64_bytes$Basic$Padding;
		default:
			return $danfishgold$base64_bytes$Basic$Nope;
	}
};
var $danfishgold$base64_bytes$Encode$fourCharsToInt24 = F4(
	function (a, b, c, d) {
		var _v0 = _Utils_Tuple3(b, c, d);
		if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
			var b_ = _v0.a.a;
			var c_ = _v0.b.a;
			var d_ = _v0.c.a;
			var _v1 = _Utils_Tuple2(
				$danfishgold$base64_bytes$Basic$charToInt6(a),
				$danfishgold$base64_bytes$Basic$charToInt6(b_));
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var n1 = _v1.a.a;
				var n2 = _v1.b.a;
				var _v2 = _Utils_Tuple2(
					$danfishgold$base64_bytes$Basic$charToInt6(c_),
					$danfishgold$base64_bytes$Basic$charToInt6(d_));
				_v2$3:
				while (true) {
					switch (_v2.a.$) {
						case 0:
							switch (_v2.b.$) {
								case 0:
									var n3 = _v2.a.a;
									var n4 = _v2.b.a;
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											(((n1 * A2($elm$core$Basics$pow, 2, 18)) + (n2 * A2($elm$core$Basics$pow, 2, 12))) + (n3 * A2($elm$core$Basics$pow, 2, 6))) + n4,
											0));
								case 1:
									var n3 = _v2.a.a;
									var _v3 = _v2.b;
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											((n1 * A2($elm$core$Basics$pow, 2, 18)) + (n2 * A2($elm$core$Basics$pow, 2, 12))) + (n3 * A2($elm$core$Basics$pow, 2, 6)),
											1));
								default:
									break _v2$3;
							}
						case 1:
							if (_v2.b.$ === 1) {
								var _v4 = _v2.a;
								var _v5 = _v2.b;
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(
										(n1 * A2($elm$core$Basics$pow, 2, 18)) + (n2 * A2($elm$core$Basics$pow, 2, 12)),
										2));
							} else {
								break _v2$3;
							}
						default:
							break _v2$3;
					}
				}
				return $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $danfishgold$base64_bytes$Encode$fourCharsToThreeInts = F4(
	function (a, b, c, d) {
		var _v0 = A4($danfishgold$base64_bytes$Encode$fourCharsToInt24, a, b, c, d);
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v1 = _v0.a;
			var n = _v1.a;
			var padding = _v1.b;
			var b3 = A2(
				$elm$core$Basics$modBy,
				A2($elm$core$Basics$pow, 2, 8),
				n);
			var b2 = A2(
				$elm$core$Basics$modBy,
				A2($elm$core$Basics$pow, 2, 8),
				(n / A2($elm$core$Basics$pow, 2, 8)) | 0);
			var b1 = A2(
				$elm$core$Basics$modBy,
				A2($elm$core$Basics$pow, 2, 8),
				(((n / A2($elm$core$Basics$pow, 2, 8)) | 0) / A2($elm$core$Basics$pow, 2, 8)) | 0);
			switch (padding) {
				case 0:
					return $elm$core$Maybe$Just(
						_List_fromArray(
							[b1, b2, b3]));
				case 1:
					return $elm$core$Maybe$Just(
						_List_fromArray(
							[b1, b2]));
				default:
					return $elm$core$Maybe$Just(
						_List_fromArray(
							[b1]));
			}
		}
	});
var $danfishgold$base64_bytes$Basic$quadMap = F2(
	function (fn, xs) {
		var reverseHelper = F3(
			function (fn_, xs_, ys) {
				reverseHelper:
				while (true) {
					if (xs_.b) {
						if (xs_.b.b) {
							if (xs_.b.b.b) {
								if (xs_.b.b.b.b) {
									var hd = xs_.a;
									var _v1 = xs_.b;
									var nk = _v1.a;
									var _v2 = _v1.b;
									var tr = _v2.a;
									var _v3 = _v2.b;
									var pl = _v3.a;
									var tl = _v3.b;
									var $temp$fn_ = fn_,
										$temp$xs_ = tl,
										$temp$ys = A2(
										$elm$core$List$cons,
										A4(
											fn_,
											hd,
											$elm$core$Maybe$Just(nk),
											$elm$core$Maybe$Just(tr),
											$elm$core$Maybe$Just(pl)),
										ys);
									fn_ = $temp$fn_;
									xs_ = $temp$xs_;
									ys = $temp$ys;
									continue reverseHelper;
								} else {
									var hd = xs_.a;
									var _v4 = xs_.b;
									var nk = _v4.a;
									var _v5 = _v4.b;
									var tr = _v5.a;
									return A2(
										$elm$core$List$cons,
										A4(
											fn_,
											hd,
											$elm$core$Maybe$Just(nk),
											$elm$core$Maybe$Just(tr),
											$elm$core$Maybe$Nothing),
										ys);
								}
							} else {
								var hd = xs_.a;
								var _v6 = xs_.b;
								var nk = _v6.a;
								return A2(
									$elm$core$List$cons,
									A4(
										fn_,
										hd,
										$elm$core$Maybe$Just(nk),
										$elm$core$Maybe$Nothing,
										$elm$core$Maybe$Nothing),
									ys);
							}
						} else {
							var hd = xs_.a;
							return A2(
								$elm$core$List$cons,
								A4(fn_, hd, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
								ys);
						}
					} else {
						return ys;
					}
				}
			});
		return $elm$core$List$reverse(
			A3(reverseHelper, fn, xs, _List_Nil));
	});
var $danfishgold$base64_bytes$Encode$stringToInts = function (string) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$List$concat,
		$danfishgold$base64_bytes$Basic$listFromMaybeList(
			A2(
				$danfishgold$base64_bytes$Basic$quadMap,
				$danfishgold$base64_bytes$Encode$fourCharsToThreeInts,
				$elm$core$String$toList(string))));
};
var $danfishgold$base64_bytes$Encode$encoder = function (string) {
	return A2(
		$elm$core$Maybe$map,
		$elm$bytes$Bytes$Encode$sequence,
		A2(
			$elm$core$Maybe$map,
			$elm$core$List$map($elm$bytes$Bytes$Encode$unsignedInt8),
			$danfishgold$base64_bytes$Encode$stringToInts(string)));
};
var $danfishgold$base64_bytes$Encode$toBytes = function (string) {
	return A2(
		$elm$core$Maybe$map,
		$elm$bytes$Bytes$Encode$encode,
		$danfishgold$base64_bytes$Encode$encoder(string));
};
var $danfishgold$base64_bytes$Base64$toBytes = $danfishgold$base64_bytes$Encode$toBytes;
var $author$project$Encrypt$xorDecrypt = F2(
	function (salt, msg) {
		var saltCodes_ = $author$project$Encrypt$stringToEncodedInts(salt);
		if (!$elm$core$String$length(salt)) {
			return $elm$core$Result$Err($author$project$Encrypt$BlankSalt);
		} else {
			if (!$elm$core$String$length(msg)) {
				return $elm$core$Result$Err($author$project$Encrypt$BlankMsg);
			} else {
				if (!saltCodes_.$) {
					var saltCodes = saltCodes_.a;
					return A2(
						$elm$core$Result$andThen,
						function (bytes) {
							return A2(
								$elm$core$Result$fromMaybe,
								$author$project$Encrypt$FailedToReadBase64('Not decoding bytes properly'),
								A2(
									$elm$bytes$Bytes$Decode$decode,
									$elm$bytes$Bytes$Decode$string(
										$elm$bytes$Bytes$width(bytes)),
									bytes));
						},
						A2(
							$elm$core$Result$andThen,
							function (x) {
								return A2(
									$elm$core$Result$fromMaybe,
									$author$project$Encrypt$FailedToReadBase64('base64 string to bytes failed.'),
									$danfishgold$base64_bytes$Base64$toBytes(x));
							},
							A2(
								$elm$core$Result$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$map($elm$core$Char$fromCode),
									$elm$core$String$fromList),
								A2(
									$elm$core$Result$andThen,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Utils$listSplitFirst($author$project$Encrypt$endMarker),
										$elm$core$Result$fromMaybe(
											$author$project$Encrypt$FailedToDecrypt('Delimiter not found in decrypted password.'))),
									A2(
										$elm$core$Result$map,
										function (msgCodes) {
											return A3(
												$elm$core$List$map2,
												F2(
													function (saltCode, msgCode) {
														return saltCode ^ msgCode;
													}),
												saltCodes,
												msgCodes);
										},
										A2(
											$elm$core$Result$mapError,
											$author$project$Encrypt$FailedToReadBase64,
											$author$project$Base64Bis$decode(msg)))))));
				} else {
					var err = saltCodes_.a;
					return $elm$core$Result$Err(err);
				}
			}
		}
	});
var $author$project$Encrypt$Base64EncodeError = function (a) {
	return {$: 4, a: a};
};
var $author$project$Encrypt$ShortSalt = {$: 2};
var $author$project$Encrypt$WeakSalt = {$: 3};
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Coder$encodeChunk = F2(
	function (scheme, chunk) {
		var octets = scheme.bY;
		var chars = scheme.bF;
		var padChar = scheme.b1;
		var intToChar = scheme.bR;
		var charToInt = scheme.bE;
		var bits = $elm$core$Basics$floor((octets * 8) / chars);
		return A2(
			$elm$core$Result$map,
			$elm$core$String$fromList,
			$elm_community$result_extra$Result$Extra$combine(
				A2(
					$elm$core$List$map,
					function (i) {
						var start = i * bits;
						var end = start + bits;
						var b = $elm$core$Basics$floor((end - 1) / 8);
						var aShift = (_Utils_cmp(
							A2($elm$core$Basics$modBy, 8, start),
							8 - bits) < 0) ? (8 - A2($elm$core$Basics$modBy, 8, end)) : ((8 - bits) - A2($elm$core$Basics$modBy, 8, start));
						var a = $elm$core$Basics$floor(start / 8);
						var bShift = _Utils_eq(a, b) ? aShift : (8 - A2($elm$core$Basics$modBy, 8, end));
						var _byte = A2(
							$elm$core$Maybe$withDefault,
							0,
							A3(
								$elm$core$Maybe$map2,
								F2(
									function (x, y) {
										return (A2($elm$core$Basics$pow, 2, bits) - 1) & (((aShift < 0) ? (x << (-aShift)) : (x >>> aShift)) | (y >>> bShift));
									}),
								A2($elm_community$list_extra$List$Extra$getAt, a, chunk),
								A2($elm_community$list_extra$List$Extra$getAt, b, chunk)));
						return intToChar(_byte);
					},
					A2($elm$core$List$range, 0, chars - 1))));
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Coder$encode = F2(
	function (scheme, bytes) {
		var octets = scheme.bY;
		var chars = scheme.bF;
		var padChar = scheme.b1;
		var intToChar = scheme.bR;
		var charToInt = scheme.bE;
		var n = $elm$core$Basics$ceiling(
			($elm$core$List$length(bytes) * chars) / octets);
		var p = (A2($elm$core$Basics$modBy, chars, n) > 0) ? (chars - A2($elm$core$Basics$modBy, chars, n)) : 0;
		var data = _Utils_ap(
			bytes,
			A2(
				$elm$core$List$repeat,
				(A2(
					$elm$core$Basics$modBy,
					octets,
					$elm$core$List$length(bytes)) > 0) ? (octets - A2(
					$elm$core$Basics$modBy,
					octets,
					$elm$core$List$length(bytes))) : 0,
				0));
		return A2(
			$elm$core$Result$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$join(''),
				A2(
					$elm$core$Basics$composeR,
					A2($elm$core$String$slice, 0, n),
					function (x) {
						return A2(
							$elm$core$String$append,
							x,
							A2($elm$core$String$repeat, p, padChar));
					})),
			$elm_community$result_extra$Result$Extra$combine(
				A2(
					$elm$core$List$map,
					$author$project$Coder$encodeChunk(scheme),
					A2($elm_community$list_extra$List$Extra$groupsOf, octets, data))));
	});
var $author$project$Base64Bis$encode = $author$project$Coder$encode($author$project$Base64Bis$scheme);
var $author$project$Encrypt$endMarkerLength = $elm$core$List$length($author$project$Encrypt$endMarker);
var $author$project$Encrypt$xorEncrypt = F2(
	function (salt, msg) {
		var saltCodes_ = $author$project$Encrypt$stringToEncodedInts(salt);
		var msgCodes_ = $author$project$Encrypt$stringToEncodedInts(msg);
		if (!$elm$core$String$length(salt)) {
			return $elm$core$Result$Err($author$project$Encrypt$BlankSalt);
		} else {
			if (!$elm$core$String$length(msg)) {
				return $elm$core$Result$Err($author$project$Encrypt$BlankMsg);
			} else {
				var _v0 = _Utils_Tuple2(saltCodes_, msgCodes_);
				_v0$1:
				while (true) {
					if (!_v0.a.$) {
						if (!_v0.b.$) {
							var saltCodes = _v0.a.a;
							var msgCodes = _v0.b.a;
							var saltLength = $elm$core$List$length(saltCodes);
							var msgLength = $elm$core$List$length(msgCodes);
							var times = $elm$core$Basics$ceiling(saltLength / msgLength);
							var msgMatched = A2(
								$elm$core$List$take,
								saltLength,
								$elm$core$List$concat(
									A2(
										$elm$core$List$repeat,
										times,
										function (x) {
											return _Utils_ap(x, $author$project$Encrypt$endMarker);
										}(msgCodes))));
							return (_Utils_cmp(saltLength, msgLength + $author$project$Encrypt$endMarkerLength) < 0) ? $elm$core$Result$Err($author$project$Encrypt$ShortSalt) : ((saltLength < 128) ? $elm$core$Result$Err($author$project$Encrypt$WeakSalt) : A2(
								$elm$core$Result$mapError,
								$author$project$Encrypt$Base64EncodeError,
								$author$project$Base64Bis$encode(
									A3(
										$elm$core$List$map2,
										F2(
											function (saltCode, msgCode) {
												return saltCode ^ msgCode;
											}),
										saltCodes,
										msgMatched))));
						} else {
							break _v0$1;
						}
					} else {
						if (_v0.b.$ === 1) {
							break _v0$1;
						} else {
							var err = _v0.a.a;
							return $elm$core$Result$Err(err);
						}
					}
				}
				var err = _v0.b.a;
				return $elm$core$Result$Err(err);
			}
		}
	});
var $author$project$OctoVault$handleGasRelayReply = F3(
	function (subModel, maybeReply, model) {
		var session = model.b7;
		if (maybeReply.$ === 1) {
			return $Chadtech$return$Return2$withNoCmd(
				A2(
					$author$project$OctoVault$setPage,
					$author$project$Model$GasRelay(subModel),
					model));
		} else {
			switch (maybeReply.a.$) {
				case 1:
					var _v47 = maybeReply.a;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$OctoVault$update,
						$author$project$Model$Close,
						$author$project$OctoVault$goHome(
							A2(
								$author$project$OctoVault$setPage,
								$author$project$Model$GasRelay(subModel),
								model)));
				case 0:
					var _v48 = maybeReply.a;
					return A2(
						$Chadtech$return$Return2$withCmd,
						session.s ? $author$project$PostMessage$sendMessage(
							_Utils_Tuple2(
								$elm$json$Json$Encode$string($author$project$PostMessage$messageReady),
								model.bz)) : $elm$core$Platform$Cmd$none,
						A2(
							$author$project$OctoVault$setPage,
							$author$project$Model$GasRelay(subModel),
							model));
				default:
					var _v49 = maybeReply.a;
					var requestId = _v49.a;
					var response = _v49.b;
					var hasError = _v49.c;
					if (!hasError) {
						return A2(
							$Chadtech$return$Return2$withCmd,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$PostMessage$sendMessage(
										_Utils_Tuple2(
											A2(
												$elm$json$Json$Encode$list,
												$elm$core$Basics$identity,
												_List_fromArray(
													[
														$elm$json$Json$Encode$string($author$project$PostMessage$executeTransactionsResponse),
														$elm$json$Json$Encode$int(requestId),
														response,
														$elm$json$Json$Encode$bool(hasError)
													])),
											model.bz))
									])),
							A2(
								$author$project$OctoVault$setPage,
								$author$project$Model$GasRelay(subModel),
								_Utils_update(
									model,
									{b8: true})));
					} else {
						return A2(
							$Chadtech$return$Return2$withCmd,
							$author$project$PostMessage$sendMessage(
								_Utils_Tuple2(
									A2(
										$elm$json$Json$Encode$list,
										$elm$core$Basics$identity,
										_List_fromArray(
											[
												$elm$json$Json$Encode$string($author$project$PostMessage$executeTransactionsResponse),
												$elm$json$Json$Encode$int(requestId),
												response,
												$elm$json$Json$Encode$bool(hasError)
											])),
									model.bz)),
							A2(
								$author$project$OctoVault$setPage,
								$author$project$Model$GasRelay(subModel),
								model));
					}
			}
		}
	});
var $author$project$OctoVault$handleHomeReply = F3(
	function (subModel, maybeReply, model_) {
		var model = A2(
			$author$project$OctoVault$setPage,
			$author$project$Model$Home(subModel),
			model_);
		if (maybeReply.$ === 1) {
			return $Chadtech$return$Return2$withNoCmd(model);
		} else {
			switch (maybeReply.a.$) {
				case 0:
					var _v36 = maybeReply.a;
					var _v37 = $author$project$Page$Import$init;
					var newSubModel = _v37.a;
					var subCmd = _v37.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b2: $author$project$Model$Import(newSubModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Model$FromImport, subCmd));
				case 1:
					var _v38 = maybeReply.a;
					var _v39 = $author$project$Page$Create$init;
					var newSubModel = _v39.a;
					var subCmd = _v39.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b2: $author$project$Model$Create(newSubModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Model$FromCreate, subCmd));
				case 6:
					var _v40 = maybeReply.a;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$OctoVault$update,
						$author$project$Model$Close,
						$Chadtech$return$Return2$withNoCmd(model));
				case 2:
					var accountAddress = maybeReply.a.a;
					var session = model.b7;
					var newSession = _Utils_update(
						session,
						{
							bB: true,
							t: $elm$core$Maybe$Just(accountAddress)
						});
					var account_ = A2($turboMaCk$any_dict$Dict$Any$get, accountAddress, session.i);
					var _v41 = _Utils_Tuple2(account_, session.f);
					if ((!_v41.a.$) && (!_v41.b.$)) {
						var account = _v41.a.a;
						var password = _v41.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{b7: newSession, b8: true}),
							$author$project$Ports$open(
								{W: account.W, p: account.p, f: password}));
					} else {
						return $Chadtech$return$Return2$withNoCmd(model);
					}
				case 3:
					var _v42 = maybeReply.a;
					var accountAddress = _v42.a;
					var accountName = _v42.b;
					var session = model.b7;
					var newAccounts = A3(
						$turboMaCk$any_dict$Dict$Any$update,
						accountAddress,
						function (x) {
							if (!x.$) {
								var account = x.a;
								return $elm$core$Maybe$Just(
									_Utils_update(
										account,
										{p: accountName}));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						session.i);
					var newSession = _Utils_update(
						session,
						{i: newAccounts});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b7: newSession}),
						$author$project$OctoVault$storeStorage(newSession));
				case 5:
					var accountAddress = maybeReply.a.a;
					var session = model.b7;
					var account_ = A2($turboMaCk$any_dict$Dict$Any$get, accountAddress, session.i);
					var _v44 = _Utils_Tuple2(account_, session.f);
					if ((!_v44.a.$) && (!_v44.b.$)) {
						var account = _v44.a.a;
						var password = _v44.b.a;
						return _Utils_Tuple2(
							model,
							$author$project$Ports$exportPrivateKey(
								{W: account.W, p: account.p, f: password}));
					} else {
						return $Chadtech$return$Return2$withNoCmd(model);
					}
				default:
					var accountAddress = maybeReply.a.a;
					var session = model.b7;
					var newAccounts = A2($turboMaCk$any_dict$Dict$Any$remove, accountAddress, session.i);
					var _v45 = _Utils_eq(
						session.t,
						$elm$core$Maybe$Just(accountAddress)) ? _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						$author$project$PostMessage$sendMessage(
							_Utils_Tuple2(
								A2(
									$elm$json$Json$Encode$list,
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											$elm$json$Json$Encode$string($author$project$PostMessage$messageAccount),
											$elm$json$Json$Encode$null
										])),
								model.bz))) : _Utils_Tuple2(session.t, $elm$core$Platform$Cmd$none);
					var newSelectedAccount = _v45.a;
					var cmd = _v45.b;
					var newSession = _Utils_update(
						session,
						{i: newAccounts, t: newSelectedAccount});
					return _Utils_Tuple2(
						A2(
							$author$project$OctoVault$setPage,
							$author$project$Model$Home(subModel),
							_Utils_update(
								model,
								{b7: newSession})),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$OctoVault$storeStorage(newSession),
									cmd
								])));
			}
		}
	});
var $author$project$OctoVault$handleInitializeReply = F3(
	function (subModel, maybeReply, model) {
		if (maybeReply.$ === 1) {
			return $Chadtech$return$Return2$withNoCmd(
				A2(
					$author$project$OctoVault$setPage,
					$author$project$Model$Initialize(subModel),
					model));
		} else {
			if (maybeReply.a.$ === 1) {
				var _v33 = maybeReply.a;
				return A2($author$project$OctoVault$update, $author$project$Model$Close, model);
			} else {
				var password = maybeReply.a.a;
				var session = model.b7;
				var _v34 = $author$project$Page$Home$init;
				var newSubModel = _v34.a;
				var subCmd = _v34.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							b2: $author$project$Model$Home(newSubModel),
							b7: _Utils_update(
								session,
								{
									f: $elm$core$Maybe$Just(password)
								})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$create(
								{p: $author$project$Constants$defaultKeyName, f: password}),
								A2($elm$core$Platform$Cmd$map, $author$project$Model$FromHome, subCmd)
							])));
			}
		}
	});
var $author$project$OctoVault$handleSignReply = F3(
	function (subModel, maybeReply, model) {
		var session = model.b7;
		if (maybeReply.$ === 1) {
			return $Chadtech$return$Return2$withNoCmd(
				A2(
					$author$project$OctoVault$setPage,
					$author$project$Model$Sign(subModel),
					model));
		} else {
			if (!maybeReply.a.$) {
				var _v30 = maybeReply.a;
				var requestId = _v30.a;
				var message = _v30.b;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$OctoVault$update,
					$author$project$Model$Close,
					A2(
						$Chadtech$return$Return2$addCmd,
						$author$project$Ports$signOnJs(
							_Utils_Tuple2(
								requestId,
								$elm$json$Json$Encode$string(message))),
						$author$project$OctoVault$goHome(
							A2(
								$author$project$OctoVault$setPage,
								$author$project$Model$Sign(subModel),
								model))));
			} else {
				var _v31 = maybeReply.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$OctoVault$update,
					$author$project$Model$Close,
					$author$project$OctoVault$goHome(
						A2(
							$author$project$OctoVault$setPage,
							$author$project$Model$Sign(subModel),
							model)));
			}
		}
	});
var $author$project$OctoVault$handleUnlockReply = F3(
	function (subModel, maybeReply, model) {
		if (maybeReply.$ === 1) {
			return $Chadtech$return$Return2$withNoCmd(
				A2(
					$author$project$OctoVault$setPage,
					$author$project$Model$Unlock(subModel),
					model));
		} else {
			if (maybeReply.a.$ === 1) {
				var _v28 = maybeReply.a;
				return A2(
					$author$project$OctoVault$update,
					$author$project$Model$Close,
					A2(
						$author$project$OctoVault$setPage,
						$author$project$Model$Unlock(subModel),
						model));
			} else {
				var password = maybeReply.a.a;
				return A2(
					$author$project$OctoVault$unlockAccount,
					password,
					A2(
						$author$project$OctoVault$setPage,
						$author$project$Model$Unlock(subModel),
						model));
			}
		}
	});
var $author$project$OctoVault$update = F2(
	function (msg, model) {
		var session = model.b7;
		switch (msg.$) {
			case 0:
				var urlRequest = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var url = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				var subMsg = msg.a;
				var _v1 = model.b2;
				if (!_v1.$) {
					var subModel = _v1.a;
					return A3(
						$Chadtech$return$Return3$incorp,
						$author$project$OctoVault$handleUnlockReply,
						model,
						A2(
							$Chadtech$return$Return3$mapCmd,
							$author$project$Model$FromUnlock,
							A3($author$project$Page$Unlock$update, session, subMsg, subModel)));
				} else {
					return $Chadtech$return$Return2$withNoCmd(model);
				}
			case 3:
				var subMsg = msg.a;
				var _v2 = model.b2;
				if (_v2.$ === 1) {
					var subModel = _v2.a;
					return A3(
						$Chadtech$return$Return3$incorp,
						$author$project$OctoVault$handleImportReply,
						model,
						A2(
							$Chadtech$return$Return3$mapCmd,
							$author$project$Model$FromImport,
							A3($author$project$Page$Import$update, session, subMsg, subModel)));
				} else {
					return $Chadtech$return$Return2$withNoCmd(model);
				}
			case 4:
				var subMsg = msg.a;
				var _v3 = model.b2;
				if (_v3.$ === 2) {
					var subModel = _v3.a;
					return A3(
						$Chadtech$return$Return3$incorp,
						$author$project$OctoVault$handleCreateReply,
						model,
						A2(
							$Chadtech$return$Return3$mapCmd,
							$author$project$Model$FromCreate,
							A3($author$project$Page$Create$update, session, subMsg, subModel)));
				} else {
					return $Chadtech$return$Return2$withNoCmd(model);
				}
			case 5:
				var subMsg = msg.a;
				var _v4 = model.b2;
				if (_v4.$ === 3) {
					var subModel = _v4.a;
					return A3(
						$Chadtech$return$Return3$incorp,
						$author$project$OctoVault$handleHomeReply,
						model,
						A2(
							$Chadtech$return$Return3$mapCmd,
							$author$project$Model$FromHome,
							A3($author$project$Page$Home$update, session, subMsg, subModel)));
				} else {
					return $Chadtech$return$Return2$withNoCmd(model);
				}
			case 6:
				var subMsg = msg.a;
				var _v5 = model.b2;
				if (_v5.$ === 4) {
					var subModel = _v5.a;
					return A3(
						$Chadtech$return$Return3$incorp,
						$author$project$OctoVault$handleInitializeReply,
						model,
						A2(
							$Chadtech$return$Return3$mapCmd,
							$author$project$Model$FromInitialize,
							A3($author$project$Page$Initialize$update, session, subMsg, subModel)));
				} else {
					return $Chadtech$return$Return2$withNoCmd(model);
				}
			case 7:
				var subMsg = msg.a;
				var _v6 = model.b2;
				if (_v6.$ === 5) {
					var subModel = _v6.a;
					return A3(
						$Chadtech$return$Return3$incorp,
						$author$project$OctoVault$handleGasRelayReply,
						model,
						A2(
							$Chadtech$return$Return3$mapCmd,
							$author$project$Model$FromGasRelay,
							A3($author$project$Page$GasRelay$update, session, subMsg, subModel)));
				} else {
					return $Chadtech$return$Return2$withNoCmd(model);
				}
			case 8:
				var subMsg = msg.a;
				var _v7 = model.b2;
				if (_v7.$ === 6) {
					var subModel = _v7.a;
					return A3(
						$Chadtech$return$Return3$incorp,
						$author$project$OctoVault$handleSignReply,
						model,
						A2(
							$Chadtech$return$Return3$mapCmd,
							$author$project$Model$FromSign,
							A3($author$project$Page$Sign$update, session, subMsg, subModel)));
				} else {
					return $Chadtech$return$Return2$withNoCmd(model);
				}
			case 9:
				var postMessageEvent = msg.a;
				var decodedMessage = $author$project$PostMessage$decodeMessageToIframe(postMessageEvent);
				if (!decodedMessage.$) {
					var m = decodedMessage.a;
					var allowed = $author$project$OctoVault$isOperationAllowed(model);
					switch (m.$) {
						case 0:
							var requestId = m.a;
							var message = m.b;
							var newModel = _Utils_update(
								model,
								{
									b7: _Utils_update(
										session,
										{J: true}),
									b8: false
								});
							if (allowed) {
								var _v10 = A2($author$project$Page$Sign$init, requestId, message);
								var subModel = _v10.a;
								var subCmd = _v10.b;
								return A3(
									$Chadtech$return$Return3$incorp,
									$author$project$OctoVault$handleSignReply,
									newModel,
									$Chadtech$return$Return3$withNoReply(
										A2(
											$Chadtech$return$Return2$mapCmd,
											$author$project$Model$FromSign,
											_Utils_Tuple2(subModel, subCmd))));
							} else {
								return _Utils_Tuple2(
									_Utils_update(
										newModel,
										{
											bV: A2($francescortiz$elm_queue$Queue$enqueueUnkeyed, msg, newModel.bV)
										}),
									$elm$core$Platform$Cmd$none);
							}
						case 1:
							var requestId = m.a;
							var value = m.b;
							var newModel = _Utils_update(
								model,
								{
									b7: _Utils_update(
										session,
										{J: true}),
									b8: false
								});
							if (allowed) {
								var _v11 = $author$project$Page$GasRelay$init;
								var subModel = _v11.a;
								return A3(
									$Chadtech$return$Return3$incorp,
									$author$project$OctoVault$handleGasRelayReply,
									newModel,
									A2(
										$Chadtech$return$Return3$mapCmd,
										$author$project$Model$FromGasRelay,
										A3(
											$author$project$Page$GasRelay$update,
											session,
											A2($author$project$Page$GasRelay$AddTransactions, requestId, value),
											subModel)));
							} else {
								return _Utils_Tuple2(
									_Utils_update(
										newModel,
										{
											bV: A2($francescortiz$elm_queue$Queue$enqueueUnkeyed, msg, newModel.bV)
										}),
									$elm$core$Platform$Cmd$none);
							}
						case 2:
							var newGasRelayUrl = m.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										b7: _Utils_update(
											session,
											{a5: newGasRelayUrl})
									}),
								$elm$core$Platform$Cmd$none);
						default:
							var open = m.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										b7: _Utils_update(
											session,
											{J: open})
									}),
								$elm$core$Platform$Cmd$none);
					}
				} else {
					var err = decodedMessage.a;
					return _Utils_Tuple2(
						model,
						$author$project$Ports$log(
							function (x) {
								return 'At `OtoVault -> update -> ReceiveMessage`:\n' + x;
							}(
								$elm$json$Json$Decode$errorToString(err))));
				}
			case 12:
				var _v12 = msg.a;
				var status = _v12.a;
				var requestId = _v12.b;
				var signedMessage = _v12.c;
				return _Utils_Tuple2(
					model,
					session.s ? $author$project$PostMessage$sendMessage(
						_Utils_Tuple2(
							A2(
								$elm$json$Json$Encode$list,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$elm$json$Json$Encode$string($author$project$PostMessage$messageSigned),
										$elm$json$Json$Encode$string(status),
										$elm$json$Json$Encode$int(requestId),
										signedMessage
									])),
							model.bz)) : $elm$core$Platform$Cmd$none);
			case 13:
				var _v13 = msg.a;
				var key = _v13.a;
				var value = _v13.b;
				if (key === 'sspKey') {
					return A2(
						$Chadtech$return$Return2$withCmd,
						A2($author$project$OctoVault$getSSPData, $author$project$Model$SSPDataResult, value),
						model);
				} else {
					if (key === 'encryptedPassword') {
						var _v14 = model.b9;
						if (!_v14.$) {
							var sspData = _v14.a;
							var decryptedPassword = $elm$core$Result$toMaybe(
								A2($author$project$Encrypt$xorDecrypt, sspData.b5, value));
							if (!decryptedPassword.$) {
								var password = decryptedPassword.a;
								var newSession = _Utils_update(
									session,
									{f: decryptedPassword});
								var newModel = _Utils_update(
									model,
									{b7: newSession});
								return A2($author$project$OctoVault$unlockAccount, password, newModel);
							} else {
								return $Chadtech$return$Return2$withNoCmd(model);
							}
						} else {
							return $Chadtech$return$Return2$withNoCmd(model);
						}
					} else {
						return $Chadtech$return$Return2$withNoCmd(model);
					}
				}
			case 14:
				if (!msg.a.$) {
					var sspData = msg.a.a;
					return A2(
						$Chadtech$return$Return2$withCmd,
						$author$project$Ports$readFromSessionStorage('encryptedPassword'),
						_Utils_update(
							model,
							{
								b9: $elm$core$Maybe$Just(sspData)
							}));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						model,
						function () {
							if (err.$ === 4) {
								var errStr = err.a;
								return $author$project$Ports$log(
									function (x) {
										return 'OctoVault.update -> SSPDataResult -> BadBody:\n' + x;
									}(errStr));
							} else {
								return $author$project$Ports$log(
									function (x) {
										return 'OctoVault.update -> SSPDataResult -> err:\n' + x;
									}(
										$NoRedInk$elm_string_conversions$String$Conversions$fromHttpError(err)));
							}
						}());
				}
			case 15:
				if (!msg.a.$) {
					return $Chadtech$return$Return2$withNoCmd(model);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$Ports$log(
							function (x) {
								return 'OctoVault.update -> PostSSPDataResult -> err:\n' + x;
							}(
								$NoRedInk$elm_string_conversions$String$Conversions$fromHttpError(err))));
				}
			case 10:
				if (msg.a.$ === 1) {
					var err = msg.a.a;
					return $Chadtech$return$Return2$withNoCmd(model);
				} else {
					var result = msg.a.a;
					if (!result.b.$) {
						var resultData = result.b.a;
						var newAccounts = A3($turboMaCk$any_dict$Dict$Any$insert, resultData.aF, resultData, session.i);
						var newSession = $author$project$Components$notBusyAnymore(
							_Utils_update(
								session,
								{
									i: newAccounts,
									t: $elm$core$Maybe$Just(resultData.aF)
								}));
						var account = {};
						var _v19 = $author$project$Page$Home$init;
						var newSubModel = _v19.a;
						var subCmd = _v19.b;
						var newModel = _Utils_update(
							model,
							{
								b2: $author$project$Model$Home(newSubModel),
								b7: newSession
							});
						var _v20 = $francescortiz$elm_queue$Queue$startUnkeyed(model.bV);
						var newMsgQueue = _v20.a;
						var msgsToExecute = _v20.b;
						var msgToExecute = $elm$core$List$head(msgsToExecute);
						return function (x) {
							if (msgToExecute.$ === 1) {
								return x;
							} else {
								var msg_ = msgToExecute.a;
								return A3($ccapndave$elm_update_extra$Update$Extra$andThen, $author$project$OctoVault$update, msg_, x);
							}
						}(
							_Utils_Tuple2(
								newModel,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$OctoVault$storeStorage(newSession),
											A2($elm$core$Platform$Cmd$map, $author$project$Model$FromHome, subCmd),
											session.s ? $author$project$PostMessage$sendMessage(
											_Utils_Tuple2(
												A2(
													$elm$json$Json$Encode$list,
													$elm$core$Basics$identity,
													_List_fromArray(
														[
															$elm$json$Json$Encode$string($author$project$PostMessage$messageAccount),
															$author$project$EthereumAddress$encode(resultData.aF)
														])),
												newModel.bz)) : $author$project$PostMessage$sendMessage(
											_Utils_Tuple2(
												A2(
													$elm$json$Json$Encode$list,
													$elm$core$Basics$identity,
													_List_fromArray(
														[
															$elm$json$Json$Encode$string($author$project$PostMessage$messageAccount),
															$elm$json$Json$Encode$null
														])),
												newModel.bz)),
											function () {
											var _v21 = newModel.b9;
											if (!_v21.$) {
												var sspData = _v21.a;
												return $elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[
															A2($author$project$OctoVault$postSSPData, $author$project$Model$PostSSPDataResult, sspData),
															$author$project$Ports$writeToSessionStorage(
															_Utils_Tuple2(
																'encryptedPassword',
																A2(
																	$elm$core$Result$withDefault,
																	'',
																	A2(
																		$author$project$Encrypt$xorEncrypt,
																		sspData.b5,
																		A2($elm$core$Maybe$withDefault, '', session.f)))))
														]));
											} else {
												return A2($elm$random$Random$generate, $author$project$Model$SSPDataGenerated, $author$project$OctoVault$sspDataGenerator);
											}
										}()
										]))));
					} else {
						if (!result.a.$) {
							var err = result.a.a;
							var _v18 = result.b;
							var newSession = $author$project$Components$notBusyAnymore(session);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{b7: newSession}),
								$author$project$Ports$alert(err));
						} else {
							var _v23 = result.a;
							var _v24 = result.b;
							var newSession = $author$project$Components$notBusyAnymore(session);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{b7: newSession}),
								$elm$core$Platform$Cmd$none);
						}
					}
				}
			case 11:
				var privateKey = msg.a;
				var newModelPage = function () {
					var _v25 = model.b2;
					if (_v25.$ === 3) {
						var subModel = _v25.a;
						return $author$project$Model$Home(
							_Utils_update(
								subModel,
								{
									bH: $elm$core$Maybe$Just(
										_Utils_Tuple3($elm$core$Maybe$Nothing, 'Copy the private key somewhere safe.', privateKey))
								}));
					} else {
						return model.b2;
					}
				}();
				return $Chadtech$return$Return2$withNoCmd(
					_Utils_update(
						model,
						{b2: newModelPage}));
			case 16:
				var newSSPData = msg.a;
				return A2(
					$Chadtech$return$Return2$withCmd,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$writeToSessionStorage(
								_Utils_Tuple2('sspKey', newSSPData.bS)),
								$author$project$Ports$writeToSessionStorage(
								_Utils_Tuple2(
									'encryptedPassword',
									A2(
										$elm$core$Result$withDefault,
										'',
										A2(
											$author$project$Encrypt$xorEncrypt,
											newSSPData.b5,
											A2($elm$core$Maybe$withDefault, '', session.f))))),
								A2($author$project$OctoVault$postSSPData, $author$project$Model$PostSSPDataResult, newSSPData)
							])),
					_Utils_update(
						model,
						{
							b9: $elm$core$Maybe$Just(newSSPData)
						}));
			case 17:
				var _v26 = $author$project$Page$GasRelay$init;
				var newSubModel = _v26.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							b2: $author$project$Model$GasRelay(newSubModel)
						}),
					$elm$core$Platform$Cmd$none);
			case 18:
				return _Utils_Tuple2(
					model,
					session.s ? $author$project$PostMessage$sendMessage(
						_Utils_Tuple2(
							$elm$json$Json$Encode$string($author$project$PostMessage$messageOpen),
							model.bz)) : $elm$core$Platform$Cmd$none);
			case 19:
				return _Utils_Tuple2(
					model,
					session.s ? $author$project$PostMessage$sendMessage(
						_Utils_Tuple2(
							$elm$json$Json$Encode$string($author$project$PostMessage$messageClose),
							model.bz)) : $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b8: false}),
					session.s ? $author$project$PostMessage$sendMessage(
						_Utils_Tuple2(
							$elm$json$Json$Encode$string($author$project$PostMessage$messageClose),
							model.bz)) : $elm$core$Platform$Cmd$none);
		}
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$i = _VirtualDom_node('i');
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm_community$html_extra$Html$Events$Extra$onClickPreventDefault = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'click',
		A2(
			$elm$json$Json$Decode$map,
			function (m) {
				return _Utils_Tuple2(m, true);
			},
			$elm$json$Json$Decode$succeed(msg)));
};
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Components$header = F2(
	function (staticAssets, closeMsg_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container visible-expanded')
				]),
			_List_fromArray(
				[
					function () {
					if (!closeMsg_.$) {
						var closeMsg = closeMsg_.a;
						return A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault(closeMsg),
									$elm$html$Html$Attributes$class('octovault-close-button'),
									A2($elm$html$Html$Attributes$attribute, 'test-id', 'octovault-close-button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' Close '),
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fal fa-times')
										]),
									_List_Nil)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('logo'),
											$elm$html$Html$Attributes$src(staticAssets.bZ),
											$elm$html$Html$Attributes$alt('OctoVault')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Page$Create$Back = {$: 2};
var $author$project$Page$Create$CheckForm = {$: 1};
var $author$project$Page$Create$SetName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$busyIndicator = A2(
	$elm$html$Html$i,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('fas fa-spinner fa-pulse busy-indicator')
		]),
	_List_Nil);
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$default = $elm$html$Html$Attributes$boolProperty('default');
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Translations$EnUk$footNote = _List_fromArray(
	[
		A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('IMPORTANT:')
			])),
		A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('OctoVault exists in your browser only, meaning that:')
			])),
		A2(
		$elm$html$Html$ul,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('You can’t access your OctoVault from a different computer.')
					])),
				A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('If you forget your password, the administrator of the system will have to be involved, linking a new OctoVault to your account.')
					])),
				A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('If you clear the browser storage (i.e. clear browser cookies), you will destroy your OctoVault.')
					]))
			]))
	]);
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Translations$EnUk$poweredBy = 'Powered by ';
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Organism$FootNote$footNote = function (staticAssets) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('footer')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('foot-note')
					]),
				$author$project$Translations$EnUk$footNote),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('powered-by-flexidao'),
						$elm$html$Html$Attributes$href('https://www.flexidao.com/'),
						$elm$html$Html$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text($author$project$Translations$EnUk$poweredBy),
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(staticAssets.bL)
							]),
						_List_Nil)
					]))
			]));
};
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Page$Create$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container page-create visible-expanded')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('main')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('intro-text')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Creating a new Private Key.')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Please, enter the details below.')
										]))
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('accounts')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('inputs')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('form-group')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Key Name')
														])),
													A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$type_('text'),
															$elm$html$Html$Attributes$placeholder('Enter Key Name'),
															$elm$html$Html$Attributes$name('keyName'),
															$elm$html$Html$Attributes$value(model.p),
															$elm$html$Html$Events$onInput($author$project$Page$Create$SetName)
														]),
													_List_Nil)
												]))
										])),
									(!session.bB) ? A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('octovault-actions')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault($author$project$Page$Create$Back),
															$elm$html$Html$Attributes$type_('button'),
															$elm$html$Html$Attributes$class('btn btn-secondary'),
															A2($elm$html$Html$Attributes$attribute, 'test-id', 'back')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Back')
														])),
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$type_('submit'),
															$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault($author$project$Page$Create$CheckForm),
															$elm$html$Html$Attributes$default(true),
															$elm$html$Html$Attributes$class('btn btn-primary'),
															A2($elm$html$Html$Attributes$attribute, 'test-id', 'create')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Create')
														]))
												]))
										])) : A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-center')
										]),
									_List_fromArray(
										[$author$project$Components$busyIndicator]))
								]))
						])),
					$author$project$Organism$FootNote$footNote(session.as)
				]));
	});
var $author$project$Page$GasRelay$SendTransaction = {$: 0};
var $author$project$Page$GasRelay$TriggerClose = {$: 4};
var $author$project$Page$GasRelay$errorView = function (pageStatus) {
	switch (pageStatus.$) {
		case 0:
			return $elm$html$Html$text('');
		case 1:
			return $elm$html$Html$text('');
		case 2:
			return $elm$html$Html$text('');
		default:
			var error = pageStatus.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('error-message')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(error)
					]));
	}
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$WebComponent$EthereumBlockies$ethereumBlockies = F4(
	function (size, scale, hqx, seed) {
		return A3(
			$elm$html$Html$node,
			'ethereum-blockies',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$attribute,
					'size',
					$elm$core$String$fromFloat(size)),
					A2(
					$elm$html$Html$Attributes$attribute,
					'scale',
					$elm$core$String$fromFloat(scale)),
					A2($elm$html$Html$Attributes$attribute, 'seed', seed),
					A2(
					$elm$html$Html$Attributes$attribute,
					'hqx',
					function (x) {
						return '[' + (x + ']');
					}(
						A2(
							$elm$core$String$join,
							',',
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Basics$max(1),
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Basics$min(4),
										$elm$core$String$fromInt)),
								hqx))))
				]),
			_List_Nil);
	});
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Utils$innerEllipsis = function (s) {
	var sList = $elm$core$String$toList(s);
	return ($elm$core$List$length(sList) > 13) ? $elm$core$String$fromList(
		function (l) {
			return A2(
				$elm$core$List$append,
				l,
				$elm$core$List$reverse(
					A2(
						$elm$core$List$take,
						7,
						$elm$core$List$reverse(sList))));
		}(
			function (l) {
				return A2(
					$elm$core$List$append,
					l,
					_List_fromArray(
						['.', '.', '.']));
			}(
				A2($elm$core$List$take, 7, sList)))) : s;
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Page$GasRelay$solidityArgToString = function (solidityArgument) {
	switch (solidityArgument.$) {
		case 0:
			var s = solidityArgument.a;
			return s;
		case 1:
			var l = solidityArgument.a;
			return A2($elm$core$String$join, ', ', l);
		case 2:
			var n = solidityArgument.a;
			return $elm$core$String$fromInt(n);
		case 3:
			var l = solidityArgument.a;
			return A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function (a) {
						return $elm$core$String$fromInt(a);
					},
					l));
		case 4:
			var n = solidityArgument.a;
			return $cmditch$elm_bigint$BigInt$toString(n);
		case 5:
			var l = solidityArgument.a;
			return A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function (a) {
						return $cmditch$elm_bigint$BigInt$toString(a);
					},
					l));
		case 6:
			var e = solidityArgument.a;
			return $author$project$EthereumAddress$toString(e);
		case 7:
			var l = solidityArgument.a;
			return A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function (a) {
						return $author$project$EthereumAddress$toString(a);
					},
					l));
		case 8:
			var b = solidityArgument.a;
			if (b) {
				return 'true';
			} else {
				return 'false';
			}
		default:
			var l = solidityArgument.a;
			return A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function (a) {
						if (a) {
							return 'true';
						} else {
							return 'false';
						}
					},
					l));
	}
};
var $author$project$Page$GasRelay$txRowView = F3(
	function (transaction, txStatus, color) {
		var transactionData = function () {
			var _v1 = transaction.u;
			if (_v1.$ === 2) {
				var status = _v1.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('blockNumber'),
								$elm$html$Html$text('\u00A0'),
								$elm$html$Html$text(
								$elm$core$String$fromInt(status.O))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('transactionHash'),
								$elm$html$Html$text('\u00A0'),
								$elm$html$Html$text(status.ag)
							]))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var functionData = function () {
			var _v0 = transaction.T;
			if (!_v0.$) {
				var data = _v0.a;
				var args = A3(
					$elm$core$List$map2,
					F2(
						function (a, b) {
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(a),
										$elm$html$Html$text('\u00A0'),
										$elm$html$Html$text(
										$author$project$Page$GasRelay$solidityArgToString(b))
									]));
						}),
					data.y,
					transaction.y);
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(data.p)
							]))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var executionTarget = transaction.S;
		var executionSource = transaction.R;
		var delegationData = function () {
			var delegationChainStr = A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function (a) {
						return $author$project$EthereumAddress$toString(a);
					},
					transaction.P));
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('delegation')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(delegationChainStr)
						]))
				]);
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('transaction-to-sign')
				]),
			_Utils_ap(
				functionData,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$innerEllipsis(
									$author$project$EthereumAddress$toString(executionTarget)))
							]))
					])));
	});
var $author$project$Page$GasRelay$txView = function (transaction) {
	var _v0 = transaction.u;
	switch (_v0.$) {
		case 2:
			var status = _v0.a;
			var _v1 = function () {
				var _v2 = status.M;
				if (_v2) {
					return _Utils_Tuple2('Successful', 'green');
				} else {
					return _Utils_Tuple2('Failed', 'red');
				}
			}();
			var statusString = _v1.a;
			var color = _v1.b;
			return A3($author$project$Page$GasRelay$txRowView, transaction, statusString, color);
		case 1:
			return A3($author$project$Page$GasRelay$txRowView, transaction, 'Signed', 'orange');
		case 0:
			return A3($author$project$Page$GasRelay$txRowView, transaction, 'Unsigned', 'gray');
		default:
			return A3($author$project$Page$GasRelay$txRowView, transaction, 'Invalid', 'red');
	}
};
var $author$project$Page$GasRelay$view = F2(
	function (session, model) {
		var transactionsList = $elm$core$Dict$values(model.q);
		var pageStatus = model.A;
		var amountOfTransactions = ($elm$core$List$length(transactionsList) === 1) ? 'Do you confirm the following transaction:' : 'Do you confirm the following transactions:';
		var selectedAcction_ = A2(
			$elm$core$Maybe$andThen,
			function (x) {
				return A2($turboMaCk$any_dict$Dict$Any$get, x, session.i);
			},
			session.t);
		if (!selectedAcction_.$) {
			var selectedAccount = selectedAcction_.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container visible-expanded ')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('gas-relay-actions accounts')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(amountOfTransactions),
								$author$project$Page$GasRelay$errorView(model.A),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('transactions')
									]),
								A2(
									$elm$core$List$map,
									function (tx) {
										return $author$project$Page$GasRelay$txView(tx);
									},
									transactionsList)),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('using the following access key?')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('active-account')
											]),
										_List_fromArray(
											[
												A4(
												$author$project$WebComponent$EthereumBlockies$ethereumBlockies,
												8,
												1,
												_List_fromArray(
													[4, 1]),
												$author$project$EthereumAddress$toString(selectedAccount.aF)),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('info')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h3,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(selectedAccount.p)
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('address')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Utils$innerEllipsis(
																	$author$project$EthereumAddress$toString(selectedAccount.aF)))
															]))
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('transaction-actions')
									]),
								function () {
									switch (pageStatus.$) {
										case 0:
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Events$onClick($author$project$Page$GasRelay$SendTransaction),
															$elm$html$Html$Attributes$class('btn btn-primary'),
															A2($elm$html$Html$Attributes$attribute, 'test-id', 'confirm')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Confirm')
														])),
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault($author$project$Page$GasRelay$TriggerClose),
															$elm$html$Html$Attributes$class('orange'),
															$elm$html$Html$Attributes$class('btn btn-secondary'),
															A2($elm$html$Html$Attributes$attribute, 'test-id', 'cancel')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Cancel')
														]))
												]);
										case 1:
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('spinner-border'),
															$elm$html$Html$Attributes$class('transaction-loader')
														]),
													_List_Nil)
												]);
										case 2:
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault($author$project$Page$GasRelay$TriggerClose),
															$elm$html$Html$Attributes$class('orange'),
															$elm$html$Html$Attributes$class('btn btn-secondary')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Exit')
														]))
												]);
										default:
											var error = pageStatus.a;
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault($author$project$Page$GasRelay$TriggerClose),
															$elm$html$Html$Attributes$class('orange'),
															$elm$html$Html$Attributes$class('btn btn-secondary')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Exit')
														]))
												]);
									}
								}())
							])),
						$author$project$Organism$FootNote$footNote(session.as)
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container page-unlock visible-expanded')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('main accounts')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$form,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('No active account selected.')
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('octovault-actions')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault($author$project$Page$GasRelay$TriggerClose),
														$elm$html$Html$Attributes$class('btn btn-secondary')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Cancel')
													]))
											]))
									]))
							])),
						$author$project$Organism$FootNote$footNote(session.as)
					]));
		}
	});
var $author$project$Page$Home$DialogClose = function (a) {
	return {$: 12, a: a};
};
var $author$project$Page$Home$TriggerCreateAccount = {$: 2};
var $author$project$Page$Home$TriggerImportAccount = {$: 1};
var $author$project$Translations$EnUk$buttonCreate = ' Create new key ';
var $author$project$Translations$EnUk$buttonImport = ' Import private key';
var $author$project$Translations$EnUk$empty1 = 'Empty Vault:';
var $author$project$Translations$EnUk$empty2 = 'Select active access key.';
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $author$project$Translations$EnUk$home1 = 'These are the existing keys in your OctoVault. The generated image helps to visually recognize the keys.';
var $author$project$Translations$EnUk$home2 = 'Select any of the following keys in order to activate it or click the name to relabel it.';
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $author$project$Page$Home$PromptForRemoveAccount = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Home$SelectAccount = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Home$StartRenameAccount = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Home$StoreAccountName = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Home$ToggleCollapsed = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Home$TriggerExportPrivateKey = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Home$UpdateAccountName = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm_community$html_extra$Html$Events$Extra$onClickStopPropagation = function (msg) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'click',
		A2(
			$elm$json$Json$Decode$map,
			function (m) {
				return _Utils_Tuple2(m, true);
			},
			$elm$json$Json$Decode$succeed(msg)));
};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$Page$Home$renderAccount = F4(
	function (session, model, expandedAccount, acco) {
		var isSelectedAccount = function (account) {
			return _Utils_eq(
				session.t,
				$elm$core$Maybe$Just(account));
		};
		var isSelected = isSelectedAccount(acco.aF);
		var isCollapsed = !_Utils_eq(
			expandedAccount,
			$elm$core$Maybe$Just(acco.aF));
		return _Utils_Tuple2(
			$author$project$EthereumAddress$toString(acco.aF),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('account', true),
								_Utils_Tuple2('active', isSelected),
								_Utils_Tuple2('inactive', !isSelected),
								_Utils_Tuple2('collapsed', isCollapsed)
							])),
						A2(
						$elm$html$Html$Attributes$attribute,
						'test-id',
						'account-' + (isSelected ? 'active' : 'inactive'))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('active-area'),
								$elm$html$Html$Events$onClick(
								$author$project$Page$Home$SelectAccount(acco.aF))
							]),
						_List_fromArray(
							[
								((!session.bB) || (!isSelected)) ? A4(
								$author$project$WebComponent$EthereumBlockies$ethereumBlockies,
								8,
								1,
								_List_fromArray(
									[4, 1]),
								$author$project$EthereumAddress$toString(acco.aF)) : $author$project$Components$busyIndicator,
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('info')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h3,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(acco.p)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('address')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$innerEllipsis(
													$author$project$EthereumAddress$toString(acco.aF)))
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('actions-toggler'),
								$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
								$author$project$Page$Home$ToggleCollapsed(acco.aF))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('far fa-ellipsis-v'),
												A2(
												$elm$html$Html$Attributes$attribute,
												'test-id',
												'account-actions-' + (isSelected ? 'active' : 'inactive'))
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('actions')
							]),
						_List_fromArray(
							[
								function () {
								var _v0 = model.L;
								if (!_v0.$) {
									var renamingAccount = _v0.a;
									return A2(
										$elm$html$Html$form,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('actions--rename'),
												$elm$html$Html$Events$onSubmit(
												$author$project$Page$Home$StoreAccountName(renamingAccount))
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('text'),
														$elm$html$Html$Attributes$value(renamingAccount.p),
														$elm$html$Html$Events$onInput(
														$author$project$Page$Home$UpdateAccountName(renamingAccount))
													]),
												_List_Nil),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('submit'),
														$elm$html$Html$Events$onClick(
														$author$project$Page$Home$StoreAccountName(renamingAccount))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Ok')
													]))
											]));
								} else {
									return A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
												$author$project$Page$Home$StartRenameAccount(acco))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Rename')
											]));
								}
							}(),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
										$author$project$Page$Home$PromptForRemoveAccount(acco.aF))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Remove')
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
										$author$project$Page$Home$TriggerExportPrivateKey(acco.aF)),
										A2(
										$elm$html$Html$Attributes$attribute,
										'test-id',
										'export-' + (isSelected ? 'active' : 'inactive'))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Export')
									]))
							]))
					])));
	});
var $author$project$Page$Home$renderBlankAccount = _Utils_Tuple2(
	'no-address',
	A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('account placeholder')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('active-area')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('img-box')
							]),
						_List_Nil),
						$elm$html$Html$text('There are no access keys yet.')
					]))
			])));
var $author$project$Dialog$isJust = function (m) {
	if (!m.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Dialog$backdrop = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'modal-backdrop show',
						$author$project$Dialog$isJust(config))
					]))
			]),
		_List_Nil);
};
var $author$project$Dialog$empty = $elm$html$Html$text('');
var $author$project$Dialog$maybe = F3(
	function (_default, f, value) {
		if (!value.$) {
			var value_ = value.a;
			return f(value_);
		} else {
			return _default;
		}
	});
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Dialog$wrapBody = function (body) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-body')
			]),
		_List_fromArray(
			[body]));
};
var $author$project$Dialog$wrapFooter = function (footer) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-footer')
			]),
		footer);
};
var $author$project$Dialog$closeButton = function (closeMessage) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('close'),
				$elm$html$Html$Events$onClick(closeMessage)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('x')
			]));
};
var $author$project$Dialog$wrapHeader = F2(
	function (closeMessage, header) {
		return (_Utils_eq(closeMessage, $elm$core$Maybe$Nothing) && _Utils_eq(header, $elm$core$Maybe$Nothing)) ? $author$project$Dialog$empty : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-header')
				]),
			_List_fromArray(
				[
					A2($elm$core$Maybe$withDefault, $author$project$Dialog$empty, header),
					A3($author$project$Dialog$maybe, $author$project$Dialog$empty, $author$project$Dialog$closeButton, closeMessage)
				]));
	});
var $author$project$Dialog$view = function (maybeConfig) {
	var displayed = $author$project$Dialog$isJust(maybeConfig);
	return A2(
		$elm$html$Html$div,
		function () {
			var _v0 = A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.aB;
				},
				maybeConfig);
			if (_v0.$ === 1) {
				return _List_Nil;
			} else {
				var containerClass = _v0.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class(containerClass)
					]);
			}
		}(),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2('show', displayed)
							])),
						A2(
						$elm$html$Html$Attributes$style,
						'display',
						displayed ? 'block' : 'none')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-dialog')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-content')
									]),
								function () {
									if (maybeConfig.$ === 1) {
										return _List_fromArray(
											[$author$project$Dialog$empty]);
									} else {
										var config = maybeConfig.a;
										return _List_fromArray(
											[
												A2($author$project$Dialog$wrapHeader, config.az, config.aD),
												A3($author$project$Dialog$maybe, $author$project$Dialog$empty, $author$project$Dialog$wrapBody, config.ay),
												$author$project$Dialog$wrapFooter(config.aC)
											]);
									}
								}())
							]))
					])),
				$author$project$Dialog$backdrop(maybeConfig)
			]));
};
var $author$project$Page$Home$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page-home visible-expanded')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('main')
						]),
					_List_fromArray(
						[
							$turboMaCk$any_dict$Dict$Any$isEmpty(session.i) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('intro-text')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text($author$project$Translations$EnUk$empty1)
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text($author$project$Translations$EnUk$empty2)
										]))
								])) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('intro-text')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text($author$project$Translations$EnUk$home1)
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text($author$project$Translations$EnUk$home2)
										]))
								])),
							A3(
							$elm$html$Html$Keyed$node,
							'div',
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('accounts')
								]),
							_Utils_ap(
								function (l) {
									return $elm$core$List$isEmpty(l) ? _List_fromArray(
										[$author$project$Page$Home$renderBlankAccount]) : l;
								}(
									A2(
										$elm$core$List$map,
										A3($author$project$Page$Home$renderAccount, session, model, model.an),
										$turboMaCk$any_dict$Dict$Any$values(session.i))),
								_List_fromArray(
									[
										_Utils_Tuple2(
										'octovault-actions',
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('octovault-actions')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault($author$project$Page$Home$TriggerImportAccount),
															$elm$html$Html$Attributes$class('btn btn-grey'),
															A2($elm$html$Html$Attributes$attribute, 'test-id', 'import-account')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text($author$project$Translations$EnUk$buttonImport)
														])),
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault($author$project$Page$Home$TriggerCreateAccount),
															$elm$html$Html$Attributes$class('btn btn-primary'),
															A2($elm$html$Html$Attributes$attribute, 'test-id', 'create-account')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text($author$project$Translations$EnUk$buttonCreate)
														]))
												])))
									])))
						])),
					$author$project$Organism$FootNote$footNote(session.as),
					$author$project$Dialog$view(
					function () {
						var _v0 = model.bH;
						if (!_v0.$) {
							var _v1 = _v0.a;
							var action = _v1.a;
							var title = _v1.b;
							var message = _v1.c;
							return $elm$core$Maybe$Just(
								{
									ay: $elm$core$Maybe$Just(
										A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$attribute, 'test-id', 'modal-message')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(message)
												]))),
									az: $elm$core$Maybe$Just(
										$author$project$Page$Home$DialogClose($elm$core$Maybe$Nothing)),
									aB: $elm$core$Maybe$Just('octovault-modal'),
									aC: _List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn btn-default'),
													$elm$html$Html$Events$onClick(
													$author$project$Page$Home$DialogClose($elm$core$Maybe$Nothing))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Abort')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn btn-success'),
													$elm$html$Html$Events$onClick(
													$author$project$Page$Home$DialogClose(action))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Proceed')
												]))
										]),
									aD: $elm$core$Maybe$Just(
										A2(
											$elm$html$Html$h5,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('modal-title')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(title)
												])))
								});
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}())
				]));
	});
var $author$project$Page$Import$Back = {$: 3};
var $author$project$Page$Import$CheckForm = {$: 2};
var $author$project$Page$Import$SetName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Import$SetPrivateKey = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Import$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container page-import visible-expanded')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('main')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$form,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('intro-text')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Importing your existing Private Key.')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Please, enter the details below.')
												]))
										])),
									A2(
									$elm$html$Html$form,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('accounts')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('inputs')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('form-group')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Key Name')
																])),
															A2(
															$elm$html$Html$input,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$type_('text'),
																	$elm$html$Html$Attributes$placeholder('Enter Key Name'),
																	$elm$html$Html$Attributes$name('keyName'),
																	$elm$html$Html$Attributes$value(model.p),
																	$elm$html$Html$Events$onInput($author$project$Page$Import$SetName)
																]),
															_List_Nil)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('form-group')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Private Key')
																])),
															A2(
															$elm$html$Html$input,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$type_('text'),
																	$elm$html$Html$Attributes$placeholder('Enter Private Key'),
																	$elm$html$Html$Attributes$name('privateKey'),
																	$elm$html$Html$Attributes$value(model.be),
																	$elm$html$Html$Events$onInput($author$project$Page$Import$SetPrivateKey)
																]),
															_List_Nil)
														]))
												])),
											(!session.bB) ? A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('octovault-actions')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault($author$project$Page$Import$Back),
																	$elm$html$Html$Attributes$type_('button'),
																	$elm$html$Html$Attributes$class('btn btn-secondary'),
																	A2($elm$html$Html$Attributes$attribute, 'test-id', 'back')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Back')
																])),
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$type_('submit'),
																	$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault($author$project$Page$Import$CheckForm),
																	$elm$html$Html$Attributes$default(true),
																	$elm$html$Html$Attributes$class('btn btn-primary'),
																	A2($elm$html$Html$Attributes$attribute, 'test-id', 'import-key')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Import Private Key')
																]))
														]))
												])) : A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-center')
												]),
											_List_fromArray(
												[$author$project$Components$busyIndicator]))
										]))
								]))
						])),
					$author$project$Organism$FootNote$footNote(session.as)
				]));
	});
var $author$project$Page$Initialize$CheckForm = {$: 2};
var $author$project$Page$Initialize$SetPassword = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Initialize$SetPassword2 = function (a) {
	return {$: 1, a: a};
};
var $author$project$Translations$EnUk$initialPromptForPassword = 'Since no OctoVault has been found in your browser, please provide a new password to create a new Octovault.';
var $author$project$Translations$EnUk$passwordFormOk = 'Create an OctoVault';
var $author$project$Page$Initialize$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container page-initialize visible-expanded')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('main')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('intro-text')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text($author$project$Translations$EnUk$initialPromptForPassword)
										]))
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('initialize-form')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('inputs')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('form-group')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('New password')
														])),
													A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$type_('password'),
															$elm$html$Html$Attributes$name('password'),
															$elm$html$Html$Attributes$class('form-control'),
															$elm$html$Html$Attributes$placeholder('Enter Password'),
															$elm$html$Html$Attributes$value(model.f),
															$elm$html$Html$Events$onInput($author$project$Page$Initialize$SetPassword)
														]),
													_List_Nil)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('form-group')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Repeat password')
														])),
													A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$type_('password'),
															$elm$html$Html$Attributes$name('password2'),
															$elm$html$Html$Attributes$class('form-control'),
															$elm$html$Html$Attributes$placeholder('Re Enter Password'),
															$elm$html$Html$Attributes$value(model.aa),
															$elm$html$Html$Events$onInput($author$project$Page$Initialize$SetPassword2)
														]),
													_List_Nil)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('octovault-actions')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('submit'),
													A2($elm$html$Html$Attributes$attribute, 'test-id', 'create-octovault'),
													$elm$html$Html$Attributes$class('btn btn-primary'),
													$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault($author$project$Page$Initialize$CheckForm)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text($author$project$Translations$EnUk$passwordFormOk)
												]))
										]))
								]))
						])),
					$author$project$Organism$FootNote$footNote(session.as)
				]));
	});
var $author$project$Page$Sign$Abort = 1;
var $author$project$Page$Sign$Proceed = 0;
var $author$project$Page$Sign$view = F2(
	function (session, model) {
		var selectedAcction_ = A2(
			$elm$core$Maybe$andThen,
			function (x) {
				return A2($turboMaCk$any_dict$Dict$Any$get, x, session.i);
			},
			session.t);
		if (!selectedAcction_.$) {
			var selectedAccount = selectedAcction_.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container page-unlock visible-expanded')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('main accounts')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$form,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Do you want to sign this message:')
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('message-to-sign')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(model.aq)
													]))
											])),
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('using the following access key?')
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('active-account')
													]),
												_List_fromArray(
													[
														A4(
														$author$project$WebComponent$EthereumBlockies$ethereumBlockies,
														8,
														1,
														_List_fromArray(
															[4, 1]),
														$author$project$EthereumAddress$toString(selectedAccount.aF)),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('info')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$h3,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(selectedAccount.p)
																	])),
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('address')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Utils$innerEllipsis(
																			$author$project$EthereumAddress$toString(selectedAccount.aF)))
																	]))
															]))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('octovault-actions')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault(1),
														$elm$html$Html$Attributes$class('btn btn-secondary'),
														A2($elm$html$Html$Attributes$attribute, 'test-id', 'cancel')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Cancel')
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault(0),
														$elm$html$Html$Attributes$class('btn btn-primary'),
														A2($elm$html$Html$Attributes$attribute, 'test-id', 'confirm')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Confirm')
													]))
											]))
									]))
							])),
						$author$project$Organism$FootNote$footNote(session.as)
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container page-unlock visible-expanded')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('main accounts')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$form,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('No active account selected.')
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('octovault-actions')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault(1),
														$elm$html$Html$Attributes$class('btn btn-secondary')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Cancel')
													]))
											]))
									]))
							])),
						$author$project$Organism$FootNote$footNote(session.as)
					]));
		}
	});
var $author$project$Page$Unlock$CheckPassword = {$: 1};
var $author$project$Page$Unlock$SetPassword = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Unlock$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container page-unlock visible-expanded')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('main')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$form,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('intro-text')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Please, unlock this browser\'s private vault.')
												]))
										])),
									A2(
									$elm$html$Html$form,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('accounts')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('inputs')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('form-group')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Password')
																])),
															A2(
															$elm$html$Html$input,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$type_('password'),
																	$elm$html$Html$Attributes$placeholder('Password'),
																	$elm$html$Html$Attributes$value(model.f),
																	$elm$html$Html$Events$onInput($author$project$Page$Unlock$SetPassword)
																]),
															_List_Nil)
														]))
												])),
											(!session.bB) ? A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('octovault-actions')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$type_('submit'),
																	$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault($author$project$Page$Unlock$CheckPassword),
																	$elm$html$Html$Attributes$default(true),
																	$elm$html$Html$Attributes$class('btn btn-primary')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Unlock')
																]))
														]))
												])) : A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-center')
												]),
											_List_fromArray(
												[$author$project$Components$busyIndicator]))
										]))
								]))
						])),
					$author$project$Organism$FootNote$footNote(session.as)
				]));
	});
var $author$project$OctoVault$renderPage = function (model) {
	var session = model.b7;
	var _v0 = model.b2;
	switch (_v0.$) {
		case 0:
			var subModel = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Model$FromUnlock,
				A2($author$project$Page$Unlock$view, session, subModel));
		case 1:
			var subModel = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Model$FromImport,
				A2($author$project$Page$Import$view, session, subModel));
		case 2:
			var subModel = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Model$FromCreate,
				A2($author$project$Page$Create$view, session, subModel));
		case 3:
			var subModel = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Model$FromHome,
				A2($author$project$Page$Home$view, session, subModel));
		case 4:
			var subModel = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Model$FromInitialize,
				A2($author$project$Page$Initialize$view, session, subModel));
		case 5:
			var subModel = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Model$FromGasRelay,
				A2($author$project$Page$GasRelay$view, session, subModel));
		default:
			var subModel = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Model$FromSign,
				A2($author$project$Page$Sign$view, session, subModel));
	}
};
var $author$project$Model$Open = {$: 18};
var $author$project$Translations$EnUk$blankPlaceholder = 'Create an OctoVault…';
var $author$project$Translations$EnUk$creatingKeyPlaceholder = 'Creating key...';
var $author$project$Translations$EnUk$gasRelayPlacehodler = 'Gas relay...';
var $author$project$Translations$EnUk$importingPlaceholder = 'Importing key…';
var $author$project$Translations$EnUk$lockedPlaceholder = 'OctoVault locked';
var $author$project$Translations$EnUk$signingPlaceholder = 'Signing...';
var $author$project$Organism$OctoButton$view = function (model) {
	var session = model.b7;
	var staticAssets = session.as;
	var page = model.b2;
	var anonymousIconButton = function (iconCharacter) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('octovault-button visible-collapsed flex compact'),
					$elm$html$Html$Events$onClick($author$project$Model$Open),
					A2($elm$html$Html$Attributes$attribute, 'icon-character', iconCharacter),
					A2($elm$html$Html$Attributes$attribute, 'test-id', 'octovault')
				]),
			_List_Nil);
	};
	var anonymousButton = function (label) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('octovault-button visible-collapsed flex'),
					$elm$html$Html$Events$onClick($author$project$Model$Open),
					A2($elm$html$Html$Attributes$attribute, 'test-id', 'octovault')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	};
	var _v0 = function () {
		var _v1 = session.t;
		if (!_v1.$) {
			var accountAddress_ = _v1.a;
			return _Utils_Tuple3(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.p;
						},
						A2($turboMaCk$any_dict$Dict$Any$get, accountAddress_, session.i))),
				$author$project$EthereumAddress$toString(accountAddress_),
				A4(
					$author$project$WebComponent$EthereumBlockies$ethereumBlockies,
					8,
					1,
					_List_fromArray(
						[3, 2]),
					$author$project$EthereumAddress$toString(accountAddress_)));
		} else {
			return _Utils_Tuple3(
				'',
				'',
				$elm$html$Html$text('?'));
		}
	}();
	var accountName = _v0.a;
	var accountAddress = _v0.b;
	var blockies = _v0.c;
	var standardButton = F2(
		function (class_, state) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('octovault-button visible-collapsed flex'),
						$elm$html$Html$Attributes$class(class_),
						$elm$html$Html$Events$onClick($author$project$Model$Open),
						A2($elm$html$Html$Attributes$attribute, 'test-id', 'octovault')
					]),
				_List_fromArray(
					[
						blockies,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('octovault-button-text')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('octovault-button-name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(accountName)
									])),
								function () {
								if (!state.$) {
									var state_ = state.a;
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('octovault-button-state')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(state_)
											]));
								} else {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('octovault-button-address')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$innerEllipsis(accountAddress))
											]));
								}
							}()
							]))
					]));
		});
	if (model.bG) {
		switch (page.$) {
			case 4:
				var subModel = page.a;
				return anonymousIconButton('\uF5FF');
			case 0:
				var subModel = page.a;
				return anonymousIconButton('\uF30D');
			case 3:
				var subModel = page.a;
				return A2(standardButton, 'compact-unlocked', $elm$core$Maybe$Nothing);
			case 1:
				var subModel = page.a;
				return A2(
					standardButton,
					'compact-unlocked',
					$elm$core$Maybe$Just($author$project$Translations$EnUk$importingPlaceholder));
			case 2:
				var subModel = page.a;
				return A2(
					standardButton,
					'compact-unlocked',
					$elm$core$Maybe$Just($author$project$Translations$EnUk$creatingKeyPlaceholder));
			case 5:
				var subModel = page.a;
				return A2(
					standardButton,
					'compact-unlocked',
					$elm$core$Maybe$Just($author$project$Translations$EnUk$gasRelayPlacehodler));
			default:
				var subModel = page.a;
				return A2(
					standardButton,
					'compact-unlocked',
					$elm$core$Maybe$Just($author$project$Translations$EnUk$signingPlaceholder));
		}
	} else {
		switch (page.$) {
			case 4:
				var subModel = page.a;
				return anonymousButton($author$project$Translations$EnUk$blankPlaceholder);
			case 0:
				var subModel = page.a;
				return anonymousButton($author$project$Translations$EnUk$lockedPlaceholder);
			case 3:
				var subModel = page.a;
				return A2(standardButton, '', $elm$core$Maybe$Nothing);
			case 1:
				var subModel = page.a;
				return A2(
					standardButton,
					'',
					$elm$core$Maybe$Just($author$project$Translations$EnUk$importingPlaceholder));
			case 2:
				var subModel = page.a;
				return A2(
					standardButton,
					'',
					$elm$core$Maybe$Just($author$project$Translations$EnUk$creatingKeyPlaceholder));
			case 5:
				var subModel = page.a;
				return A2(
					standardButton,
					'',
					$elm$core$Maybe$Just($author$project$Translations$EnUk$gasRelayPlacehodler));
			default:
				var subModel = page.a;
				return A2(
					standardButton,
					'',
					$elm$core$Maybe$Just($author$project$Translations$EnUk$signingPlaceholder));
		}
	}
};
var $author$project$OctoVault$view = function (model) {
	return {
		ay: _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('octovault-is-open', model.b7.J),
								_Utils_Tuple2('octovault-is-closed', !model.b7.J),
								_Utils_Tuple2('octovault-is-embedded', model.b7.s),
								_Utils_Tuple2('octovault-is-full-page', !model.b7.s)
							])),
						$elm$html$Html$Attributes$class('shake-it'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'test-id',
						model.b7.J ? 'octovault-is-open' : 'octovault-is-closed')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$header,
						model.b7.as,
						model.b7.s ? $elm$core$Maybe$Just($author$project$Model$Close) : $elm$core$Maybe$Nothing),
						$author$project$OctoVault$renderPage(model),
						$author$project$Organism$OctoButton$view(model)
					]))
			]),
		cf: 'OctoVault'
	};
};
var $author$project$OctoVault$main = $elm$browser$Browser$application(
	{bQ: $author$project$OctoVault$init, b_: $author$project$Model$UrlChange, b$: $author$project$Model$UrlRequest, cd: $author$project$OctoVault$subscriptions, ch: $author$project$OctoVault$update, ci: $author$project$OctoVault$view});
_Platform_export({'OctoVault':{'init':$author$project$OctoVault$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (storage) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (staticAssets) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (compactButtonLayout) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (allowedOrigin) {
									return $elm$json$Json$Decode$succeed(
										{bz: allowedOrigin, bG: compactButtonLayout, as: staticAssets, aX: storage});
								},
								A2(
									$elm$json$Json$Decode$field,
									'allowedOrigin',
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
											]))));
						},
						A2($elm$json$Json$Decode$field, 'compactButtonLayout', $elm$json$Json$Decode$bool));
				},
				A2(
					$elm$json$Json$Decode$field,
					'staticAssets',
					A2(
						$elm$json$Json$Decode$andThen,
						function (octoVault) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (flexidao) {
									return $elm$json$Json$Decode$succeed(
										{bL: flexidao, bZ: octoVault});
								},
								A2($elm$json$Json$Decode$field, 'flexidao', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'octoVault', $elm$json$Json$Decode$string))));
		},
		A2(
			$elm$json$Json$Decode$field,
			'storage',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
					])))))(0)}});}(this));